/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AuthLoginRouteRouteImport } from './routes/auth/login/route'
import { Route as AppToolsRouteRouteImport } from './routes/app/tools/route'
import { Route as AppProductsRouteRouteImport } from './routes/app/products/route'
import { Route as AppFaqRouteRouteImport } from './routes/app/faq/route'
import { Route as AppExternalLinksRouteRouteImport } from './routes/app/external-links/route'
import { Route as AppEnterprisesRouteRouteImport } from './routes/app/enterprises/route'
import { Route as AppDashboardRouteRouteImport } from './routes/app/dashboard/route'
import { Route as AppBusinessesRmaRouteRouteImport } from './routes/app/businesses-rma/route'
import { Route as AppToolsIndexRouteImport } from './routes/app/tools/index'
import { Route as AppToolsVvaRouteRouteImport } from './routes/app/tools/vva/route'
import { Route as AppToolsSchedulerRouteRouteImport } from './routes/app/tools/scheduler/route'
import { Route as AppToolsRepresentativesTurnoverRouteRouteImport } from './routes/app/tools/representatives-turnover/route'
import { Route as AppToolsRepresentativesMapRouteRouteImport } from './routes/app/tools/representatives-map/route'
import { Route as AppToolsProductShelvesRouteRouteImport } from './routes/app/tools/product-shelves/route'
import { Route as AppToolsProductInventoryRouteRouteImport } from './routes/app/tools/product-inventory/route'
import { Route as AppToolsProductFiltersRouteRouteImport } from './routes/app/tools/product-filters/route'
import { Route as AppToolsPredefinedTextsRouteRouteImport } from './routes/app/tools/predefined-texts/route'
import { Route as AppToolsPredefinedMessagesRouteRouteImport } from './routes/app/tools/predefined-messages/route'
import { Route as AppToolsNewsRouteRouteImport } from './routes/app/tools/news/route'
import { Route as AppToolsMenuRouteRouteImport } from './routes/app/tools/menu/route'
import { Route as AppToolsMailsRouteRouteImport } from './routes/app/tools/mails/route'
import { Route as AppToolsGlobalTurnoverRouteRouteImport } from './routes/app/tools/global-turnover/route'
import { Route as AppToolsFormationsRouteRouteImport } from './routes/app/tools/formations/route'
import { Route as AppToolsExternalLinksRouteRouteImport } from './routes/app/tools/external-links/route'
import { Route as AppToolsEmailsRouteRouteImport } from './routes/app/tools/emails/route'
import { Route as AppToolsDepartmentsRouteRouteImport } from './routes/app/tools/departments/route'
import { Route as AppToolsDdnsRouteRouteImport } from './routes/app/tools/ddns/route'
import { Route as AppToolsCreditRouteRouteImport } from './routes/app/tools/credit/route'
import { Route as AppProductsProductIdRouteRouteImport } from './routes/app/products_.$productId/route'
import { Route as AppProductsSerialNumbersRouteRouteImport } from './routes/app/products/serial-numbers/route'
import { Route as AppProductsCreateRouteRouteImport } from './routes/app/products/create/route'
import { Route as AppFaqCreateRouteRouteImport } from './routes/app/faq/create/route'
import { Route as AppExternalLinksExternalLinkIdRouteRouteImport } from './routes/app/external-links_.$externalLinkId/route'
import { Route as AppEnterprisesEnterpriseIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/route'
import { Route as AppEnterprisesCreateRouteRouteImport } from './routes/app/enterprises/create/route'
import { Route as AppDashboardDeleteCollectiveTasksRouteRouteImport } from './routes/app/dashboard/delete-collective-tasks/route'
import { Route as AppDashboardCreateProgressiveInfoRouteRouteImport } from './routes/app/dashboard/create-progressive-info/route'
import { Route as AppDashboardCreatePersonalTaskRouteRouteImport } from './routes/app/dashboard/create-personal-task/route'
import { Route as AppDashboardCreateCollectiveTaskRouteRouteImport } from './routes/app/dashboard/create-collective-task/route'
import { Route as AppBusinessesRmaSearchByProductsRouteRouteImport } from './routes/app/businesses-rma/search-by-products/route'
import { Route as AppBusinessesRmaRepresentativeTurnoverRouteRouteImport } from './routes/app/businesses-rma/representative-turnover/route'
import { Route as AppProductsProductIdIndexRouteImport } from './routes/app/products_.$productId/index'
import { Route as AppToolsVvaCreateRouteRouteImport } from './routes/app/tools/vva/create/route'
import { Route as AppToolsSchedulerCreateRouteRouteImport } from './routes/app/tools/scheduler/create/route'
import { Route as AppToolsProductShelvesCreateRouteRouteImport } from './routes/app/tools/product-shelves/create/route'
import { Route as AppToolsProductInventoryValidateQuantitiesRouteRouteImport } from './routes/app/tools/product-inventory/validate-quantities/route'
import { Route as AppToolsProductFiltersCreateRouteRouteImport } from './routes/app/tools/product-filters/create/route'
import { Route as AppToolsPredefinedTextsCreateRouteRouteImport } from './routes/app/tools/predefined-texts/create/route'
import { Route as AppToolsPredefinedMessagesCreateRouteRouteImport } from './routes/app/tools/predefined-messages/create/route'
import { Route as AppToolsNewsCreateRouteRouteImport } from './routes/app/tools/news/create/route'
import { Route as AppToolsMenuCreateProductRouteRouteImport } from './routes/app/tools/menu/create-product/route'
import { Route as AppToolsMenuCreateEnterpriseRouteRouteImport } from './routes/app/tools/menu/create-enterprise/route'
import { Route as AppToolsMailsCreateRouteRouteImport } from './routes/app/tools/mails/create/route'
import { Route as AppToolsFormationsCreateRouteRouteImport } from './routes/app/tools/formations/create/route'
import { Route as AppToolsExternalLinksCreateRouteRouteImport } from './routes/app/tools/external-links/create/route'
import { Route as AppToolsEmailsEmailIdRouteRouteImport } from './routes/app/tools/emails/$emailId/route'
import { Route as AppToolsDepartmentsCreateRouteRouteImport } from './routes/app/tools/departments/create/route'
import { Route as AppToolsDdnsCreateRouteRouteImport } from './routes/app/tools/ddns/create/route'
import { Route as AppToolsCreditShowRouteRouteImport } from './routes/app/tools/credit/show/route'
import { Route as AppToolsCreditDetailsRouteRouteImport } from './routes/app/tools/credit/details/route'
import { Route as AppProductsProductIdManageRouteRouteImport } from './routes/app/products_.$productId/manage/route'
import { Route as AppProductsProductIdInformationsRouteRouteImport } from './routes/app/products_.$productId/informations/route'
import { Route as AppProductsSerialNumbersCreateRouteRouteImport } from './routes/app/products/serial-numbers/create/route'
import { Route as AppFaqUpdateFaqIdRouteRouteImport } from './routes/app/faq/update.$faqId/route'
import { Route as AppFaqSendByEmailFaqIdRouteRouteImport } from './routes/app/faq/send-by-email.$faqId/route'
import { Route as AppFaqGedFaqIdRouteRouteImport } from './routes/app/faq/ged.$faqId/route'
import { Route as AppFaqDeleteFaqIdRouteRouteImport } from './routes/app/faq/delete.$faqId/route'
import { Route as AppFaqArchiveFaqIdRouteRouteImport } from './routes/app/faq/archive.$faqId/route'
import { Route as AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/update-representative/route'
import { Route as AppEnterprisesEnterpriseIdUpdateCategoryRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/update-category/route'
import { Route as AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/update-accountability/route'
import { Route as AppEnterprisesEnterpriseIdUpdateRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/update/route'
import { Route as AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/relate-business-rma/route'
import { Route as AppEnterprisesEnterpriseIdImportGedFilesRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/import-ged-files/route'
import { Route as AppEnterprisesEnterpriseIdImportContactsRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/import-contacts/route'
import { Route as AppEnterprisesEnterpriseIdEmailHistoryRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/email-history/route'
import { Route as AppEnterprisesEnterpriseIdDeleteRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/delete/route'
import { Route as AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/create-lifesheet-comment/route'
import { Route as AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/create-ged-directory/route'
import { Route as AppEnterprisesEnterpriseIdCreateContactRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/create-contact/route'
import { Route as AppEnterprisesEnterpriseIdAddressBookRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/address-book/route'
import { Route as AppEnterprisesUpdateContactContactIdRouteRouteImport } from './routes/app/enterprises/update-contact.$contactId/route'
import { Route as AppEnterprisesUpdateContactPasswordContactIdRouteRouteImport } from './routes/app/enterprises/update-contact-password.$contactId/route'
import { Route as AppEnterprisesSendEmailToContactContactIdRouteRouteImport } from './routes/app/enterprises/send-email-to-contact.$contactId/route'
import { Route as AppEnterprisesDeleteContactContactIdRouteRouteImport } from './routes/app/enterprises/delete-contact.$contactId/route'
import { Route as AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRouteImport } from './routes/app/enterprises/create-enterprise-rma.$enterpriseId/route'
import { Route as AppEnterprisesCreateContactEnterpriseIdRouteRouteImport } from './routes/app/enterprises/create-contact.$enterpriseId/route'
import { Route as AppEnterprisesCreateContactTravelVoucherContactIdRouteRouteImport } from './routes/app/enterprises/create-contact-travel-voucher.$contactId/route'
import { Route as AppEnterprisesCreateContactBusinessContactIdRouteRouteImport } from './routes/app/enterprises/create-contact-business.$contactId/route'
import { Route as AppDashboardValidatePersonalTaskTaskIdRouteRouteImport } from './routes/app/dashboard/validate-personal-task.$taskId/route'
import { Route as AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRouteImport } from './routes/app/dashboard/update-progressive-info.$progressiveInfoId/route'
import { Route as AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRouteImport } from './routes/app/dashboard/update-personal-task-deadline.$taskId/route'
import { Route as AppDashboardUpdateAircallContactContactIdRouteRouteImport } from './routes/app/dashboard/update-aircall-contact.$contactId/route'
import { Route as AppDashboardUnlinkPersonalTaskTaskIdRouteRouteImport } from './routes/app/dashboard/unlink-personal-task.$taskId/route'
import { Route as AppDashboardTransferTaskTaskIdRouteRouteImport } from './routes/app/dashboard/transfer-task.$taskId/route'
import { Route as AppDashboardTaskEmailTaskIdRouteRouteImport } from './routes/app/dashboard/task-email.$taskId/route'
import { Route as AppDashboardTaskCommentsTaskIdRouteRouteImport } from './routes/app/dashboard/task-comments.$taskId/route'
import { Route as AppDashboardTakeCollectiveTaskTaskIdRouteRouteImport } from './routes/app/dashboard/take-collective-task.$taskId/route'
import { Route as AppDashboardSchedulerEventDetailsEventIdRouteRouteImport } from './routes/app/dashboard/scheduler-event-details.$eventId/route'
import { Route as AppDashboardPersonalTaskDetailsTaskIdRouteRouteImport } from './routes/app/dashboard/personal-task-details.$taskId/route'
import { Route as AppDashboardOtherPersonalTasksProfileIdRouteRouteImport } from './routes/app/dashboard/other-personal-tasks.$profileId/route'
import { Route as AppDashboardLinkPersonalTaskTaskIdRouteRouteImport } from './routes/app/dashboard/link-personal-task.$taskId/route'
import { Route as AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRouteImport } from './routes/app/dashboard/delete-progressive-info.$progressiveInfoId/route'
import { Route as AppDashboardDeleteCollectiveTaskTaskIdRouteRouteImport } from './routes/app/dashboard/delete-collective-task.$taskId/route'
import { Route as AppDashboardCreateAircallContactNumberRouteRouteImport } from './routes/app/dashboard/create-aircall-contact.$number/route'
import { Route as AppDashboardArchivePersonalTaskTaskIdRouteRouteImport } from './routes/app/dashboard/archive-personal-task.$taskId/route'
import { Route as AppBusinessesRmaRmaRmaIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/route'
import { Route as AppBusinessesRmaRmaRmaIdIndexRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/index'
import { Route as AppBusinessesRmaBusinessBusinessIdIndexRouteImport } from './routes/app/businesses-rma_/business.$businessId/index'
import { Route as AppToolsVvaDeleteVvaIdRouteRouteImport } from './routes/app/tools/vva/delete.$vvaId/route'
import { Route as AppToolsSchedulerDetailsRdvIdRouteRouteImport } from './routes/app/tools/scheduler/details.$rdvId/route'
import { Route as AppToolsProductShelvesDeleteProductShelfIdRouteRouteImport } from './routes/app/tools/product-shelves/delete.$productShelfId/route'
import { Route as AppToolsProductInventoryUpdateStockIdRouteRouteImport } from './routes/app/tools/product-inventory/update.$stockId/route'
import { Route as AppToolsProductFiltersUpdateProductFilterIdRouteRouteImport } from './routes/app/tools/product-filters/update.$productFilterId/route'
import { Route as AppToolsProductFiltersDeleteProductFilterIdRouteRouteImport } from './routes/app/tools/product-filters/delete.$productFilterId/route'
import { Route as AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRouteImport } from './routes/app/tools/predefined-texts/update.$predefinedTextId/route'
import { Route as AppToolsPredefinedTextsDeletePredefinedTextIdRouteRouteImport } from './routes/app/tools/predefined-texts/delete.$predefinedTextId/route'
import { Route as AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRouteImport } from './routes/app/tools/predefined-messages/update.$predefinedMessageId/route'
import { Route as AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRouteImport } from './routes/app/tools/predefined-messages/delete.$predefinedMessageId/route'
import { Route as AppToolsNewsUpdateNewsIdRouteRouteImport } from './routes/app/tools/news/update.$newsId/route'
import { Route as AppToolsNewsDeleteNewsIdRouteRouteImport } from './routes/app/tools/news/delete.$newsId/route'
import { Route as AppToolsMailsUpdateMailIdRouteRouteImport } from './routes/app/tools/mails/update.$mailId/route'
import { Route as AppToolsMailsShowMailIdRouteRouteImport } from './routes/app/tools/mails/show.$mailId/route'
import { Route as AppToolsMailsDeleteMailIdRouteRouteImport } from './routes/app/tools/mails/delete.$mailId/route'
import { Route as AppToolsFormationsUpdateFormationIdRouteRouteImport } from './routes/app/tools/formations/update.$formationId/route'
import { Route as AppToolsFormationsSubscribersFormationDetailIdRouteRouteImport } from './routes/app/tools/formations/subscribers.$formationDetailId/route'
import { Route as AppToolsFormationsDeleteFormationIdRouteRouteImport } from './routes/app/tools/formations/delete.$formationId/route'
import { Route as AppToolsFormationsCreateDetailsRouteRouteImport } from './routes/app/tools/formations/create/details/route'
import { Route as AppToolsFormationsCreateAddDetailRouteRouteImport } from './routes/app/tools/formations/create/add-detail/route'
import { Route as AppToolsExternalLinksUpdateExternalLinkIdRouteRouteImport } from './routes/app/tools/external-links/update.$externalLinkId/route'
import { Route as AppToolsExternalLinksDeleteExternalLinkIdRouteRouteImport } from './routes/app/tools/external-links/delete.$externalLinkId/route'
import { Route as AppToolsExternalLinksArchiveExternalLinkIdRouteRouteImport } from './routes/app/tools/external-links/archive.$externalLinkId/route'
import { Route as AppToolsEmailsEmailIdResendRouteRouteImport } from './routes/app/tools/emails/$emailId/resend/route'
import { Route as AppToolsEmailsEmailIdReplyRouteRouteImport } from './routes/app/tools/emails/$emailId/reply/route'
import { Route as AppToolsDepartmentsUpdateDepartmentIdRouteRouteImport } from './routes/app/tools/departments/update.$departmentId/route'
import { Route as AppToolsDepartmentsDeleteDepartmentIdRouteRouteImport } from './routes/app/tools/departments/delete.$departmentId/route'
import { Route as AppToolsDdnsDeleteDdnsIdRouteRouteImport } from './routes/app/tools/ddns/delete.$ddnsId/route'
import { Route as AppProductsProductIdManageCreateVersionRouteRouteImport } from './routes/app/products_.$productId/manage/create-version/route'
import { Route as AppProductsProductIdManageCreateStockRouteRouteImport } from './routes/app/products_.$productId/manage/create-stock/route'
import { Route as AppProductsProductIdManageAddSpecificationRouteRouteImport } from './routes/app/products_.$productId/manage/add-specification/route'
import { Route as AppProductsProductIdManageAddNomenclatureDetailRouteRouteImport } from './routes/app/products_.$productId/manage/add-nomenclature-detail/route'
import { Route as AppProductsProductIdManageAddAssociatedProductRouteRouteImport } from './routes/app/products_.$productId/manage/add-associated-product/route'
import { Route as AppProductsProductIdInformationsRenameGedObjectRouteRouteImport } from './routes/app/products_.$productId/informations/rename-ged-object/route'
import { Route as AppProductsProductIdInformationsImportGedFilesRouteRouteImport } from './routes/app/products_.$productId/informations/import-ged-files/route'
import { Route as AppProductsProductIdInformationsDeleteGedObjectRouteRouteImport } from './routes/app/products_.$productId/informations/delete-ged-object/route'
import { Route as AppProductsProductIdInformationsCreateLifesheetCommentRouteRouteImport } from './routes/app/products_.$productId/informations/create-lifesheet-comment/route'
import { Route as AppProductsProductIdInformationsCreateGedDirectoryRouteRouteImport } from './routes/app/products_.$productId/informations/create-ged-directory/route'
import { Route as AppProductsSerialNumbersUpdateSerialNumberIdRouteRouteImport } from './routes/app/products/serial-numbers/update.$serialNumberId/route'
import { Route as AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRouteImport } from './routes/app/products/serial-numbers/remove-from-business.$serialNumberId/route'
import { Route as AppProductsSerialNumbersDeleteSerialNumberIdRouteRouteImport } from './routes/app/products/serial-numbers/delete.$serialNumberId/route'
import { Route as AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRouteImport } from './routes/app/products/serial-numbers/create-rma.$serialNumberId/route'
import { Route as AppFaqGedFaqIdImportFilesRouteRouteImport } from './routes/app/faq/ged.$faqId/import-files/route'
import { Route as AppFaqGedFaqIdCreateDirectoryRouteRouteImport } from './routes/app/faq/ged.$faqId/create-directory/route'
import { Route as AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/update-contact.$contactId/route'
import { Route as AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/update-contact-password.$contactId/route'
import { Route as AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/unrelate-business-rma.$businessRmaId/route'
import { Route as AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/unlink-task.$taskId/route'
import { Route as AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/task-email.$taskId/route'
import { Route as AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/send-email-to-contact.$contactId/route'
import { Route as AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/rename-ged-object.$objectRelativePath/route'
import { Route as AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/lifesheet-email.$lifesheetId/route'
import { Route as AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/delete-ged-object.$objectRelativePath/route'
import { Route as AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/delete-contact.$contactId/route'
import { Route as AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/create-contact-business.$contactId/route'
import { Route as AppEnterprisesEnterpriseIdAddressBookImportRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/address-book/import/route'
import { Route as AppEnterprisesEnterpriseIdAddressBookCreateRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/address-book/create/route'
import { Route as AppDashboardTaskEmailTaskIdResendRouteRouteImport } from './routes/app/dashboard/task-email.$taskId/resend/route'
import { Route as AppDashboardTaskEmailTaskIdReplyRouteRouteImport } from './routes/app/dashboard/task-email.$taskId/reply/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/route'
import { Route as AppBusinessesRmaRmaRmaIdReceptionRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/reception/route'
import { Route as AppBusinessesRmaRmaRmaIdDeliveryRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/delivery/route'
import { Route as AppBusinessesRmaBusinessBusinessIdStudyRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/study/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBlRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bl/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBillRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bill/route'
import { Route as AppBusinessesRmaBusinessBusinessIdArcRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/arc/route'
import { Route as AppBusinessesRmaBusinessBusinessIdStudyIndexRouteImport } from './routes/app/businesses-rma_/business.$businessId_/study/index'
import { Route as AppToolsSchedulerDetailsRdvIdUpdateRouteRouteImport } from './routes/app/tools/scheduler/details.$rdvId/update/route'
import { Route as AppToolsSchedulerDetailsRdvIdDeleteRouteRouteImport } from './routes/app/tools/scheduler/details.$rdvId/delete/route'
import { Route as AppToolsFormationsUpdateFormationIdDetailsRouteRouteImport } from './routes/app/tools/formations/update.$formationId/details/route'
import { Route as AppToolsFormationsUpdateFormationIdAddDetailRouteRouteImport } from './routes/app/tools/formations/update.$formationId/add-detail/route'
import { Route as AppToolsFormationsSubscribersFormationDetailIdCreateRouteRouteImport } from './routes/app/tools/formations/subscribers.$formationDetailId/create/route'
import { Route as AppProductsProductIdManageUpdateVersionVersionIdRouteRouteImport } from './routes/app/products_.$productId/manage/update-version.$versionId/route'
import { Route as AppProductsProductIdManageUpdateStockStockIdRouteRouteImport } from './routes/app/products_.$productId/manage/update-stock.$stockId/route'
import { Route as AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRouteImport } from './routes/app/products_.$productId/manage/update-specification.$specificationId/route'
import { Route as AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRouteImport } from './routes/app/products_.$productId/manage/update-nomenclature-detail.$nomenclatureDetailId/route'
import { Route as AppProductsProductIdManageStockHistoryStockIdRouteRouteImport } from './routes/app/products_.$productId/manage/stock-history.$stockId/route'
import { Route as AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRouteImport } from './routes/app/products_.$productId/manage/remove-associated-product.$associatedProductId/route'
import { Route as AppProductsProductIdManageDeleteVersionVersionIdRouteRouteImport } from './routes/app/products_.$productId/manage/delete-version.$versionId/route'
import { Route as AppProductsProductIdManageDeleteStockStockIdRouteRouteImport } from './routes/app/products_.$productId/manage/delete-stock.$stockId/route'
import { Route as AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRouteImport } from './routes/app/products_.$productId/manage/delete-specification.$specificationId/route'
import { Route as AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRouteImport } from './routes/app/products_.$productId/manage/delete-nomenclature-detail.$nomenclatureDetailId/route'
import { Route as AppProductsProductIdManageAddSpecificationFilterIdRouteRouteImport } from './routes/app/products_.$productId/manage/add-specification/$filterId/route'
import { Route as AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRouteImport } from './routes/app/products_.$productId/informations/unlink-task.$taskId/route'
import { Route as AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteImport } from './routes/app/products_.$productId/informations/task-email.$taskId/route'
import { Route as AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteImport } from './routes/app/products_.$productId/informations/lifesheet-email.$lifesheetId/route'
import { Route as AppFaqGedFaqIdRenameItemRelativePathRouteRouteImport } from './routes/app/faq/ged.$faqId/rename.$itemRelativePath/route'
import { Route as AppFaqGedFaqIdDeleteItemRelativePathRouteRouteImport } from './routes/app/faq/ged.$faqId/delete.$itemRelativePath/route'
import { Route as AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/task-email.$taskId/resend/route'
import { Route as AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/task-email.$taskId/reply/route'
import { Route as AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/lifesheet-email.$lifesheetId/resend/route'
import { Route as AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/lifesheet-email.$lifesheetId/reply/route'
import { Route as AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/email-history/email.$emailId/route'
import { Route as AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/address-book/update.$addressId/route'
import { Route as AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/address-book/delete.$addressId/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/pdf/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/import-ged-files/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/create-link/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/create-lifesheet/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/create-ged-directory/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/create-detail/route'
import { Route as AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/reception/pdf/route'
import { Route as AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/reception/create-detail/route'
import { Route as AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/delivery/travel-voucher/route'
import { Route as AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/delivery/pdf/route'
import { Route as AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/delivery/create-detail/route'
import { Route as AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/study/expert/route'
import { Route as AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/study/automatic/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/update-shipping-price/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/pdf/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/commercial-notice/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/update-responsible/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/update-representative/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/update-billing-address/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/send-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/import-ged-files/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/delete/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/create-link/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/create-lifesheet/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/create-ged-directory/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/travel-voucher/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bl/update/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bl/send-by-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bill/send-by-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bill/credits/route'
import { Route as AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/arc/update-shipping-price/route'
import { Route as AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/arc/pdf/route'
import { Route as AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRouteImport } from './routes/app/tools/formations/subscribers.$formationDetailId/send-email.$subscriptionId/route'
import { Route as AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRouteImport } from './routes/app/tools/formations/subscribers.$formationDetailId/delete.$subscriptionId/route'
import { Route as AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRouteImport } from './routes/app/products_.$productId/informations/task-email.$taskId/resend/route'
import { Route as AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRouteImport } from './routes/app/products_.$productId/informations/task-email.$taskId/reply/route'
import { Route as AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRouteImport } from './routes/app/products_.$productId/informations/lifesheet-email.$lifesheetId/resend/route'
import { Route as AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRouteImport } from './routes/app/products_.$productId/informations/lifesheet-email.$lifesheetId/reply/route'
import { Route as AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/email-history/email.$emailId/resend/route'
import { Route as AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRouteImport } from './routes/app/enterprises_.$enterpriseId/email-history/email.$emailId/reply/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/update-detail.$detailId/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/unlink-task.$taskId/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/task-email.$taskId/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/rename-ged-object.$objectRelativePath/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/pdf/send-by-email/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/lifesheet-email.$lifesheetId/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/delete-link.$associatedId/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/delete-ged-object.$relativePath/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/delete-detail.$detailId/route'
import { Route as AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/reception/update-detail.$detailId/route'
import { Route as AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/reception/pdf/send-by-email/route'
import { Route as AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/reception/delete-detail.$detailId/route'
import { Route as AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/delivery/update-detail.$detailId/route'
import { Route as AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/delivery/pdf/send-by-email/route'
import { Route as AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/delivery/delete-detail.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/pdf/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/import-ged-files/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/edit-subtitle/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/edit-no-billed-time/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/edit-cumulated-time/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/delete/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-link/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-lifesheet/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-ged-directory/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-faq/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/update-subquotation.$subquotationId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/update-detail.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/pdf/send-by-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/delete-subquotation.$subquotationId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/delete-detail.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/create-detail.$subquotationId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/create-associated-detail.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/commercial-notice/send-by-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/unlink-task.$taskId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/task-email.$taskId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/rename-ged-object.$objectRelativePath/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/lifesheet-email.$lifesheetId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/$emailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/delete-link.$associatedId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/delete-ged-object.$objectRelativePath/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/confirm-quotation-import.$otherBusinessId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/create/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/update-detail.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/delete-serial.$serialId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/delete-detail.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/create-serial-rma.$serialId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/create-detail-rma.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bp/add-serial.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bl/update/new/route'
import { Route as AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/bill/credits/send-by-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/arc/update-detail.$detailId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/arc/pdf/send-by-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/arc/delete-detail.$detailId/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/task-email.$taskId/resend/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/task-email.$taskId/reply/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/lifesheet-email.$lifesheetId/resend/route'
import { Route as AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRouteImport } from './routes/app/businesses-rma_/rma.$rmaId/support/lifesheet-email.$lifesheetId/reply/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/rename-ged-object.$objectRelativePath/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/pdf/send-by-email/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/lifesheet-email.$lifesheetId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/delete-link.$associatedId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/delete-ged-object.$objectRelativePath/route'
import { Route as AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/quotation/commercial-notice/send-by-email/predefined-messages/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/task-email.$taskId/resend/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/task-email.$taskId/reply/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/lifesheet-email.$lifesheetId/resend/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/lifesheet-email.$lifesheetId/reply/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/$emailId/resend/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/$emailId/reply/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/update.$addressId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/delete.$addressId/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/lifesheet-email.$lifesheetId/resend/route'
import { Route as AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRouteImport } from './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/lifesheet-email.$lifesheetId/reply/route'

const AuthForgotPasswordRouteLazyRouteImport = createFileRoute(
  '/auth/forgot-password',
)()
const AuthResetPasswordTokenRouteLazyRouteImport = createFileRoute(
  '/auth/reset-password/$token',
)()

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/route.lazy').then((d) => d.Route))
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/app/route.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordRouteLazyRoute =
  AuthForgotPasswordRouteLazyRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/auth/forgot-password/route.lazy').then((d) => d.Route),
  )
const AuthLoginRouteRoute = AuthLoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/login/route.lazy').then((d) => d.Route),
)
const AppToolsRouteRoute = AppToolsRouteRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProductsRouteRoute = AppProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() =>
  import('./routes/app/products/route.lazy').then((d) => d.Route),
)
const AppFaqRouteRoute = AppFaqRouteRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() => import('./routes/app/faq/route.lazy').then((d) => d.Route))
const AppExternalLinksRouteRoute = AppExternalLinksRouteRouteImport.update({
  id: '/external-links',
  path: '/external-links',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() =>
  import('./routes/app/external-links/route.lazy').then((d) => d.Route),
)
const AppEnterprisesRouteRoute = AppEnterprisesRouteRouteImport.update({
  id: '/enterprises',
  path: '/enterprises',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() =>
  import('./routes/app/enterprises/route.lazy').then((d) => d.Route),
)
const AppDashboardRouteRoute = AppDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() =>
  import('./routes/app/dashboard/route.lazy').then((d) => d.Route),
)
const AppBusinessesRmaRouteRoute = AppBusinessesRmaRouteRouteImport.update({
  id: '/businesses-rma',
  path: '/businesses-rma',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() =>
  import('./routes/app/businesses-rma/route.lazy').then((d) => d.Route),
)
const AppToolsIndexRoute = AppToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppToolsRouteRoute,
} as any)
const AuthResetPasswordTokenRouteLazyRoute =
  AuthResetPasswordTokenRouteLazyRouteImport.update({
    id: '/reset-password/$token',
    path: '/reset-password/$token',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/auth/reset-password.$token/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsVvaRouteRoute = AppToolsVvaRouteRouteImport.update({
  id: '/vva',
  path: '/vva',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/vva/route.lazy').then((d) => d.Route),
)
const AppToolsSchedulerRouteRoute = AppToolsSchedulerRouteRouteImport.update({
  id: '/scheduler',
  path: '/scheduler',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/scheduler/route.lazy').then((d) => d.Route),
)
const AppToolsRepresentativesTurnoverRouteRoute =
  AppToolsRepresentativesTurnoverRouteRouteImport.update({
    id: '/representatives-turnover',
    path: '/representatives-turnover',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/representatives-turnover/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsRepresentativesMapRouteRoute =
  AppToolsRepresentativesMapRouteRouteImport.update({
    id: '/representatives-map',
    path: '/representatives-map',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/representatives-map/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsProductShelvesRouteRoute =
  AppToolsProductShelvesRouteRouteImport.update({
    id: '/product-shelves',
    path: '/product-shelves',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/product-shelves/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsProductInventoryRouteRoute =
  AppToolsProductInventoryRouteRouteImport.update({
    id: '/product-inventory',
    path: '/product-inventory',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/product-inventory/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsProductFiltersRouteRoute =
  AppToolsProductFiltersRouteRouteImport.update({
    id: '/product-filters',
    path: '/product-filters',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/product-filters/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsPredefinedTextsRouteRoute =
  AppToolsPredefinedTextsRouteRouteImport.update({
    id: '/predefined-texts',
    path: '/predefined-texts',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/predefined-texts/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsPredefinedMessagesRouteRoute =
  AppToolsPredefinedMessagesRouteRouteImport.update({
    id: '/predefined-messages',
    path: '/predefined-messages',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/predefined-messages/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsNewsRouteRoute = AppToolsNewsRouteRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/news/route.lazy').then((d) => d.Route),
)
const AppToolsMenuRouteRoute = AppToolsMenuRouteRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/menu/route.lazy').then((d) => d.Route),
)
const AppToolsMailsRouteRoute = AppToolsMailsRouteRouteImport.update({
  id: '/mails',
  path: '/mails',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/mails/route.lazy').then((d) => d.Route),
)
const AppToolsGlobalTurnoverRouteRoute =
  AppToolsGlobalTurnoverRouteRouteImport.update({
    id: '/global-turnover',
    path: '/global-turnover',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/global-turnover/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsFormationsRouteRoute = AppToolsFormationsRouteRouteImport.update({
  id: '/formations',
  path: '/formations',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/formations/route.lazy').then((d) => d.Route),
)
const AppToolsExternalLinksRouteRoute =
  AppToolsExternalLinksRouteRouteImport.update({
    id: '/external-links',
    path: '/external-links',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/external-links/route.lazy').then((d) => d.Route),
  )
const AppToolsEmailsRouteRoute = AppToolsEmailsRouteRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/emails/route.lazy').then((d) => d.Route),
)
const AppToolsDepartmentsRouteRoute =
  AppToolsDepartmentsRouteRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AppToolsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/departments/route.lazy').then((d) => d.Route),
  )
const AppToolsDdnsRouteRoute = AppToolsDdnsRouteRouteImport.update({
  id: '/ddns',
  path: '/ddns',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/ddns/route.lazy').then((d) => d.Route),
)
const AppToolsCreditRouteRoute = AppToolsCreditRouteRouteImport.update({
  id: '/credit',
  path: '/credit',
  getParentRoute: () => AppToolsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/credit/route.lazy').then((d) => d.Route),
)
const AppProductsProductIdRouteRoute =
  AppProductsProductIdRouteRouteImport.update({
    id: '/products_/$productId',
    path: '/products/$productId',
    getParentRoute: () => AppRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/products_.$productId/route.lazy').then((d) => d.Route),
  )
const AppProductsSerialNumbersRouteRoute =
  AppProductsSerialNumbersRouteRouteImport.update({
    id: '/serial-numbers',
    path: '/serial-numbers',
    getParentRoute: () => AppProductsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/products/serial-numbers/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppProductsCreateRouteRoute = AppProductsCreateRouteRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppProductsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/products/create/route.lazy').then((d) => d.Route),
)
const AppFaqCreateRouteRoute = AppFaqCreateRouteRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppFaqRouteRoute,
} as any).lazy(() =>
  import('./routes/app/faq/create/route.lazy').then((d) => d.Route),
)
const AppExternalLinksExternalLinkIdRouteRoute =
  AppExternalLinksExternalLinkIdRouteRouteImport.update({
    id: '/external-links_/$externalLinkId',
    path: '/external-links/$externalLinkId',
    getParentRoute: () => AppRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/external-links_.$externalLinkId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppEnterprisesEnterpriseIdRouteRoute =
  AppEnterprisesEnterpriseIdRouteRouteImport.update({
    id: '/enterprises_/$enterpriseId',
    path: '/enterprises/$enterpriseId',
    getParentRoute: () => AppRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/enterprises_.$enterpriseId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppEnterprisesCreateRouteRoute =
  AppEnterprisesCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/enterprises/create/route.lazy').then((d) => d.Route),
  )
const AppDashboardDeleteCollectiveTasksRouteRoute =
  AppDashboardDeleteCollectiveTasksRouteRouteImport.update({
    id: '/delete-collective-tasks',
    path: '/delete-collective-tasks',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/delete-collective-tasks/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardCreateProgressiveInfoRouteRoute =
  AppDashboardCreateProgressiveInfoRouteRouteImport.update({
    id: '/create-progressive-info',
    path: '/create-progressive-info',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/create-progressive-info/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardCreatePersonalTaskRouteRoute =
  AppDashboardCreatePersonalTaskRouteRouteImport.update({
    id: '/create-personal-task',
    path: '/create-personal-task',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/create-personal-task/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardCreateCollectiveTaskRouteRoute =
  AppDashboardCreateCollectiveTaskRouteRouteImport.update({
    id: '/create-collective-task',
    path: '/create-collective-task',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/create-collective-task/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaSearchByProductsRouteRoute =
  AppBusinessesRmaSearchByProductsRouteRouteImport.update({
    id: '/search-by-products',
    path: '/search-by-products',
    getParentRoute: () => AppBusinessesRmaRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/businesses-rma/search-by-products/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaRepresentativeTurnoverRouteRoute =
  AppBusinessesRmaRepresentativeTurnoverRouteRouteImport.update({
    id: '/representative-turnover',
    path: '/representative-turnover',
    getParentRoute: () => AppBusinessesRmaRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma/representative-turnover/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdIndexRoute =
  AppProductsProductIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductsProductIdRouteRoute,
  } as any)
const AppToolsVvaCreateRouteRoute = AppToolsVvaCreateRouteRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppToolsVvaRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/vva/create/route.lazy').then((d) => d.Route),
)
const AppToolsSchedulerCreateRouteRoute =
  AppToolsSchedulerCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsSchedulerRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/scheduler/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsProductShelvesCreateRouteRoute =
  AppToolsProductShelvesCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsProductShelvesRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/product-shelves/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsProductInventoryValidateQuantitiesRouteRoute =
  AppToolsProductInventoryValidateQuantitiesRouteRouteImport.update({
    id: '/validate-quantities',
    path: '/validate-quantities',
    getParentRoute: () => AppToolsProductInventoryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/product-inventory/validate-quantities/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsProductFiltersCreateRouteRoute =
  AppToolsProductFiltersCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsProductFiltersRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/product-filters/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsPredefinedTextsCreateRouteRoute =
  AppToolsPredefinedTextsCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsPredefinedTextsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/predefined-texts/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsPredefinedMessagesCreateRouteRoute =
  AppToolsPredefinedMessagesCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsPredefinedMessagesRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/predefined-messages/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsNewsCreateRouteRoute = AppToolsNewsCreateRouteRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppToolsNewsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/news/create/route.lazy').then((d) => d.Route),
)
const AppToolsMenuCreateProductRouteRoute =
  AppToolsMenuCreateProductRouteRouteImport.update({
    id: '/create-product',
    path: '/create-product',
    getParentRoute: () => AppToolsMenuRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/menu/create-product/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsMenuCreateEnterpriseRouteRoute =
  AppToolsMenuCreateEnterpriseRouteRouteImport.update({
    id: '/create-enterprise',
    path: '/create-enterprise',
    getParentRoute: () => AppToolsMenuRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/menu/create-enterprise/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsMailsCreateRouteRoute =
  AppToolsMailsCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsMailsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/mails/create/route.lazy').then((d) => d.Route),
  )
const AppToolsFormationsCreateRouteRoute =
  AppToolsFormationsCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsFormationsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/formations/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsExternalLinksCreateRouteRoute =
  AppToolsExternalLinksCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsExternalLinksRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/external-links/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsEmailsEmailIdRouteRoute =
  AppToolsEmailsEmailIdRouteRouteImport.update({
    id: '/$emailId',
    path: '/$emailId',
    getParentRoute: () => AppToolsEmailsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/emails/$emailId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsDepartmentsCreateRouteRoute =
  AppToolsDepartmentsCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppToolsDepartmentsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/departments/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsDdnsCreateRouteRoute = AppToolsDdnsCreateRouteRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppToolsDdnsRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/ddns/create/route.lazy').then((d) => d.Route),
)
const AppToolsCreditShowRouteRoute = AppToolsCreditShowRouteRouteImport.update({
  id: '/show',
  path: '/show',
  getParentRoute: () => AppToolsCreditRouteRoute,
} as any).lazy(() =>
  import('./routes/app/tools/credit/show/route.lazy').then((d) => d.Route),
)
const AppToolsCreditDetailsRouteRoute =
  AppToolsCreditDetailsRouteRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AppToolsCreditRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/credit/details/route.lazy').then((d) => d.Route),
  )
const AppProductsProductIdManageRouteRoute =
  AppProductsProductIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => AppProductsProductIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/products_.$productId/manage/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppProductsProductIdInformationsRouteRoute =
  AppProductsProductIdInformationsRouteRouteImport.update({
    id: '/informations',
    path: '/informations',
    getParentRoute: () => AppProductsProductIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/products_.$productId/informations/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppProductsSerialNumbersCreateRouteRoute =
  AppProductsSerialNumbersCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppProductsSerialNumbersRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/products/serial-numbers/create/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppFaqUpdateFaqIdRouteRoute = AppFaqUpdateFaqIdRouteRouteImport.update({
  id: '/update/$faqId',
  path: '/update/$faqId',
  getParentRoute: () => AppFaqRouteRoute,
} as any).lazy(() =>
  import('./routes/app/faq/update.$faqId/route.lazy').then((d) => d.Route),
)
const AppFaqSendByEmailFaqIdRouteRoute =
  AppFaqSendByEmailFaqIdRouteRouteImport.update({
    id: '/send-by-email/$faqId',
    path: '/send-by-email/$faqId',
    getParentRoute: () => AppFaqRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/faq/send-by-email.$faqId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppFaqGedFaqIdRouteRoute = AppFaqGedFaqIdRouteRouteImport.update({
  id: '/ged/$faqId',
  path: '/ged/$faqId',
  getParentRoute: () => AppFaqRouteRoute,
} as any).lazy(() =>
  import('./routes/app/faq/ged.$faqId/route.lazy').then((d) => d.Route),
)
const AppFaqDeleteFaqIdRouteRoute = AppFaqDeleteFaqIdRouteRouteImport.update({
  id: '/delete/$faqId',
  path: '/delete/$faqId',
  getParentRoute: () => AppFaqRouteRoute,
} as any).lazy(() =>
  import('./routes/app/faq/delete.$faqId/route.lazy').then((d) => d.Route),
)
const AppFaqArchiveFaqIdRouteRoute = AppFaqArchiveFaqIdRouteRouteImport.update({
  id: '/archive/$faqId',
  path: '/archive/$faqId',
  getParentRoute: () => AppFaqRouteRoute,
} as any).lazy(() =>
  import('./routes/app/faq/archive.$faqId/route.lazy').then((d) => d.Route),
)
const AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute =
  AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRouteImport.update({
    id: '/update-representative',
    path: '/update-representative',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/update-representative/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute =
  AppEnterprisesEnterpriseIdUpdateCategoryRouteRouteImport.update({
    id: '/update-category',
    path: '/update-category',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/update-category/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute =
  AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRouteImport.update({
    id: '/update-accountability',
    path: '/update-accountability',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/update-accountability/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdUpdateRouteRoute =
  AppEnterprisesEnterpriseIdUpdateRouteRouteImport.update({
    id: '/update',
    path: '/update',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/enterprises_.$enterpriseId/update/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute =
  AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRouteImport.update({
    id: '/relate-business-rma',
    path: '/relate-business-rma',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/relate-business-rma/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdImportGedFilesRouteRoute =
  AppEnterprisesEnterpriseIdImportGedFilesRouteRouteImport.update({
    id: '/import-ged-files',
    path: '/import-ged-files',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/import-ged-files/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdImportContactsRouteRoute =
  AppEnterprisesEnterpriseIdImportContactsRouteRouteImport.update({
    id: '/import-contacts',
    path: '/import-contacts',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/import-contacts/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdEmailHistoryRouteRoute =
  AppEnterprisesEnterpriseIdEmailHistoryRouteRouteImport.update({
    id: '/email-history',
    path: '/email-history',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/email-history/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdDeleteRouteRoute =
  AppEnterprisesEnterpriseIdDeleteRouteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/enterprises_.$enterpriseId/delete/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute =
  AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRouteImport.update({
    id: '/create-lifesheet-comment',
    path: '/create-lifesheet-comment',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/create-lifesheet-comment/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute =
  AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRouteImport.update({
    id: '/create-ged-directory',
    path: '/create-ged-directory',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/create-ged-directory/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdCreateContactRouteRoute =
  AppEnterprisesEnterpriseIdCreateContactRouteRouteImport.update({
    id: '/create-contact',
    path: '/create-contact',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/create-contact/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdAddressBookRouteRoute =
  AppEnterprisesEnterpriseIdAddressBookRouteRouteImport.update({
    id: '/address-book',
    path: '/address-book',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/address-book/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesUpdateContactContactIdRouteRoute =
  AppEnterprisesUpdateContactContactIdRouteRouteImport.update({
    id: '/update-contact/$contactId',
    path: '/update-contact/$contactId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/update-contact.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesUpdateContactPasswordContactIdRouteRoute =
  AppEnterprisesUpdateContactPasswordContactIdRouteRouteImport.update({
    id: '/update-contact-password/$contactId',
    path: '/update-contact-password/$contactId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/update-contact-password.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesSendEmailToContactContactIdRouteRoute =
  AppEnterprisesSendEmailToContactContactIdRouteRouteImport.update({
    id: '/send-email-to-contact/$contactId',
    path: '/send-email-to-contact/$contactId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/send-email-to-contact.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesDeleteContactContactIdRouteRoute =
  AppEnterprisesDeleteContactContactIdRouteRouteImport.update({
    id: '/delete-contact/$contactId',
    path: '/delete-contact/$contactId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/delete-contact.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute =
  AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRouteImport.update({
    id: '/create-enterprise-rma/$enterpriseId',
    path: '/create-enterprise-rma/$enterpriseId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/create-enterprise-rma.$enterpriseId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesCreateContactEnterpriseIdRouteRoute =
  AppEnterprisesCreateContactEnterpriseIdRouteRouteImport.update({
    id: '/create-contact/$enterpriseId',
    path: '/create-contact/$enterpriseId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/create-contact.$enterpriseId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute =
  AppEnterprisesCreateContactTravelVoucherContactIdRouteRouteImport.update({
    id: '/create-contact-travel-voucher/$contactId',
    path: '/create-contact-travel-voucher/$contactId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/create-contact-travel-voucher.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesCreateContactBusinessContactIdRouteRoute =
  AppEnterprisesCreateContactBusinessContactIdRouteRouteImport.update({
    id: '/create-contact-business/$contactId',
    path: '/create-contact-business/$contactId',
    getParentRoute: () => AppEnterprisesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises/create-contact-business.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardValidatePersonalTaskTaskIdRouteRoute =
  AppDashboardValidatePersonalTaskTaskIdRouteRouteImport.update({
    id: '/validate-personal-task/$taskId',
    path: '/validate-personal-task/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/validate-personal-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute =
  AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRouteImport.update({
    id: '/update-progressive-info/$progressiveInfoId',
    path: '/update-progressive-info/$progressiveInfoId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/update-progressive-info.$progressiveInfoId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute =
  AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRouteImport.update({
    id: '/update-personal-task-deadline/$taskId',
    path: '/update-personal-task-deadline/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/update-personal-task-deadline.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardUpdateAircallContactContactIdRouteRoute =
  AppDashboardUpdateAircallContactContactIdRouteRouteImport.update({
    id: '/update-aircall-contact/$contactId',
    path: '/update-aircall-contact/$contactId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/update-aircall-contact.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardUnlinkPersonalTaskTaskIdRouteRoute =
  AppDashboardUnlinkPersonalTaskTaskIdRouteRouteImport.update({
    id: '/unlink-personal-task/$taskId',
    path: '/unlink-personal-task/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/unlink-personal-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardTransferTaskTaskIdRouteRoute =
  AppDashboardTransferTaskTaskIdRouteRouteImport.update({
    id: '/transfer-task/$taskId',
    path: '/transfer-task/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/transfer-task.$taskId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardTaskEmailTaskIdRouteRoute =
  AppDashboardTaskEmailTaskIdRouteRouteImport.update({
    id: '/task-email/$taskId',
    path: '/task-email/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/task-email.$taskId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardTaskCommentsTaskIdRouteRoute =
  AppDashboardTaskCommentsTaskIdRouteRouteImport.update({
    id: '/task-comments/$taskId',
    path: '/task-comments/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/task-comments.$taskId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardTakeCollectiveTaskTaskIdRouteRoute =
  AppDashboardTakeCollectiveTaskTaskIdRouteRouteImport.update({
    id: '/take-collective-task/$taskId',
    path: '/take-collective-task/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/take-collective-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardSchedulerEventDetailsEventIdRouteRoute =
  AppDashboardSchedulerEventDetailsEventIdRouteRouteImport.update({
    id: '/scheduler-event-details/$eventId',
    path: '/scheduler-event-details/$eventId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/scheduler-event-details.$eventId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardPersonalTaskDetailsTaskIdRouteRoute =
  AppDashboardPersonalTaskDetailsTaskIdRouteRouteImport.update({
    id: '/personal-task-details/$taskId',
    path: '/personal-task-details/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/personal-task-details.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardOtherPersonalTasksProfileIdRouteRoute =
  AppDashboardOtherPersonalTasksProfileIdRouteRouteImport.update({
    id: '/other-personal-tasks/$profileId',
    path: '/other-personal-tasks/$profileId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/other-personal-tasks.$profileId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardLinkPersonalTaskTaskIdRouteRoute =
  AppDashboardLinkPersonalTaskTaskIdRouteRouteImport.update({
    id: '/link-personal-task/$taskId',
    path: '/link-personal-task/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/link-personal-task.$taskId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute =
  AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRouteImport.update({
    id: '/delete-progressive-info/$progressiveInfoId',
    path: '/delete-progressive-info/$progressiveInfoId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/delete-progressive-info.$progressiveInfoId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardDeleteCollectiveTaskTaskIdRouteRoute =
  AppDashboardDeleteCollectiveTaskTaskIdRouteRouteImport.update({
    id: '/delete-collective-task/$taskId',
    path: '/delete-collective-task/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/delete-collective-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardCreateAircallContactNumberRouteRoute =
  AppDashboardCreateAircallContactNumberRouteRouteImport.update({
    id: '/create-aircall-contact/$number',
    path: '/create-aircall-contact/$number',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/create-aircall-contact.$number/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardArchivePersonalTaskTaskIdRouteRoute =
  AppDashboardArchivePersonalTaskTaskIdRouteRouteImport.update({
    id: '/archive-personal-task/$taskId',
    path: '/archive-personal-task/$taskId',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/dashboard/archive-personal-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdRouteRoute =
  AppBusinessesRmaRmaRmaIdRouteRouteImport.update({
    id: '/businesses-rma_/rma/$rmaId',
    path: '/businesses-rma/rma/$rmaId',
    getParentRoute: () => AppRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/businesses-rma_/rma.$rmaId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaBusinessBusinessIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdRouteRouteImport.update({
    id: '/businesses-rma_/business/$businessId',
    path: '/businesses-rma/business/$businessId',
    getParentRoute: () => AppRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/businesses-rma_/business.$businessId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaRmaRmaIdIndexRoute =
  AppBusinessesRmaRmaRmaIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdRouteRoute,
  } as any)
const AppBusinessesRmaBusinessBusinessIdIndexRoute =
  AppBusinessesRmaBusinessBusinessIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdRouteRoute,
  } as any)
const AppToolsVvaDeleteVvaIdRouteRoute =
  AppToolsVvaDeleteVvaIdRouteRouteImport.update({
    id: '/delete/$vvaId',
    path: '/delete/$vvaId',
    getParentRoute: () => AppToolsVvaRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/vva/delete.$vvaId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsSchedulerDetailsRdvIdRouteRoute =
  AppToolsSchedulerDetailsRdvIdRouteRouteImport.update({
    id: '/details/$rdvId',
    path: '/details/$rdvId',
    getParentRoute: () => AppToolsSchedulerRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/scheduler/details.$rdvId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsProductShelvesDeleteProductShelfIdRouteRoute =
  AppToolsProductShelvesDeleteProductShelfIdRouteRouteImport.update({
    id: '/delete/$productShelfId',
    path: '/delete/$productShelfId',
    getParentRoute: () => AppToolsProductShelvesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/product-shelves/delete.$productShelfId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsProductInventoryUpdateStockIdRouteRoute =
  AppToolsProductInventoryUpdateStockIdRouteRouteImport.update({
    id: '/update/$stockId',
    path: '/update/$stockId',
    getParentRoute: () => AppToolsProductInventoryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/product-inventory/update.$stockId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsProductFiltersUpdateProductFilterIdRouteRoute =
  AppToolsProductFiltersUpdateProductFilterIdRouteRouteImport.update({
    id: '/update/$productFilterId',
    path: '/update/$productFilterId',
    getParentRoute: () => AppToolsProductFiltersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/product-filters/update.$productFilterId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsProductFiltersDeleteProductFilterIdRouteRoute =
  AppToolsProductFiltersDeleteProductFilterIdRouteRouteImport.update({
    id: '/delete/$productFilterId',
    path: '/delete/$productFilterId',
    getParentRoute: () => AppToolsProductFiltersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/product-filters/delete.$productFilterId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute =
  AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRouteImport.update({
    id: '/update/$predefinedTextId',
    path: '/update/$predefinedTextId',
    getParentRoute: () => AppToolsPredefinedTextsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/predefined-texts/update.$predefinedTextId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute =
  AppToolsPredefinedTextsDeletePredefinedTextIdRouteRouteImport.update({
    id: '/delete/$predefinedTextId',
    path: '/delete/$predefinedTextId',
    getParentRoute: () => AppToolsPredefinedTextsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/predefined-texts/delete.$predefinedTextId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute =
  AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRouteImport.update({
    id: '/update/$predefinedMessageId',
    path: '/update/$predefinedMessageId',
    getParentRoute: () => AppToolsPredefinedMessagesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/predefined-messages/update.$predefinedMessageId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute =
  AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRouteImport.update({
    id: '/delete/$predefinedMessageId',
    path: '/delete/$predefinedMessageId',
    getParentRoute: () => AppToolsPredefinedMessagesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/predefined-messages/delete.$predefinedMessageId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsNewsUpdateNewsIdRouteRoute =
  AppToolsNewsUpdateNewsIdRouteRouteImport.update({
    id: '/update/$newsId',
    path: '/update/$newsId',
    getParentRoute: () => AppToolsNewsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/news/update.$newsId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsNewsDeleteNewsIdRouteRoute =
  AppToolsNewsDeleteNewsIdRouteRouteImport.update({
    id: '/delete/$newsId',
    path: '/delete/$newsId',
    getParentRoute: () => AppToolsNewsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/news/delete.$newsId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsMailsUpdateMailIdRouteRoute =
  AppToolsMailsUpdateMailIdRouteRouteImport.update({
    id: '/update/$mailId',
    path: '/update/$mailId',
    getParentRoute: () => AppToolsMailsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/mails/update.$mailId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsMailsShowMailIdRouteRoute =
  AppToolsMailsShowMailIdRouteRouteImport.update({
    id: '/show/$mailId',
    path: '/show/$mailId',
    getParentRoute: () => AppToolsMailsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/mails/show.$mailId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsMailsDeleteMailIdRouteRoute =
  AppToolsMailsDeleteMailIdRouteRouteImport.update({
    id: '/delete/$mailId',
    path: '/delete/$mailId',
    getParentRoute: () => AppToolsMailsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/mails/delete.$mailId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsFormationsUpdateFormationIdRouteRoute =
  AppToolsFormationsUpdateFormationIdRouteRouteImport.update({
    id: '/update/$formationId',
    path: '/update/$formationId',
    getParentRoute: () => AppToolsFormationsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/formations/update.$formationId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsFormationsSubscribersFormationDetailIdRouteRoute =
  AppToolsFormationsSubscribersFormationDetailIdRouteRouteImport.update({
    id: '/subscribers/$formationDetailId',
    path: '/subscribers/$formationDetailId',
    getParentRoute: () => AppToolsFormationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/formations/subscribers.$formationDetailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsFormationsDeleteFormationIdRouteRoute =
  AppToolsFormationsDeleteFormationIdRouteRouteImport.update({
    id: '/delete/$formationId',
    path: '/delete/$formationId',
    getParentRoute: () => AppToolsFormationsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/formations/delete.$formationId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsFormationsCreateDetailsRouteRoute =
  AppToolsFormationsCreateDetailsRouteRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AppToolsFormationsCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/formations/create/details/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsFormationsCreateAddDetailRouteRoute =
  AppToolsFormationsCreateAddDetailRouteRouteImport.update({
    id: '/add-detail',
    path: '/add-detail',
    getParentRoute: () => AppToolsFormationsCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/formations/create/add-detail/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsExternalLinksUpdateExternalLinkIdRouteRoute =
  AppToolsExternalLinksUpdateExternalLinkIdRouteRouteImport.update({
    id: '/update/$externalLinkId',
    path: '/update/$externalLinkId',
    getParentRoute: () => AppToolsExternalLinksRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/external-links/update.$externalLinkId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsExternalLinksDeleteExternalLinkIdRouteRoute =
  AppToolsExternalLinksDeleteExternalLinkIdRouteRouteImport.update({
    id: '/delete/$externalLinkId',
    path: '/delete/$externalLinkId',
    getParentRoute: () => AppToolsExternalLinksRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/external-links/delete.$externalLinkId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsExternalLinksArchiveExternalLinkIdRouteRoute =
  AppToolsExternalLinksArchiveExternalLinkIdRouteRouteImport.update({
    id: '/archive/$externalLinkId',
    path: '/archive/$externalLinkId',
    getParentRoute: () => AppToolsExternalLinksRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/external-links/archive.$externalLinkId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsEmailsEmailIdResendRouteRoute =
  AppToolsEmailsEmailIdResendRouteRouteImport.update({
    id: '/resend',
    path: '/resend',
    getParentRoute: () => AppToolsEmailsEmailIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/emails/$emailId/resend/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsEmailsEmailIdReplyRouteRoute =
  AppToolsEmailsEmailIdReplyRouteRouteImport.update({
    id: '/reply',
    path: '/reply',
    getParentRoute: () => AppToolsEmailsEmailIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/emails/$emailId/reply/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppToolsDepartmentsUpdateDepartmentIdRouteRoute =
  AppToolsDepartmentsUpdateDepartmentIdRouteRouteImport.update({
    id: '/update/$departmentId',
    path: '/update/$departmentId',
    getParentRoute: () => AppToolsDepartmentsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/departments/update.$departmentId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsDepartmentsDeleteDepartmentIdRouteRoute =
  AppToolsDepartmentsDeleteDepartmentIdRouteRouteImport.update({
    id: '/delete/$departmentId',
    path: '/delete/$departmentId',
    getParentRoute: () => AppToolsDepartmentsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/departments/delete.$departmentId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsDdnsDeleteDdnsIdRouteRoute =
  AppToolsDdnsDeleteDdnsIdRouteRouteImport.update({
    id: '/delete/$ddnsId',
    path: '/delete/$ddnsId',
    getParentRoute: () => AppToolsDdnsRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/tools/ddns/delete.$ddnsId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppProductsProductIdManageCreateVersionRouteRoute =
  AppProductsProductIdManageCreateVersionRouteRouteImport.update({
    id: '/create-version',
    path: '/create-version',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/create-version/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageCreateStockRouteRoute =
  AppProductsProductIdManageCreateStockRouteRouteImport.update({
    id: '/create-stock',
    path: '/create-stock',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/create-stock/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageAddSpecificationRouteRoute =
  AppProductsProductIdManageAddSpecificationRouteRouteImport.update({
    id: '/add-specification',
    path: '/add-specification',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/add-specification/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageAddNomenclatureDetailRouteRoute =
  AppProductsProductIdManageAddNomenclatureDetailRouteRouteImport.update({
    id: '/add-nomenclature-detail',
    path: '/add-nomenclature-detail',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/add-nomenclature-detail/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageAddAssociatedProductRouteRoute =
  AppProductsProductIdManageAddAssociatedProductRouteRouteImport.update({
    id: '/add-associated-product',
    path: '/add-associated-product',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/add-associated-product/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsRenameGedObjectRouteRoute =
  AppProductsProductIdInformationsRenameGedObjectRouteRouteImport.update({
    id: '/rename-ged-object',
    path: '/rename-ged-object',
    getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/rename-ged-object/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsImportGedFilesRouteRoute =
  AppProductsProductIdInformationsImportGedFilesRouteRouteImport.update({
    id: '/import-ged-files',
    path: '/import-ged-files',
    getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/import-ged-files/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsDeleteGedObjectRouteRoute =
  AppProductsProductIdInformationsDeleteGedObjectRouteRouteImport.update({
    id: '/delete-ged-object',
    path: '/delete-ged-object',
    getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/delete-ged-object/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute =
  AppProductsProductIdInformationsCreateLifesheetCommentRouteRouteImport.update(
    {
      id: '/create-lifesheet-comment',
      path: '/create-lifesheet-comment',
      getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/create-lifesheet-comment/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsCreateGedDirectoryRouteRoute =
  AppProductsProductIdInformationsCreateGedDirectoryRouteRouteImport.update({
    id: '/create-ged-directory',
    path: '/create-ged-directory',
    getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/create-ged-directory/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute =
  AppProductsSerialNumbersUpdateSerialNumberIdRouteRouteImport.update({
    id: '/update/$serialNumberId',
    path: '/update/$serialNumberId',
    getParentRoute: () => AppProductsSerialNumbersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products/serial-numbers/update.$serialNumberId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute =
  AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRouteImport.update(
    {
      id: '/remove-from-business/$serialNumberId',
      path: '/remove-from-business/$serialNumberId',
      getParentRoute: () => AppProductsSerialNumbersRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products/serial-numbers/remove-from-business.$serialNumberId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute =
  AppProductsSerialNumbersDeleteSerialNumberIdRouteRouteImport.update({
    id: '/delete/$serialNumberId',
    path: '/delete/$serialNumberId',
    getParentRoute: () => AppProductsSerialNumbersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products/serial-numbers/delete.$serialNumberId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute =
  AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRouteImport.update({
    id: '/create-rma/$serialNumberId',
    path: '/create-rma/$serialNumberId',
    getParentRoute: () => AppProductsSerialNumbersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products/serial-numbers/create-rma.$serialNumberId/route.lazy'
    ).then((d) => d.Route),
  )
const AppFaqGedFaqIdImportFilesRouteRoute =
  AppFaqGedFaqIdImportFilesRouteRouteImport.update({
    id: '/import-files',
    path: '/import-files',
    getParentRoute: () => AppFaqGedFaqIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/faq/ged.$faqId/import-files/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppFaqGedFaqIdCreateDirectoryRouteRoute =
  AppFaqGedFaqIdCreateDirectoryRouteRouteImport.update({
    id: '/create-directory',
    path: '/create-directory',
    getParentRoute: () => AppFaqGedFaqIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/faq/ged.$faqId/create-directory/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute =
  AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRouteImport.update({
    id: '/update-contact/$contactId',
    path: '/update-contact/$contactId',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/update-contact.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute =
  AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRouteImport.update(
    {
      id: '/update-contact-password/$contactId',
      path: '/update-contact-password/$contactId',
      getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/update-contact-password.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute =
  AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRouteImport.update(
    {
      id: '/unrelate-business-rma/$businessRmaId',
      path: '/unrelate-business-rma/$businessRmaId',
      getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/unrelate-business-rma.$businessRmaId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute =
  AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRouteImport.update({
    id: '/unlink-task/$taskId',
    path: '/unlink-task/$taskId',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/unlink-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute =
  AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteImport.update({
    id: '/task-email/$taskId',
    path: '/task-email/$taskId',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/task-email.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute =
  AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRouteImport.update({
    id: '/send-email-to-contact/$contactId',
    path: '/send-email-to-contact/$contactId',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/send-email-to-contact.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute =
  AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRouteImport.update(
    {
      id: '/rename-ged-object/$objectRelativePath',
      path: '/rename-ged-object/$objectRelativePath',
      getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/rename-ged-object.$objectRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute =
  AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteImport.update({
    id: '/lifesheet-email/$lifesheetId',
    path: '/lifesheet-email/$lifesheetId',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/lifesheet-email.$lifesheetId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute =
  AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRouteImport.update(
    {
      id: '/delete-ged-object/$objectRelativePath',
      path: '/delete-ged-object/$objectRelativePath',
      getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/delete-ged-object.$objectRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute =
  AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRouteImport.update({
    id: '/delete-contact/$contactId',
    path: '/delete-contact/$contactId',
    getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/delete-contact.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute =
  AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRouteImport.update(
    {
      id: '/create-contact-business/$contactId',
      path: '/create-contact-business/$contactId',
      getParentRoute: () => AppEnterprisesEnterpriseIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/create-contact-business.$contactId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdAddressBookImportRouteRoute =
  AppEnterprisesEnterpriseIdAddressBookImportRouteRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AppEnterprisesEnterpriseIdAddressBookRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/address-book/import/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute =
  AppEnterprisesEnterpriseIdAddressBookCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppEnterprisesEnterpriseIdAddressBookRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/address-book/create/route.lazy'
    ).then((d) => d.Route),
  )
const AppDashboardTaskEmailTaskIdResendRouteRoute =
  AppDashboardTaskEmailTaskIdResendRouteRouteImport.update({
    id: '/resend',
    path: '/resend',
    getParentRoute: () => AppDashboardTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/task-email.$taskId/resend/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppDashboardTaskEmailTaskIdReplyRouteRoute =
  AppDashboardTaskEmailTaskIdReplyRouteRouteImport.update({
    id: '/reply',
    path: '/reply',
    getParentRoute: () => AppDashboardTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/dashboard/task-email.$taskId/reply/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaRmaRmaIdSupportRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportRouteRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/businesses-rma_/rma.$rmaId/support/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaRmaRmaIdReceptionRouteRoute =
  AppBusinessesRmaRmaRmaIdReceptionRouteRouteImport.update({
    id: '/reception',
    path: '/reception',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/businesses-rma_/rma.$rmaId/reception/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaRmaRmaIdDeliveryRouteRoute =
  AppBusinessesRmaRmaRmaIdDeliveryRouteRouteImport.update({
    id: '/delivery',
    path: '/delivery',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/businesses-rma_/rma.$rmaId/delivery/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AppBusinessesRmaBusinessBusinessIdStudyRouteRoute =
  AppBusinessesRmaBusinessBusinessIdStudyRouteRouteImport.update({
    id: '/businesses-rma_/business/$businessId_/study',
    path: '/businesses-rma/business/$businessId/study',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteImport.update({
    id: '/quotation',
    path: '/quotation',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpRouteRouteImport.update({
    id: '/bp',
    path: '/bp',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBlRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBlRouteRouteImport.update({
    id: '/bl',
    path: '/bl',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bl/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBillRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBillRouteRouteImport.update({
    id: '/bill',
    path: '/bill',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bill/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdArcRouteRoute =
  AppBusinessesRmaBusinessBusinessIdArcRouteRouteImport.update({
    id: '/arc',
    path: '/arc',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/arc/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdStudyIndexRoute =
  AppBusinessesRmaBusinessBusinessIdStudyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdStudyRouteRoute,
  } as any)
const AppToolsSchedulerDetailsRdvIdUpdateRouteRoute =
  AppToolsSchedulerDetailsRdvIdUpdateRouteRouteImport.update({
    id: '/update',
    path: '/update',
    getParentRoute: () => AppToolsSchedulerDetailsRdvIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/scheduler/details.$rdvId/update/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsSchedulerDetailsRdvIdDeleteRouteRoute =
  AppToolsSchedulerDetailsRdvIdDeleteRouteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AppToolsSchedulerDetailsRdvIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/scheduler/details.$rdvId/delete/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsFormationsUpdateFormationIdDetailsRouteRoute =
  AppToolsFormationsUpdateFormationIdDetailsRouteRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AppToolsFormationsUpdateFormationIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/formations/update.$formationId/details/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsFormationsUpdateFormationIdAddDetailRouteRoute =
  AppToolsFormationsUpdateFormationIdAddDetailRouteRouteImport.update({
    id: '/add-detail',
    path: '/add-detail',
    getParentRoute: () => AppToolsFormationsUpdateFormationIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/formations/update.$formationId/add-detail/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute =
  AppToolsFormationsSubscribersFormationDetailIdCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AppToolsFormationsSubscribersFormationDetailIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/tools/formations/subscribers.$formationDetailId/create/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageUpdateVersionVersionIdRouteRoute =
  AppProductsProductIdManageUpdateVersionVersionIdRouteRouteImport.update({
    id: '/update-version/$versionId',
    path: '/update-version/$versionId',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/update-version.$versionId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageUpdateStockStockIdRouteRoute =
  AppProductsProductIdManageUpdateStockStockIdRouteRouteImport.update({
    id: '/update-stock/$stockId',
    path: '/update-stock/$stockId',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/update-stock.$stockId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute =
  AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRouteImport.update(
    {
      id: '/update-specification/$specificationId',
      path: '/update-specification/$specificationId',
      getParentRoute: () => AppProductsProductIdManageRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/update-specification.$specificationId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute =
  AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRouteImport.update(
    {
      id: '/update-nomenclature-detail/$nomenclatureDetailId',
      path: '/update-nomenclature-detail/$nomenclatureDetailId',
      getParentRoute: () => AppProductsProductIdManageRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/update-nomenclature-detail.$nomenclatureDetailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageStockHistoryStockIdRouteRoute =
  AppProductsProductIdManageStockHistoryStockIdRouteRouteImport.update({
    id: '/stock-history/$stockId',
    path: '/stock-history/$stockId',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/stock-history.$stockId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute =
  AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRouteImport.update(
    {
      id: '/remove-associated-product/$associatedProductId',
      path: '/remove-associated-product/$associatedProductId',
      getParentRoute: () => AppProductsProductIdManageRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/remove-associated-product.$associatedProductId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageDeleteVersionVersionIdRouteRoute =
  AppProductsProductIdManageDeleteVersionVersionIdRouteRouteImport.update({
    id: '/delete-version/$versionId',
    path: '/delete-version/$versionId',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/delete-version.$versionId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageDeleteStockStockIdRouteRoute =
  AppProductsProductIdManageDeleteStockStockIdRouteRouteImport.update({
    id: '/delete-stock/$stockId',
    path: '/delete-stock/$stockId',
    getParentRoute: () => AppProductsProductIdManageRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/delete-stock.$stockId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute =
  AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRouteImport.update(
    {
      id: '/delete-specification/$specificationId',
      path: '/delete-specification/$specificationId',
      getParentRoute: () => AppProductsProductIdManageRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/delete-specification.$specificationId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute =
  AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRouteImport.update(
    {
      id: '/delete-nomenclature-detail/$nomenclatureDetailId',
      path: '/delete-nomenclature-detail/$nomenclatureDetailId',
      getParentRoute: () => AppProductsProductIdManageRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/delete-nomenclature-detail.$nomenclatureDetailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdManageAddSpecificationFilterIdRouteRoute =
  AppProductsProductIdManageAddSpecificationFilterIdRouteRouteImport.update({
    id: '/$filterId',
    path: '/$filterId',
    getParentRoute: () => AppProductsProductIdManageAddSpecificationRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/manage/add-specification/$filterId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute =
  AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRouteImport.update({
    id: '/unlink-task/$taskId',
    path: '/unlink-task/$taskId',
    getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/unlink-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute =
  AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteImport.update({
    id: '/task-email/$taskId',
    path: '/task-email/$taskId',
    getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/task-email.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute =
  AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteImport.update(
    {
      id: '/lifesheet-email/$lifesheetId',
      path: '/lifesheet-email/$lifesheetId',
      getParentRoute: () => AppProductsProductIdInformationsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/lifesheet-email.$lifesheetId/route.lazy'
    ).then((d) => d.Route),
  )
const AppFaqGedFaqIdRenameItemRelativePathRouteRoute =
  AppFaqGedFaqIdRenameItemRelativePathRouteRouteImport.update({
    id: '/rename/$itemRelativePath',
    path: '/rename/$itemRelativePath',
    getParentRoute: () => AppFaqGedFaqIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/faq/ged.$faqId/rename.$itemRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppFaqGedFaqIdDeleteItemRelativePathRouteRoute =
  AppFaqGedFaqIdDeleteItemRelativePathRouteRouteImport.update({
    id: '/delete/$itemRelativePath',
    path: '/delete/$itemRelativePath',
    getParentRoute: () => AppFaqGedFaqIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/faq/ged.$faqId/delete.$itemRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute =
  AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRouteImport.update({
    id: '/resend',
    path: '/resend',
    getParentRoute: () => AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/task-email.$taskId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute =
  AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRouteImport.update({
    id: '/reply',
    path: '/reply',
    getParentRoute: () => AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/task-email.$taskId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute =
  AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/lifesheet-email.$lifesheetId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute =
  AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/lifesheet-email.$lifesheetId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute =
  AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteImport.update({
    id: '/email/$emailId',
    path: '/email/$emailId',
    getParentRoute: () => AppEnterprisesEnterpriseIdEmailHistoryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/email-history/email.$emailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute =
  AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRouteImport.update({
    id: '/update/$addressId',
    path: '/update/$addressId',
    getParentRoute: () => AppEnterprisesEnterpriseIdAddressBookRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/address-book/update.$addressId/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute =
  AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRouteImport.update({
    id: '/delete/$addressId',
    path: '/delete/$addressId',
    getParentRoute: () => AppEnterprisesEnterpriseIdAddressBookRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/address-book/delete.$addressId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportPdfRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteImport.update({
    id: '/pdf',
    path: '/pdf',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/pdf/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRouteImport.update({
    id: '/import-ged-files',
    path: '/import-ged-files',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/import-ged-files/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRouteImport.update({
    id: '/create-link',
    path: '/create-link',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/create-link/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRouteImport.update({
    id: '/create-lifesheet',
    path: '/create-lifesheet',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/create-lifesheet/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRouteImport.update({
    id: '/create-ged-directory',
    path: '/create-ged-directory',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/create-ged-directory/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRouteImport.update({
    id: '/create-detail',
    path: '/create-detail',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/create-detail/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdReceptionPdfRouteRoute =
  AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteImport.update({
    id: '/pdf',
    path: '/pdf',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdReceptionRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/reception/pdf/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute =
  AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRouteImport.update({
    id: '/create-detail',
    path: '/create-detail',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdReceptionRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/reception/create-detail/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute =
  AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRouteImport.update({
    id: '/travel-voucher',
    path: '/travel-voucher',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdDeliveryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/delivery/travel-voucher/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRoute =
  AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteImport.update({
    id: '/pdf',
    path: '/pdf',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdDeliveryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/delivery/pdf/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute =
  AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRouteImport.update({
    id: '/create-detail',
    path: '/create-detail',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdDeliveryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/delivery/create-detail/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute =
  AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRouteImport.update({
    id: '/expert',
    path: '/expert',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdStudyRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/study/expert/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute =
  AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRouteImport.update({
    id: '/automatic',
    path: '/automatic',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdStudyRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/study/automatic/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteImport.update(
    {
      id: '/businesses-rma_/business/$businessId_/assistance/$assistanceId',
      path: '/businesses-rma/business/$businessId/assistance/$assistanceId',
      getParentRoute: () => AppRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRouteImport.update(
    {
      id: '/update-shipping-price',
      path: '/update-shipping-price',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/update-shipping-price/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteImport.update({
    id: '/pdf',
    path: '/pdf',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/pdf/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteImport.update(
    {
      id: '/commercial-notice',
      path: '/commercial-notice',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/commercial-notice/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRouteImport.update(
    {
      id: '/update-responsible',
      path: '/update-responsible',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/update-responsible/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRouteImport.update(
    {
      id: '/update-representative',
      path: '/update-representative',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/update-representative/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRouteImport.update(
    {
      id: '/update-billing-address',
      path: '/update-billing-address',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/update-billing-address/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRouteImport.update({
    id: '/send-email',
    path: '/send-email',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/send-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRouteImport.update(
    {
      id: '/import-ged-files',
      path: '/import-ged-files',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/import-ged-files/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteImport.update(
    {
      id: '/email-history',
      path: '/email-history',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/delete/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRouteImport.update({
    id: '/create-link',
    path: '/create-link',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/create-link/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRouteImport.update(
    {
      id: '/create-lifesheet',
      path: '/create-lifesheet',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/create-lifesheet/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRouteImport.update(
    {
      id: '/create-ged-directory',
      path: '/create-ged-directory',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/create-ged-directory/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteImport.update(
    {
      id: '/address-book',
      path: '/address-book',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRouteImport.update({
    id: '/travel-voucher',
    path: '/travel-voucher',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBpRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/travel-voucher/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteImport.update({
    id: '/update',
    path: '/update',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBlRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bl/update/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRouteImport.update({
    id: '/send-by-email',
    path: '/send-by-email',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBlRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bl/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRouteImport.update({
    id: '/send-by-email',
    path: '/send-by-email',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBillRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bill/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteImport.update({
    id: '/credits',
    path: '/credits',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBillRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bill/credits/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute =
  AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRouteImport.update(
    {
      id: '/update-shipping-price',
      path: '/update-shipping-price',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdArcRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/arc/update-shipping-price/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdArcPdfRouteRoute =
  AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteImport.update({
    id: '/pdf',
    path: '/pdf',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdArcRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/arc/pdf/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute =
  AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRouteImport.update(
    {
      id: '/send-email/$subscriptionId',
      path: '/send-email/$subscriptionId',
      getParentRoute: () =>
        AppToolsFormationsSubscribersFormationDetailIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/tools/formations/subscribers.$formationDetailId/send-email.$subscriptionId/route.lazy'
    ).then((d) => d.Route),
  )
const AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute =
  AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRouteImport.update(
    {
      id: '/delete/$subscriptionId',
      path: '/delete/$subscriptionId',
      getParentRoute: () =>
        AppToolsFormationsSubscribersFormationDetailIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/tools/formations/subscribers.$formationDetailId/delete.$subscriptionId/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute =
  AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRouteImport.update({
    id: '/resend',
    path: '/resend',
    getParentRoute: () =>
      AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/task-email.$taskId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute =
  AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRouteImport.update({
    id: '/reply',
    path: '/reply',
    getParentRoute: () =>
      AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/task-email.$taskId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute =
  AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/lifesheet-email.$lifesheetId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute =
  AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/products_.$productId/informations/lifesheet-email.$lifesheetId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute =
  AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/email-history/email.$emailId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute =
  AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/enterprises_.$enterpriseId/email-history/email.$emailId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRouteImport.update({
    id: '/update-detail/$detailId',
    path: '/update-detail/$detailId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/update-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRouteImport.update({
    id: '/unlink-task/$taskId',
    path: '/unlink-task/$taskId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/unlink-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteImport.update({
    id: '/task-email/$taskId',
    path: '/task-email/$taskId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/task-email.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRouteImport.update(
    {
      id: '/rename-ged-object/$objectRelativePath',
      path: '/rename-ged-object/$objectRelativePath',
      getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/rename-ged-object.$objectRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRouteImport.update({
    id: '/send-by-email',
    path: '/send-by-email',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportPdfRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/pdf/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteImport.update(
    {
      id: '/lifesheet-email/$lifesheetId',
      path: '/lifesheet-email/$lifesheetId',
      getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/lifesheet-email.$lifesheetId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRouteImport.update({
    id: '/delete-link/$associatedId',
    path: '/delete-link/$associatedId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/delete-link.$associatedId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRouteImport.update(
    {
      id: '/delete-ged-object/$relativePath',
      path: '/delete-ged-object/$relativePath',
      getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/delete-ged-object.$relativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRouteImport.update({
    id: '/delete-detail/$detailId',
    path: '/delete-detail/$detailId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdSupportRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/delete-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute =
  AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRouteImport.update({
    id: '/update-detail/$detailId',
    path: '/update-detail/$detailId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdReceptionRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/reception/update-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute =
  AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRouteImport.update({
    id: '/send-by-email',
    path: '/send-by-email',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdReceptionPdfRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/reception/pdf/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute =
  AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRouteImport.update({
    id: '/delete-detail/$detailId',
    path: '/delete-detail/$detailId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdReceptionRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/reception/delete-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute =
  AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRouteImport.update({
    id: '/update-detail/$detailId',
    path: '/update-detail/$detailId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdDeliveryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/delivery/update-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute =
  AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRouteImport.update({
    id: '/send-by-email',
    path: '/send-by-email',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/delivery/pdf/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute =
  AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRouteImport.update({
    id: '/delete-detail/$detailId',
    path: '/delete-detail/$detailId',
    getParentRoute: () => AppBusinessesRmaRmaRmaIdDeliveryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/delivery/delete-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteImport.update(
    {
      id: '/pdf',
      path: '/pdf',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/pdf/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRouteImport.update(
    {
      id: '/import-ged-files',
      path: '/import-ged-files',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/import-ged-files/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRouteImport.update(
    {
      id: '/edit-subtitle',
      path: '/edit-subtitle',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/edit-subtitle/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRouteImport.update(
    {
      id: '/edit-no-billed-time',
      path: '/edit-no-billed-time',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/edit-no-billed-time/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRouteImport.update(
    {
      id: '/edit-cumulated-time',
      path: '/edit-cumulated-time',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/edit-cumulated-time/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRouteImport.update(
    {
      id: '/delete',
      path: '/delete',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/delete/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRouteImport.update(
    {
      id: '/create-link',
      path: '/create-link',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-link/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRouteImport.update(
    {
      id: '/create-lifesheet',
      path: '/create-lifesheet',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-lifesheet/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRouteImport.update(
    {
      id: '/create-ged-directory',
      path: '/create-ged-directory',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-ged-directory/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRouteImport.update(
    {
      id: '/create-faq',
      path: '/create-faq',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/create-faq/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRouteImport.update(
    {
      id: '/update-subquotation/$subquotationId',
      path: '/update-subquotation/$subquotationId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/update-subquotation.$subquotationId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRouteImport.update(
    {
      id: '/update-detail/$detailId',
      path: '/update-detail/$detailId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/update-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRouteImport.update(
    {
      id: '/send-by-email',
      path: '/send-by-email',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/pdf/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRouteImport.update(
    {
      id: '/delete-subquotation/$subquotationId',
      path: '/delete-subquotation/$subquotationId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/delete-subquotation.$subquotationId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRouteImport.update(
    {
      id: '/delete-detail/$detailId',
      path: '/delete-detail/$detailId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/delete-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRouteImport.update(
    {
      id: '/create-detail/$subquotationId',
      path: '/create-detail/$subquotationId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/create-detail.$subquotationId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRouteImport.update(
    {
      id: '/create-associated-detail/$detailId',
      path: '/create-associated-detail/$detailId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/create-associated-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteImport.update(
    {
      id: '/send-by-email',
      path: '/send-by-email',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/quotation/commercial-notice/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRouteImport.update(
    {
      id: '/unlink-task/$taskId',
      path: '/unlink-task/$taskId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/unlink-task.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteImport.update(
    {
      id: '/task-email/$taskId',
      path: '/task-email/$taskId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/task-email.$taskId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRouteImport.update(
    {
      id: '/rename-ged-object/$objectRelativePath',
      path: '/rename-ged-object/$objectRelativePath',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/rename-ged-object.$objectRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteImport.update(
    {
      id: '/lifesheet-email/$lifesheetId',
      path: '/lifesheet-email/$lifesheetId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/lifesheet-email.$lifesheetId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteImport.update(
    {
      id: '/$emailId',
      path: '/$emailId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/$emailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRouteImport.update(
    {
      id: '/delete-link/$associatedId',
      path: '/delete-link/$associatedId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/delete-link.$associatedId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRouteImport.update(
    {
      id: '/delete-ged-object/$objectRelativePath',
      path: '/delete-ged-object/$objectRelativePath',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/delete-ged-object.$objectRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRouteImport.update(
    {
      id: '/confirm-quotation-import/$otherBusinessId',
      path: '/confirm-quotation-import/$otherBusinessId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/confirm-quotation-import.$otherBusinessId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/create/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRouteImport.update(
    {
      id: '/update-detail/$detailId',
      path: '/update-detail/$detailId',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBpRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/update-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRouteImport.update(
    {
      id: '/delete-serial/$serialId',
      path: '/delete-serial/$serialId',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBpRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/delete-serial.$serialId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRouteImport.update(
    {
      id: '/delete-detail/$detailId',
      path: '/delete-detail/$detailId',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBpRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/delete-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRouteImport.update(
    {
      id: '/create-serial-rma/$serialId',
      path: '/create-serial-rma/$serialId',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBpRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/create-serial-rma.$serialId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRouteImport.update(
    {
      id: '/create-detail-rma/$detailId',
      path: '/create-detail-rma/$detailId',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBpRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/create-detail-rma.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRouteImport.update({
    id: '/add-serial/$detailId',
    path: '/add-serial/$detailId',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBpRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bp/add-serial.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bl/update/new/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRouteImport.update(
    {
      id: '/send-by-email',
      path: '/send-by-email',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/bill/credits/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRouteImport.update(
    {
      id: '/update-detail/$detailId',
      path: '/update-detail/$detailId',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdArcRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/arc/update-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRouteImport.update({
    id: '/send-by-email',
    path: '/send-by-email',
    getParentRoute: () => AppBusinessesRmaBusinessBusinessIdArcPdfRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/arc/pdf/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRouteImport.update(
    {
      id: '/delete-detail/$detailId',
      path: '/delete-detail/$detailId',
      getParentRoute: () => AppBusinessesRmaBusinessBusinessIdArcRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/arc/delete-detail.$detailId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRouteImport.update({
    id: '/resend',
    path: '/resend',
    getParentRoute: () =>
      AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/task-email.$taskId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRouteImport.update({
    id: '/reply',
    path: '/reply',
    getParentRoute: () =>
      AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/task-email.$taskId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/lifesheet-email.$lifesheetId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute =
  AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/rma.$rmaId/support/lifesheet-email.$lifesheetId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRouteImport.update(
    {
      id: '/rename-ged-object/$objectRelativePath',
      path: '/rename-ged-object/$objectRelativePath',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/rename-ged-object.$objectRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRouteImport.update(
    {
      id: '/send-by-email',
      path: '/send-by-email',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/pdf/send-by-email/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteImport.update(
    {
      id: '/lifesheet-email/$lifesheetId',
      path: '/lifesheet-email/$lifesheetId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/lifesheet-email.$lifesheetId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRouteImport.update(
    {
      id: '/delete-link/$associatedId',
      path: '/delete-link/$associatedId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/delete-link.$associatedId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRouteImport.update(
    {
      id: '/delete-ged-object/$objectRelativePath',
      path: '/delete-ged-object/$objectRelativePath',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/delete-ged-object.$objectRelativePath/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute =
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRouteImport.update(
    {
      id: '/predefined-messages',
      path: '/predefined-messages',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRoute,
    } as any,
  )
const AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/task-email.$taskId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/task-email.$taskId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/lifesheet-email.$lifesheetId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/lifesheet-email.$lifesheetId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/$emailId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/email-history/$emailId/reply/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRouteImport.update(
    {
      id: '/update/$addressId',
      path: '/update/$addressId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/update.$addressId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute =
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRouteImport.update(
    {
      id: '/delete/$addressId',
      path: '/delete/$addressId',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId/dashboard/address-book/delete.$addressId/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRouteImport.update(
    {
      id: '/resend',
      path: '/resend',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/lifesheet-email.$lifesheetId/resend/route.lazy'
    ).then((d) => d.Route),
  )
const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRouteImport.update(
    {
      id: '/reply',
      path: '/reply',
      getParentRoute: () =>
        AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/app/businesses-rma_/business.$businessId_/assistance.$assistanceId/lifesheet-email.$lifesheetId/reply/route.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/app/businesses-rma': typeof AppBusinessesRmaRouteRouteWithChildren
  '/app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/app/enterprises': typeof AppEnterprisesRouteRouteWithChildren
  '/app/external-links': typeof AppExternalLinksRouteRoute
  '/app/faq': typeof AppFaqRouteRouteWithChildren
  '/app/products': typeof AppProductsRouteRouteWithChildren
  '/app/tools': typeof AppToolsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRouteRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRouteLazyRoute
  '/app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/app/businesses-rma/representative-turnover': typeof AppBusinessesRmaRepresentativeTurnoverRouteRoute
  '/app/businesses-rma/search-by-products': typeof AppBusinessesRmaSearchByProductsRouteRoute
  '/app/dashboard/create-collective-task': typeof AppDashboardCreateCollectiveTaskRouteRoute
  '/app/dashboard/create-personal-task': typeof AppDashboardCreatePersonalTaskRouteRoute
  '/app/dashboard/create-progressive-info': typeof AppDashboardCreateProgressiveInfoRouteRoute
  '/app/dashboard/delete-collective-tasks': typeof AppDashboardDeleteCollectiveTasksRouteRoute
  '/app/enterprises/create': typeof AppEnterprisesCreateRouteRoute
  '/app/enterprises/$enterpriseId': typeof AppEnterprisesEnterpriseIdRouteRouteWithChildren
  '/app/external-links/$externalLinkId': typeof AppExternalLinksExternalLinkIdRouteRoute
  '/app/faq/create': typeof AppFaqCreateRouteRoute
  '/app/products/create': typeof AppProductsCreateRouteRoute
  '/app/products/serial-numbers': typeof AppProductsSerialNumbersRouteRouteWithChildren
  '/app/products/$productId': typeof AppProductsProductIdRouteRouteWithChildren
  '/app/tools/credit': typeof AppToolsCreditRouteRouteWithChildren
  '/app/tools/ddns': typeof AppToolsDdnsRouteRouteWithChildren
  '/app/tools/departments': typeof AppToolsDepartmentsRouteRouteWithChildren
  '/app/tools/emails': typeof AppToolsEmailsRouteRouteWithChildren
  '/app/tools/external-links': typeof AppToolsExternalLinksRouteRouteWithChildren
  '/app/tools/formations': typeof AppToolsFormationsRouteRouteWithChildren
  '/app/tools/global-turnover': typeof AppToolsGlobalTurnoverRouteRoute
  '/app/tools/mails': typeof AppToolsMailsRouteRouteWithChildren
  '/app/tools/menu': typeof AppToolsMenuRouteRouteWithChildren
  '/app/tools/news': typeof AppToolsNewsRouteRouteWithChildren
  '/app/tools/predefined-messages': typeof AppToolsPredefinedMessagesRouteRouteWithChildren
  '/app/tools/predefined-texts': typeof AppToolsPredefinedTextsRouteRouteWithChildren
  '/app/tools/product-filters': typeof AppToolsProductFiltersRouteRouteWithChildren
  '/app/tools/product-inventory': typeof AppToolsProductInventoryRouteRouteWithChildren
  '/app/tools/product-shelves': typeof AppToolsProductShelvesRouteRouteWithChildren
  '/app/tools/representatives-map': typeof AppToolsRepresentativesMapRouteRoute
  '/app/tools/representatives-turnover': typeof AppToolsRepresentativesTurnoverRouteRoute
  '/app/tools/scheduler': typeof AppToolsSchedulerRouteRouteWithChildren
  '/app/tools/vva': typeof AppToolsVvaRouteRouteWithChildren
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRouteLazyRoute
  '/app/tools/': typeof AppToolsIndexRoute
  '/app/businesses-rma/business/$businessId': typeof AppBusinessesRmaBusinessBusinessIdRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId': typeof AppBusinessesRmaRmaRmaIdRouteRouteWithChildren
  '/app/dashboard/archive-personal-task/$taskId': typeof AppDashboardArchivePersonalTaskTaskIdRouteRoute
  '/app/dashboard/create-aircall-contact/$number': typeof AppDashboardCreateAircallContactNumberRouteRoute
  '/app/dashboard/delete-collective-task/$taskId': typeof AppDashboardDeleteCollectiveTaskTaskIdRouteRoute
  '/app/dashboard/delete-progressive-info/$progressiveInfoId': typeof AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute
  '/app/dashboard/link-personal-task/$taskId': typeof AppDashboardLinkPersonalTaskTaskIdRouteRoute
  '/app/dashboard/other-personal-tasks/$profileId': typeof AppDashboardOtherPersonalTasksProfileIdRouteRoute
  '/app/dashboard/personal-task-details/$taskId': typeof AppDashboardPersonalTaskDetailsTaskIdRouteRoute
  '/app/dashboard/scheduler-event-details/$eventId': typeof AppDashboardSchedulerEventDetailsEventIdRouteRoute
  '/app/dashboard/take-collective-task/$taskId': typeof AppDashboardTakeCollectiveTaskTaskIdRouteRoute
  '/app/dashboard/task-comments/$taskId': typeof AppDashboardTaskCommentsTaskIdRouteRoute
  '/app/dashboard/task-email/$taskId': typeof AppDashboardTaskEmailTaskIdRouteRouteWithChildren
  '/app/dashboard/transfer-task/$taskId': typeof AppDashboardTransferTaskTaskIdRouteRoute
  '/app/dashboard/unlink-personal-task/$taskId': typeof AppDashboardUnlinkPersonalTaskTaskIdRouteRoute
  '/app/dashboard/update-aircall-contact/$contactId': typeof AppDashboardUpdateAircallContactContactIdRouteRoute
  '/app/dashboard/update-personal-task-deadline/$taskId': typeof AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute
  '/app/dashboard/update-progressive-info/$progressiveInfoId': typeof AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute
  '/app/dashboard/validate-personal-task/$taskId': typeof AppDashboardValidatePersonalTaskTaskIdRouteRoute
  '/app/enterprises/create-contact-business/$contactId': typeof AppEnterprisesCreateContactBusinessContactIdRouteRoute
  '/app/enterprises/create-contact-travel-voucher/$contactId': typeof AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute
  '/app/enterprises/create-contact/$enterpriseId': typeof AppEnterprisesCreateContactEnterpriseIdRouteRoute
  '/app/enterprises/create-enterprise-rma/$enterpriseId': typeof AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute
  '/app/enterprises/delete-contact/$contactId': typeof AppEnterprisesDeleteContactContactIdRouteRoute
  '/app/enterprises/send-email-to-contact/$contactId': typeof AppEnterprisesSendEmailToContactContactIdRouteRoute
  '/app/enterprises/update-contact-password/$contactId': typeof AppEnterprisesUpdateContactPasswordContactIdRouteRoute
  '/app/enterprises/update-contact/$contactId': typeof AppEnterprisesUpdateContactContactIdRouteRoute
  '/app/enterprises/$enterpriseId/address-book': typeof AppEnterprisesEnterpriseIdAddressBookRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/create-contact': typeof AppEnterprisesEnterpriseIdCreateContactRouteRoute
  '/app/enterprises/$enterpriseId/create-ged-directory': typeof AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute
  '/app/enterprises/$enterpriseId/create-lifesheet-comment': typeof AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute
  '/app/enterprises/$enterpriseId/delete': typeof AppEnterprisesEnterpriseIdDeleteRouteRoute
  '/app/enterprises/$enterpriseId/email-history': typeof AppEnterprisesEnterpriseIdEmailHistoryRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/import-contacts': typeof AppEnterprisesEnterpriseIdImportContactsRouteRoute
  '/app/enterprises/$enterpriseId/import-ged-files': typeof AppEnterprisesEnterpriseIdImportGedFilesRouteRoute
  '/app/enterprises/$enterpriseId/relate-business-rma': typeof AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute
  '/app/enterprises/$enterpriseId/update': typeof AppEnterprisesEnterpriseIdUpdateRouteRoute
  '/app/enterprises/$enterpriseId/update-accountability': typeof AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute
  '/app/enterprises/$enterpriseId/update-category': typeof AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute
  '/app/enterprises/$enterpriseId/update-representative': typeof AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute
  '/app/faq/archive/$faqId': typeof AppFaqArchiveFaqIdRouteRoute
  '/app/faq/delete/$faqId': typeof AppFaqDeleteFaqIdRouteRoute
  '/app/faq/ged/$faqId': typeof AppFaqGedFaqIdRouteRouteWithChildren
  '/app/faq/send-by-email/$faqId': typeof AppFaqSendByEmailFaqIdRouteRoute
  '/app/faq/update/$faqId': typeof AppFaqUpdateFaqIdRouteRoute
  '/app/products/serial-numbers/create': typeof AppProductsSerialNumbersCreateRouteRoute
  '/app/products/$productId/informations': typeof AppProductsProductIdInformationsRouteRouteWithChildren
  '/app/products/$productId/manage': typeof AppProductsProductIdManageRouteRouteWithChildren
  '/app/tools/credit/details': typeof AppToolsCreditDetailsRouteRoute
  '/app/tools/credit/show': typeof AppToolsCreditShowRouteRoute
  '/app/tools/ddns/create': typeof AppToolsDdnsCreateRouteRoute
  '/app/tools/departments/create': typeof AppToolsDepartmentsCreateRouteRoute
  '/app/tools/emails/$emailId': typeof AppToolsEmailsEmailIdRouteRouteWithChildren
  '/app/tools/external-links/create': typeof AppToolsExternalLinksCreateRouteRoute
  '/app/tools/formations/create': typeof AppToolsFormationsCreateRouteRouteWithChildren
  '/app/tools/mails/create': typeof AppToolsMailsCreateRouteRoute
  '/app/tools/menu/create-enterprise': typeof AppToolsMenuCreateEnterpriseRouteRoute
  '/app/tools/menu/create-product': typeof AppToolsMenuCreateProductRouteRoute
  '/app/tools/news/create': typeof AppToolsNewsCreateRouteRoute
  '/app/tools/predefined-messages/create': typeof AppToolsPredefinedMessagesCreateRouteRoute
  '/app/tools/predefined-texts/create': typeof AppToolsPredefinedTextsCreateRouteRoute
  '/app/tools/product-filters/create': typeof AppToolsProductFiltersCreateRouteRoute
  '/app/tools/product-inventory/validate-quantities': typeof AppToolsProductInventoryValidateQuantitiesRouteRoute
  '/app/tools/product-shelves/create': typeof AppToolsProductShelvesCreateRouteRoute
  '/app/tools/scheduler/create': typeof AppToolsSchedulerCreateRouteRoute
  '/app/tools/vva/create': typeof AppToolsVvaCreateRouteRoute
  '/app/products/$productId/': typeof AppProductsProductIdIndexRoute
  '/app/businesses-rma/business/$businessId/arc': typeof AppBusinessesRmaBusinessBusinessIdArcRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bill': typeof AppBusinessesRmaBusinessBusinessIdBillRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bl': typeof AppBusinessesRmaBusinessBusinessIdBlRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bp': typeof AppBusinessesRmaBusinessBusinessIdBpRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard': typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation': typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/study': typeof AppBusinessesRmaBusinessBusinessIdStudyRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/delivery': typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/reception': typeof AppBusinessesRmaRmaRmaIdReceptionRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support': typeof AppBusinessesRmaRmaRmaIdSupportRouteRouteWithChildren
  '/app/dashboard/task-email/$taskId/reply': typeof AppDashboardTaskEmailTaskIdReplyRouteRoute
  '/app/dashboard/task-email/$taskId/resend': typeof AppDashboardTaskEmailTaskIdResendRouteRoute
  '/app/enterprises/$enterpriseId/address-book/create': typeof AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute
  '/app/enterprises/$enterpriseId/address-book/import': typeof AppEnterprisesEnterpriseIdAddressBookImportRouteRoute
  '/app/enterprises/$enterpriseId/create-contact-business/$contactId': typeof AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute
  '/app/enterprises/$enterpriseId/delete-contact/$contactId': typeof AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute
  '/app/enterprises/$enterpriseId/delete-ged-object/$objectRelativePath': typeof AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute
  '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/rename-ged-object/$objectRelativePath': typeof AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute
  '/app/enterprises/$enterpriseId/send-email-to-contact/$contactId': typeof AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute
  '/app/enterprises/$enterpriseId/task-email/$taskId': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/unlink-task/$taskId': typeof AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute
  '/app/enterprises/$enterpriseId/unrelate-business-rma/$businessRmaId': typeof AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute
  '/app/enterprises/$enterpriseId/update-contact-password/$contactId': typeof AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute
  '/app/enterprises/$enterpriseId/update-contact/$contactId': typeof AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute
  '/app/faq/ged/$faqId/create-directory': typeof AppFaqGedFaqIdCreateDirectoryRouteRoute
  '/app/faq/ged/$faqId/import-files': typeof AppFaqGedFaqIdImportFilesRouteRoute
  '/app/products/serial-numbers/create-rma/$serialNumberId': typeof AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute
  '/app/products/serial-numbers/delete/$serialNumberId': typeof AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute
  '/app/products/serial-numbers/remove-from-business/$serialNumberId': typeof AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute
  '/app/products/serial-numbers/update/$serialNumberId': typeof AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute
  '/app/products/$productId/informations/create-ged-directory': typeof AppProductsProductIdInformationsCreateGedDirectoryRouteRoute
  '/app/products/$productId/informations/create-lifesheet-comment': typeof AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute
  '/app/products/$productId/informations/delete-ged-object': typeof AppProductsProductIdInformationsDeleteGedObjectRouteRoute
  '/app/products/$productId/informations/import-ged-files': typeof AppProductsProductIdInformationsImportGedFilesRouteRoute
  '/app/products/$productId/informations/rename-ged-object': typeof AppProductsProductIdInformationsRenameGedObjectRouteRoute
  '/app/products/$productId/manage/add-associated-product': typeof AppProductsProductIdManageAddAssociatedProductRouteRoute
  '/app/products/$productId/manage/add-nomenclature-detail': typeof AppProductsProductIdManageAddNomenclatureDetailRouteRoute
  '/app/products/$productId/manage/add-specification': typeof AppProductsProductIdManageAddSpecificationRouteRouteWithChildren
  '/app/products/$productId/manage/create-stock': typeof AppProductsProductIdManageCreateStockRouteRoute
  '/app/products/$productId/manage/create-version': typeof AppProductsProductIdManageCreateVersionRouteRoute
  '/app/tools/ddns/delete/$ddnsId': typeof AppToolsDdnsDeleteDdnsIdRouteRoute
  '/app/tools/departments/delete/$departmentId': typeof AppToolsDepartmentsDeleteDepartmentIdRouteRoute
  '/app/tools/departments/update/$departmentId': typeof AppToolsDepartmentsUpdateDepartmentIdRouteRoute
  '/app/tools/emails/$emailId/reply': typeof AppToolsEmailsEmailIdReplyRouteRoute
  '/app/tools/emails/$emailId/resend': typeof AppToolsEmailsEmailIdResendRouteRoute
  '/app/tools/external-links/archive/$externalLinkId': typeof AppToolsExternalLinksArchiveExternalLinkIdRouteRoute
  '/app/tools/external-links/delete/$externalLinkId': typeof AppToolsExternalLinksDeleteExternalLinkIdRouteRoute
  '/app/tools/external-links/update/$externalLinkId': typeof AppToolsExternalLinksUpdateExternalLinkIdRouteRoute
  '/app/tools/formations/create/add-detail': typeof AppToolsFormationsCreateAddDetailRouteRoute
  '/app/tools/formations/create/details': typeof AppToolsFormationsCreateDetailsRouteRoute
  '/app/tools/formations/delete/$formationId': typeof AppToolsFormationsDeleteFormationIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId': typeof AppToolsFormationsSubscribersFormationDetailIdRouteRouteWithChildren
  '/app/tools/formations/update/$formationId': typeof AppToolsFormationsUpdateFormationIdRouteRouteWithChildren
  '/app/tools/mails/delete/$mailId': typeof AppToolsMailsDeleteMailIdRouteRoute
  '/app/tools/mails/show/$mailId': typeof AppToolsMailsShowMailIdRouteRoute
  '/app/tools/mails/update/$mailId': typeof AppToolsMailsUpdateMailIdRouteRoute
  '/app/tools/news/delete/$newsId': typeof AppToolsNewsDeleteNewsIdRouteRoute
  '/app/tools/news/update/$newsId': typeof AppToolsNewsUpdateNewsIdRouteRoute
  '/app/tools/predefined-messages/delete/$predefinedMessageId': typeof AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute
  '/app/tools/predefined-messages/update/$predefinedMessageId': typeof AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute
  '/app/tools/predefined-texts/delete/$predefinedTextId': typeof AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute
  '/app/tools/predefined-texts/update/$predefinedTextId': typeof AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute
  '/app/tools/product-filters/delete/$productFilterId': typeof AppToolsProductFiltersDeleteProductFilterIdRouteRoute
  '/app/tools/product-filters/update/$productFilterId': typeof AppToolsProductFiltersUpdateProductFilterIdRouteRoute
  '/app/tools/product-inventory/update/$stockId': typeof AppToolsProductInventoryUpdateStockIdRouteRoute
  '/app/tools/product-shelves/delete/$productShelfId': typeof AppToolsProductShelvesDeleteProductShelfIdRouteRoute
  '/app/tools/scheduler/details/$rdvId': typeof AppToolsSchedulerDetailsRdvIdRouteRouteWithChildren
  '/app/tools/vva/delete/$vvaId': typeof AppToolsVvaDeleteVvaIdRouteRoute
  '/app/businesses-rma/business/$businessId/': typeof AppBusinessesRmaBusinessBusinessIdIndexRoute
  '/app/businesses-rma/rma/$rmaId/': typeof AppBusinessesRmaRmaRmaIdIndexRoute
  '/app/businesses-rma/business/$businessId/arc/pdf': typeof AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/arc/update-shipping-price': typeof AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute
  '/app/businesses-rma/business/$businessId/bill/credits': typeof AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bill/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/bl/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/bl/update': typeof AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bp/travel-voucher': typeof AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/create-ged-directory': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/create-lifesheet': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/create-link': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/delete': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/import-ged-files': typeof AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/send-email': typeof AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/update-billing-address': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/update-representative': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/update-responsible': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/commercial-notice': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation/pdf': typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation/update-shipping-price': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/study/automatic': typeof AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute
  '/app/businesses-rma/business/$businessId/study/expert': typeof AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/create-detail': typeof AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/pdf': typeof AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/delivery/travel-voucher': typeof AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/create-detail': typeof AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/pdf': typeof AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support/create-detail': typeof AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/create-ged-directory': typeof AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/create-lifesheet': typeof AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/create-link': typeof AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/import-ged-files': typeof AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/pdf': typeof AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/address-book/delete/$addressId': typeof AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute
  '/app/enterprises/$enterpriseId/address-book/update/$addressId': typeof AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute
  '/app/enterprises/$enterpriseId/email-history/email/$emailId': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/reply': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/resend': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute
  '/app/enterprises/$enterpriseId/task-email/$taskId/reply': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute
  '/app/enterprises/$enterpriseId/task-email/$taskId/resend': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute
  '/app/faq/ged/$faqId/delete/$itemRelativePath': typeof AppFaqGedFaqIdDeleteItemRelativePathRouteRoute
  '/app/faq/ged/$faqId/rename/$itemRelativePath': typeof AppFaqGedFaqIdRenameItemRelativePathRouteRoute
  '/app/products/$productId/informations/lifesheet-email/$lifesheetId': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/products/$productId/informations/task-email/$taskId': typeof AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteWithChildren
  '/app/products/$productId/informations/unlink-task/$taskId': typeof AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute
  '/app/products/$productId/manage/add-specification/$filterId': typeof AppProductsProductIdManageAddSpecificationFilterIdRouteRoute
  '/app/products/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId': typeof AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute
  '/app/products/$productId/manage/delete-specification/$specificationId': typeof AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute
  '/app/products/$productId/manage/delete-stock/$stockId': typeof AppProductsProductIdManageDeleteStockStockIdRouteRoute
  '/app/products/$productId/manage/delete-version/$versionId': typeof AppProductsProductIdManageDeleteVersionVersionIdRouteRoute
  '/app/products/$productId/manage/remove-associated-product/$associatedProductId': typeof AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute
  '/app/products/$productId/manage/stock-history/$stockId': typeof AppProductsProductIdManageStockHistoryStockIdRouteRoute
  '/app/products/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId': typeof AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute
  '/app/products/$productId/manage/update-specification/$specificationId': typeof AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute
  '/app/products/$productId/manage/update-stock/$stockId': typeof AppProductsProductIdManageUpdateStockStockIdRouteRoute
  '/app/products/$productId/manage/update-version/$versionId': typeof AppProductsProductIdManageUpdateVersionVersionIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/create': typeof AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute
  '/app/tools/formations/update/$formationId/add-detail': typeof AppToolsFormationsUpdateFormationIdAddDetailRouteRoute
  '/app/tools/formations/update/$formationId/details': typeof AppToolsFormationsUpdateFormationIdDetailsRouteRoute
  '/app/tools/scheduler/details/$rdvId/delete': typeof AppToolsSchedulerDetailsRdvIdDeleteRouteRoute
  '/app/tools/scheduler/details/$rdvId/update': typeof AppToolsSchedulerDetailsRdvIdUpdateRouteRoute
  '/app/businesses-rma/business/$businessId/study/': typeof AppBusinessesRmaBusinessBusinessIdStudyIndexRoute
  '/app/businesses-rma/business/$businessId/arc/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/arc/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/arc/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bill/credits/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/bl/update/new': typeof AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute
  '/app/businesses-rma/business/$businessId/bp/add-serial/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/create-detail-rma/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/create-serial-rma/$serialId': typeof AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/delete-serial/$serialId': typeof AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book/create': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId': typeof AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/delete-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/delete-link/$associatedId': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/unlink-task/$taskId': typeof AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation/create-associated-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/create-detail/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/delete-subquotation/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/update-subquotation/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-faq': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-ged-directory': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-lifesheet': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-link': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-cumulated-time': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-no-billed-time': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-subtitle': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/import-ged-files': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/delivery/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/delete-ged-object/$relativePath': typeof AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/delete-link/$associatedId': typeof AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support/unlink-task/$taskId': typeof AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute
  '/app/enterprises/$enterpriseId/email-history/email/$emailId/reply': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute
  '/app/enterprises/$enterpriseId/email-history/email/$emailId/resend': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute
  '/app/products/$productId/informations/lifesheet-email/$lifesheetId/reply': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/products/$productId/informations/lifesheet-email/$lifesheetId/resend': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute
  '/app/products/$productId/informations/task-email/$taskId/reply': typeof AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute
  '/app/products/$productId/informations/task-email/$taskId/resend': typeof AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId': typeof AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId': typeof AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book/delete/$addressId': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book/update/$addressId': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-link/$associatedId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/reply': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/resend': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app/businesses-rma': typeof AppBusinessesRmaRouteRouteWithChildren
  '/app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/app/enterprises': typeof AppEnterprisesRouteRouteWithChildren
  '/app/external-links': typeof AppExternalLinksRouteRoute
  '/app/faq': typeof AppFaqRouteRouteWithChildren
  '/app/products': typeof AppProductsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRouteRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRouteLazyRoute
  '/app': typeof AppIndexRoute
  '/auth': typeof AuthIndexRoute
  '/app/businesses-rma/representative-turnover': typeof AppBusinessesRmaRepresentativeTurnoverRouteRoute
  '/app/businesses-rma/search-by-products': typeof AppBusinessesRmaSearchByProductsRouteRoute
  '/app/dashboard/create-collective-task': typeof AppDashboardCreateCollectiveTaskRouteRoute
  '/app/dashboard/create-personal-task': typeof AppDashboardCreatePersonalTaskRouteRoute
  '/app/dashboard/create-progressive-info': typeof AppDashboardCreateProgressiveInfoRouteRoute
  '/app/dashboard/delete-collective-tasks': typeof AppDashboardDeleteCollectiveTasksRouteRoute
  '/app/enterprises/create': typeof AppEnterprisesCreateRouteRoute
  '/app/enterprises/$enterpriseId': typeof AppEnterprisesEnterpriseIdRouteRouteWithChildren
  '/app/external-links/$externalLinkId': typeof AppExternalLinksExternalLinkIdRouteRoute
  '/app/faq/create': typeof AppFaqCreateRouteRoute
  '/app/products/create': typeof AppProductsCreateRouteRoute
  '/app/products/serial-numbers': typeof AppProductsSerialNumbersRouteRouteWithChildren
  '/app/tools/credit': typeof AppToolsCreditRouteRouteWithChildren
  '/app/tools/ddns': typeof AppToolsDdnsRouteRouteWithChildren
  '/app/tools/departments': typeof AppToolsDepartmentsRouteRouteWithChildren
  '/app/tools/emails': typeof AppToolsEmailsRouteRouteWithChildren
  '/app/tools/external-links': typeof AppToolsExternalLinksRouteRouteWithChildren
  '/app/tools/formations': typeof AppToolsFormationsRouteRouteWithChildren
  '/app/tools/global-turnover': typeof AppToolsGlobalTurnoverRouteRoute
  '/app/tools/mails': typeof AppToolsMailsRouteRouteWithChildren
  '/app/tools/menu': typeof AppToolsMenuRouteRouteWithChildren
  '/app/tools/news': typeof AppToolsNewsRouteRouteWithChildren
  '/app/tools/predefined-messages': typeof AppToolsPredefinedMessagesRouteRouteWithChildren
  '/app/tools/predefined-texts': typeof AppToolsPredefinedTextsRouteRouteWithChildren
  '/app/tools/product-filters': typeof AppToolsProductFiltersRouteRouteWithChildren
  '/app/tools/product-inventory': typeof AppToolsProductInventoryRouteRouteWithChildren
  '/app/tools/product-shelves': typeof AppToolsProductShelvesRouteRouteWithChildren
  '/app/tools/representatives-map': typeof AppToolsRepresentativesMapRouteRoute
  '/app/tools/representatives-turnover': typeof AppToolsRepresentativesTurnoverRouteRoute
  '/app/tools/scheduler': typeof AppToolsSchedulerRouteRouteWithChildren
  '/app/tools/vva': typeof AppToolsVvaRouteRouteWithChildren
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRouteLazyRoute
  '/app/tools': typeof AppToolsIndexRoute
  '/app/dashboard/archive-personal-task/$taskId': typeof AppDashboardArchivePersonalTaskTaskIdRouteRoute
  '/app/dashboard/create-aircall-contact/$number': typeof AppDashboardCreateAircallContactNumberRouteRoute
  '/app/dashboard/delete-collective-task/$taskId': typeof AppDashboardDeleteCollectiveTaskTaskIdRouteRoute
  '/app/dashboard/delete-progressive-info/$progressiveInfoId': typeof AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute
  '/app/dashboard/link-personal-task/$taskId': typeof AppDashboardLinkPersonalTaskTaskIdRouteRoute
  '/app/dashboard/other-personal-tasks/$profileId': typeof AppDashboardOtherPersonalTasksProfileIdRouteRoute
  '/app/dashboard/personal-task-details/$taskId': typeof AppDashboardPersonalTaskDetailsTaskIdRouteRoute
  '/app/dashboard/scheduler-event-details/$eventId': typeof AppDashboardSchedulerEventDetailsEventIdRouteRoute
  '/app/dashboard/take-collective-task/$taskId': typeof AppDashboardTakeCollectiveTaskTaskIdRouteRoute
  '/app/dashboard/task-comments/$taskId': typeof AppDashboardTaskCommentsTaskIdRouteRoute
  '/app/dashboard/task-email/$taskId': typeof AppDashboardTaskEmailTaskIdRouteRouteWithChildren
  '/app/dashboard/transfer-task/$taskId': typeof AppDashboardTransferTaskTaskIdRouteRoute
  '/app/dashboard/unlink-personal-task/$taskId': typeof AppDashboardUnlinkPersonalTaskTaskIdRouteRoute
  '/app/dashboard/update-aircall-contact/$contactId': typeof AppDashboardUpdateAircallContactContactIdRouteRoute
  '/app/dashboard/update-personal-task-deadline/$taskId': typeof AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute
  '/app/dashboard/update-progressive-info/$progressiveInfoId': typeof AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute
  '/app/dashboard/validate-personal-task/$taskId': typeof AppDashboardValidatePersonalTaskTaskIdRouteRoute
  '/app/enterprises/create-contact-business/$contactId': typeof AppEnterprisesCreateContactBusinessContactIdRouteRoute
  '/app/enterprises/create-contact-travel-voucher/$contactId': typeof AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute
  '/app/enterprises/create-contact/$enterpriseId': typeof AppEnterprisesCreateContactEnterpriseIdRouteRoute
  '/app/enterprises/create-enterprise-rma/$enterpriseId': typeof AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute
  '/app/enterprises/delete-contact/$contactId': typeof AppEnterprisesDeleteContactContactIdRouteRoute
  '/app/enterprises/send-email-to-contact/$contactId': typeof AppEnterprisesSendEmailToContactContactIdRouteRoute
  '/app/enterprises/update-contact-password/$contactId': typeof AppEnterprisesUpdateContactPasswordContactIdRouteRoute
  '/app/enterprises/update-contact/$contactId': typeof AppEnterprisesUpdateContactContactIdRouteRoute
  '/app/enterprises/$enterpriseId/address-book': typeof AppEnterprisesEnterpriseIdAddressBookRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/create-contact': typeof AppEnterprisesEnterpriseIdCreateContactRouteRoute
  '/app/enterprises/$enterpriseId/create-ged-directory': typeof AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute
  '/app/enterprises/$enterpriseId/create-lifesheet-comment': typeof AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute
  '/app/enterprises/$enterpriseId/delete': typeof AppEnterprisesEnterpriseIdDeleteRouteRoute
  '/app/enterprises/$enterpriseId/email-history': typeof AppEnterprisesEnterpriseIdEmailHistoryRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/import-contacts': typeof AppEnterprisesEnterpriseIdImportContactsRouteRoute
  '/app/enterprises/$enterpriseId/import-ged-files': typeof AppEnterprisesEnterpriseIdImportGedFilesRouteRoute
  '/app/enterprises/$enterpriseId/relate-business-rma': typeof AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute
  '/app/enterprises/$enterpriseId/update': typeof AppEnterprisesEnterpriseIdUpdateRouteRoute
  '/app/enterprises/$enterpriseId/update-accountability': typeof AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute
  '/app/enterprises/$enterpriseId/update-category': typeof AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute
  '/app/enterprises/$enterpriseId/update-representative': typeof AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute
  '/app/faq/archive/$faqId': typeof AppFaqArchiveFaqIdRouteRoute
  '/app/faq/delete/$faqId': typeof AppFaqDeleteFaqIdRouteRoute
  '/app/faq/ged/$faqId': typeof AppFaqGedFaqIdRouteRouteWithChildren
  '/app/faq/send-by-email/$faqId': typeof AppFaqSendByEmailFaqIdRouteRoute
  '/app/faq/update/$faqId': typeof AppFaqUpdateFaqIdRouteRoute
  '/app/products/serial-numbers/create': typeof AppProductsSerialNumbersCreateRouteRoute
  '/app/products/$productId/informations': typeof AppProductsProductIdInformationsRouteRouteWithChildren
  '/app/products/$productId/manage': typeof AppProductsProductIdManageRouteRouteWithChildren
  '/app/tools/credit/details': typeof AppToolsCreditDetailsRouteRoute
  '/app/tools/credit/show': typeof AppToolsCreditShowRouteRoute
  '/app/tools/ddns/create': typeof AppToolsDdnsCreateRouteRoute
  '/app/tools/departments/create': typeof AppToolsDepartmentsCreateRouteRoute
  '/app/tools/emails/$emailId': typeof AppToolsEmailsEmailIdRouteRouteWithChildren
  '/app/tools/external-links/create': typeof AppToolsExternalLinksCreateRouteRoute
  '/app/tools/formations/create': typeof AppToolsFormationsCreateRouteRouteWithChildren
  '/app/tools/mails/create': typeof AppToolsMailsCreateRouteRoute
  '/app/tools/menu/create-enterprise': typeof AppToolsMenuCreateEnterpriseRouteRoute
  '/app/tools/menu/create-product': typeof AppToolsMenuCreateProductRouteRoute
  '/app/tools/news/create': typeof AppToolsNewsCreateRouteRoute
  '/app/tools/predefined-messages/create': typeof AppToolsPredefinedMessagesCreateRouteRoute
  '/app/tools/predefined-texts/create': typeof AppToolsPredefinedTextsCreateRouteRoute
  '/app/tools/product-filters/create': typeof AppToolsProductFiltersCreateRouteRoute
  '/app/tools/product-inventory/validate-quantities': typeof AppToolsProductInventoryValidateQuantitiesRouteRoute
  '/app/tools/product-shelves/create': typeof AppToolsProductShelvesCreateRouteRoute
  '/app/tools/scheduler/create': typeof AppToolsSchedulerCreateRouteRoute
  '/app/tools/vva/create': typeof AppToolsVvaCreateRouteRoute
  '/app/products/$productId': typeof AppProductsProductIdIndexRoute
  '/app/businesses-rma/business/$businessId/arc': typeof AppBusinessesRmaBusinessBusinessIdArcRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bill': typeof AppBusinessesRmaBusinessBusinessIdBillRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bl': typeof AppBusinessesRmaBusinessBusinessIdBlRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bp': typeof AppBusinessesRmaBusinessBusinessIdBpRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard': typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation': typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/delivery': typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/reception': typeof AppBusinessesRmaRmaRmaIdReceptionRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support': typeof AppBusinessesRmaRmaRmaIdSupportRouteRouteWithChildren
  '/app/dashboard/task-email/$taskId/reply': typeof AppDashboardTaskEmailTaskIdReplyRouteRoute
  '/app/dashboard/task-email/$taskId/resend': typeof AppDashboardTaskEmailTaskIdResendRouteRoute
  '/app/enterprises/$enterpriseId/address-book/create': typeof AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute
  '/app/enterprises/$enterpriseId/address-book/import': typeof AppEnterprisesEnterpriseIdAddressBookImportRouteRoute
  '/app/enterprises/$enterpriseId/create-contact-business/$contactId': typeof AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute
  '/app/enterprises/$enterpriseId/delete-contact/$contactId': typeof AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute
  '/app/enterprises/$enterpriseId/delete-ged-object/$objectRelativePath': typeof AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute
  '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/rename-ged-object/$objectRelativePath': typeof AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute
  '/app/enterprises/$enterpriseId/send-email-to-contact/$contactId': typeof AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute
  '/app/enterprises/$enterpriseId/task-email/$taskId': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/unlink-task/$taskId': typeof AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute
  '/app/enterprises/$enterpriseId/unrelate-business-rma/$businessRmaId': typeof AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute
  '/app/enterprises/$enterpriseId/update-contact-password/$contactId': typeof AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute
  '/app/enterprises/$enterpriseId/update-contact/$contactId': typeof AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute
  '/app/faq/ged/$faqId/create-directory': typeof AppFaqGedFaqIdCreateDirectoryRouteRoute
  '/app/faq/ged/$faqId/import-files': typeof AppFaqGedFaqIdImportFilesRouteRoute
  '/app/products/serial-numbers/create-rma/$serialNumberId': typeof AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute
  '/app/products/serial-numbers/delete/$serialNumberId': typeof AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute
  '/app/products/serial-numbers/remove-from-business/$serialNumberId': typeof AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute
  '/app/products/serial-numbers/update/$serialNumberId': typeof AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute
  '/app/products/$productId/informations/create-ged-directory': typeof AppProductsProductIdInformationsCreateGedDirectoryRouteRoute
  '/app/products/$productId/informations/create-lifesheet-comment': typeof AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute
  '/app/products/$productId/informations/delete-ged-object': typeof AppProductsProductIdInformationsDeleteGedObjectRouteRoute
  '/app/products/$productId/informations/import-ged-files': typeof AppProductsProductIdInformationsImportGedFilesRouteRoute
  '/app/products/$productId/informations/rename-ged-object': typeof AppProductsProductIdInformationsRenameGedObjectRouteRoute
  '/app/products/$productId/manage/add-associated-product': typeof AppProductsProductIdManageAddAssociatedProductRouteRoute
  '/app/products/$productId/manage/add-nomenclature-detail': typeof AppProductsProductIdManageAddNomenclatureDetailRouteRoute
  '/app/products/$productId/manage/add-specification': typeof AppProductsProductIdManageAddSpecificationRouteRouteWithChildren
  '/app/products/$productId/manage/create-stock': typeof AppProductsProductIdManageCreateStockRouteRoute
  '/app/products/$productId/manage/create-version': typeof AppProductsProductIdManageCreateVersionRouteRoute
  '/app/tools/ddns/delete/$ddnsId': typeof AppToolsDdnsDeleteDdnsIdRouteRoute
  '/app/tools/departments/delete/$departmentId': typeof AppToolsDepartmentsDeleteDepartmentIdRouteRoute
  '/app/tools/departments/update/$departmentId': typeof AppToolsDepartmentsUpdateDepartmentIdRouteRoute
  '/app/tools/emails/$emailId/reply': typeof AppToolsEmailsEmailIdReplyRouteRoute
  '/app/tools/emails/$emailId/resend': typeof AppToolsEmailsEmailIdResendRouteRoute
  '/app/tools/external-links/archive/$externalLinkId': typeof AppToolsExternalLinksArchiveExternalLinkIdRouteRoute
  '/app/tools/external-links/delete/$externalLinkId': typeof AppToolsExternalLinksDeleteExternalLinkIdRouteRoute
  '/app/tools/external-links/update/$externalLinkId': typeof AppToolsExternalLinksUpdateExternalLinkIdRouteRoute
  '/app/tools/formations/create/add-detail': typeof AppToolsFormationsCreateAddDetailRouteRoute
  '/app/tools/formations/create/details': typeof AppToolsFormationsCreateDetailsRouteRoute
  '/app/tools/formations/delete/$formationId': typeof AppToolsFormationsDeleteFormationIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId': typeof AppToolsFormationsSubscribersFormationDetailIdRouteRouteWithChildren
  '/app/tools/formations/update/$formationId': typeof AppToolsFormationsUpdateFormationIdRouteRouteWithChildren
  '/app/tools/mails/delete/$mailId': typeof AppToolsMailsDeleteMailIdRouteRoute
  '/app/tools/mails/show/$mailId': typeof AppToolsMailsShowMailIdRouteRoute
  '/app/tools/mails/update/$mailId': typeof AppToolsMailsUpdateMailIdRouteRoute
  '/app/tools/news/delete/$newsId': typeof AppToolsNewsDeleteNewsIdRouteRoute
  '/app/tools/news/update/$newsId': typeof AppToolsNewsUpdateNewsIdRouteRoute
  '/app/tools/predefined-messages/delete/$predefinedMessageId': typeof AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute
  '/app/tools/predefined-messages/update/$predefinedMessageId': typeof AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute
  '/app/tools/predefined-texts/delete/$predefinedTextId': typeof AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute
  '/app/tools/predefined-texts/update/$predefinedTextId': typeof AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute
  '/app/tools/product-filters/delete/$productFilterId': typeof AppToolsProductFiltersDeleteProductFilterIdRouteRoute
  '/app/tools/product-filters/update/$productFilterId': typeof AppToolsProductFiltersUpdateProductFilterIdRouteRoute
  '/app/tools/product-inventory/update/$stockId': typeof AppToolsProductInventoryUpdateStockIdRouteRoute
  '/app/tools/product-shelves/delete/$productShelfId': typeof AppToolsProductShelvesDeleteProductShelfIdRouteRoute
  '/app/tools/scheduler/details/$rdvId': typeof AppToolsSchedulerDetailsRdvIdRouteRouteWithChildren
  '/app/tools/vva/delete/$vvaId': typeof AppToolsVvaDeleteVvaIdRouteRoute
  '/app/businesses-rma/business/$businessId': typeof AppBusinessesRmaBusinessBusinessIdIndexRoute
  '/app/businesses-rma/rma/$rmaId': typeof AppBusinessesRmaRmaRmaIdIndexRoute
  '/app/businesses-rma/business/$businessId/arc/pdf': typeof AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/arc/update-shipping-price': typeof AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute
  '/app/businesses-rma/business/$businessId/bill/credits': typeof AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bill/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/bl/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/bl/update': typeof AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/bp/travel-voucher': typeof AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/create-ged-directory': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/create-lifesheet': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/create-link': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/delete': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/import-ged-files': typeof AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/send-email': typeof AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/update-billing-address': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/update-representative': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/update-responsible': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/commercial-notice': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation/pdf': typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation/update-shipping-price': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/study/automatic': typeof AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute
  '/app/businesses-rma/business/$businessId/study/expert': typeof AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/create-detail': typeof AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/pdf': typeof AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/delivery/travel-voucher': typeof AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/create-detail': typeof AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/pdf': typeof AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support/create-detail': typeof AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/create-ged-directory': typeof AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/create-lifesheet': typeof AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/create-link': typeof AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/import-ged-files': typeof AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/pdf': typeof AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/address-book/delete/$addressId': typeof AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute
  '/app/enterprises/$enterpriseId/address-book/update/$addressId': typeof AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute
  '/app/enterprises/$enterpriseId/email-history/email/$emailId': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteWithChildren
  '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/reply': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/resend': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute
  '/app/enterprises/$enterpriseId/task-email/$taskId/reply': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute
  '/app/enterprises/$enterpriseId/task-email/$taskId/resend': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute
  '/app/faq/ged/$faqId/delete/$itemRelativePath': typeof AppFaqGedFaqIdDeleteItemRelativePathRouteRoute
  '/app/faq/ged/$faqId/rename/$itemRelativePath': typeof AppFaqGedFaqIdRenameItemRelativePathRouteRoute
  '/app/products/$productId/informations/lifesheet-email/$lifesheetId': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/products/$productId/informations/task-email/$taskId': typeof AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteWithChildren
  '/app/products/$productId/informations/unlink-task/$taskId': typeof AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute
  '/app/products/$productId/manage/add-specification/$filterId': typeof AppProductsProductIdManageAddSpecificationFilterIdRouteRoute
  '/app/products/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId': typeof AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute
  '/app/products/$productId/manage/delete-specification/$specificationId': typeof AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute
  '/app/products/$productId/manage/delete-stock/$stockId': typeof AppProductsProductIdManageDeleteStockStockIdRouteRoute
  '/app/products/$productId/manage/delete-version/$versionId': typeof AppProductsProductIdManageDeleteVersionVersionIdRouteRoute
  '/app/products/$productId/manage/remove-associated-product/$associatedProductId': typeof AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute
  '/app/products/$productId/manage/stock-history/$stockId': typeof AppProductsProductIdManageStockHistoryStockIdRouteRoute
  '/app/products/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId': typeof AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute
  '/app/products/$productId/manage/update-specification/$specificationId': typeof AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute
  '/app/products/$productId/manage/update-stock/$stockId': typeof AppProductsProductIdManageUpdateStockStockIdRouteRoute
  '/app/products/$productId/manage/update-version/$versionId': typeof AppProductsProductIdManageUpdateVersionVersionIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/create': typeof AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute
  '/app/tools/formations/update/$formationId/add-detail': typeof AppToolsFormationsUpdateFormationIdAddDetailRouteRoute
  '/app/tools/formations/update/$formationId/details': typeof AppToolsFormationsUpdateFormationIdDetailsRouteRoute
  '/app/tools/scheduler/details/$rdvId/delete': typeof AppToolsSchedulerDetailsRdvIdDeleteRouteRoute
  '/app/tools/scheduler/details/$rdvId/update': typeof AppToolsSchedulerDetailsRdvIdUpdateRouteRoute
  '/app/businesses-rma/business/$businessId/study': typeof AppBusinessesRmaBusinessBusinessIdStudyIndexRoute
  '/app/businesses-rma/business/$businessId/arc/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/arc/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/arc/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bill/credits/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/bl/update/new': typeof AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute
  '/app/businesses-rma/business/$businessId/bp/add-serial/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/create-detail-rma/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/create-serial-rma/$serialId': typeof AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/delete-serial/$serialId': typeof AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute
  '/app/businesses-rma/business/$businessId/bp/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book/create': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId': typeof AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/delete-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/delete-link/$associatedId': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/dashboard/unlink-task/$taskId': typeof AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/quotation/create-associated-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/create-detail/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/delete-subquotation/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/update-subquotation/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-faq': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-ged-directory': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-lifesheet': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-link': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-cumulated-time': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-no-billed-time': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-subtitle': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/import-ged-files': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/delivery/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute
  '/app/businesses-rma/rma/$rmaId/delivery/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute
  '/app/businesses-rma/rma/$rmaId/reception/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/delete-ged-object/$relativePath': typeof AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/delete-link/$associatedId': typeof AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteWithChildren
  '/app/businesses-rma/rma/$rmaId/support/unlink-task/$taskId': typeof AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute
  '/app/enterprises/$enterpriseId/email-history/email/$emailId/reply': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute
  '/app/enterprises/$enterpriseId/email-history/email/$emailId/resend': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute
  '/app/products/$productId/informations/lifesheet-email/$lifesheetId/reply': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/products/$productId/informations/lifesheet-email/$lifesheetId/resend': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute
  '/app/products/$productId/informations/task-email/$taskId/reply': typeof AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute
  '/app/products/$productId/informations/task-email/$taskId/resend': typeof AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId': typeof AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId': typeof AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book/delete/$addressId': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/address-book/update/$addressId': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-link/$associatedId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/reply': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute
  '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/resend': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/app/businesses-rma': typeof AppBusinessesRmaRouteRouteWithChildren
  '/app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/app/enterprises': typeof AppEnterprisesRouteRouteWithChildren
  '/app/external-links': typeof AppExternalLinksRouteRoute
  '/app/faq': typeof AppFaqRouteRouteWithChildren
  '/app/products': typeof AppProductsRouteRouteWithChildren
  '/app/tools': typeof AppToolsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRouteRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRouteLazyRoute
  '/app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/app/businesses-rma/representative-turnover': typeof AppBusinessesRmaRepresentativeTurnoverRouteRoute
  '/app/businesses-rma/search-by-products': typeof AppBusinessesRmaSearchByProductsRouteRoute
  '/app/dashboard/create-collective-task': typeof AppDashboardCreateCollectiveTaskRouteRoute
  '/app/dashboard/create-personal-task': typeof AppDashboardCreatePersonalTaskRouteRoute
  '/app/dashboard/create-progressive-info': typeof AppDashboardCreateProgressiveInfoRouteRoute
  '/app/dashboard/delete-collective-tasks': typeof AppDashboardDeleteCollectiveTasksRouteRoute
  '/app/enterprises/create': typeof AppEnterprisesCreateRouteRoute
  '/app/enterprises_/$enterpriseId': typeof AppEnterprisesEnterpriseIdRouteRouteWithChildren
  '/app/external-links_/$externalLinkId': typeof AppExternalLinksExternalLinkIdRouteRoute
  '/app/faq/create': typeof AppFaqCreateRouteRoute
  '/app/products/create': typeof AppProductsCreateRouteRoute
  '/app/products/serial-numbers': typeof AppProductsSerialNumbersRouteRouteWithChildren
  '/app/products_/$productId': typeof AppProductsProductIdRouteRouteWithChildren
  '/app/tools/credit': typeof AppToolsCreditRouteRouteWithChildren
  '/app/tools/ddns': typeof AppToolsDdnsRouteRouteWithChildren
  '/app/tools/departments': typeof AppToolsDepartmentsRouteRouteWithChildren
  '/app/tools/emails': typeof AppToolsEmailsRouteRouteWithChildren
  '/app/tools/external-links': typeof AppToolsExternalLinksRouteRouteWithChildren
  '/app/tools/formations': typeof AppToolsFormationsRouteRouteWithChildren
  '/app/tools/global-turnover': typeof AppToolsGlobalTurnoverRouteRoute
  '/app/tools/mails': typeof AppToolsMailsRouteRouteWithChildren
  '/app/tools/menu': typeof AppToolsMenuRouteRouteWithChildren
  '/app/tools/news': typeof AppToolsNewsRouteRouteWithChildren
  '/app/tools/predefined-messages': typeof AppToolsPredefinedMessagesRouteRouteWithChildren
  '/app/tools/predefined-texts': typeof AppToolsPredefinedTextsRouteRouteWithChildren
  '/app/tools/product-filters': typeof AppToolsProductFiltersRouteRouteWithChildren
  '/app/tools/product-inventory': typeof AppToolsProductInventoryRouteRouteWithChildren
  '/app/tools/product-shelves': typeof AppToolsProductShelvesRouteRouteWithChildren
  '/app/tools/representatives-map': typeof AppToolsRepresentativesMapRouteRoute
  '/app/tools/representatives-turnover': typeof AppToolsRepresentativesTurnoverRouteRoute
  '/app/tools/scheduler': typeof AppToolsSchedulerRouteRouteWithChildren
  '/app/tools/vva': typeof AppToolsVvaRouteRouteWithChildren
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRouteLazyRoute
  '/app/tools/': typeof AppToolsIndexRoute
  '/app/businesses-rma_/business/$businessId': typeof AppBusinessesRmaBusinessBusinessIdRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId': typeof AppBusinessesRmaRmaRmaIdRouteRouteWithChildren
  '/app/dashboard/archive-personal-task/$taskId': typeof AppDashboardArchivePersonalTaskTaskIdRouteRoute
  '/app/dashboard/create-aircall-contact/$number': typeof AppDashboardCreateAircallContactNumberRouteRoute
  '/app/dashboard/delete-collective-task/$taskId': typeof AppDashboardDeleteCollectiveTaskTaskIdRouteRoute
  '/app/dashboard/delete-progressive-info/$progressiveInfoId': typeof AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute
  '/app/dashboard/link-personal-task/$taskId': typeof AppDashboardLinkPersonalTaskTaskIdRouteRoute
  '/app/dashboard/other-personal-tasks/$profileId': typeof AppDashboardOtherPersonalTasksProfileIdRouteRoute
  '/app/dashboard/personal-task-details/$taskId': typeof AppDashboardPersonalTaskDetailsTaskIdRouteRoute
  '/app/dashboard/scheduler-event-details/$eventId': typeof AppDashboardSchedulerEventDetailsEventIdRouteRoute
  '/app/dashboard/take-collective-task/$taskId': typeof AppDashboardTakeCollectiveTaskTaskIdRouteRoute
  '/app/dashboard/task-comments/$taskId': typeof AppDashboardTaskCommentsTaskIdRouteRoute
  '/app/dashboard/task-email/$taskId': typeof AppDashboardTaskEmailTaskIdRouteRouteWithChildren
  '/app/dashboard/transfer-task/$taskId': typeof AppDashboardTransferTaskTaskIdRouteRoute
  '/app/dashboard/unlink-personal-task/$taskId': typeof AppDashboardUnlinkPersonalTaskTaskIdRouteRoute
  '/app/dashboard/update-aircall-contact/$contactId': typeof AppDashboardUpdateAircallContactContactIdRouteRoute
  '/app/dashboard/update-personal-task-deadline/$taskId': typeof AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute
  '/app/dashboard/update-progressive-info/$progressiveInfoId': typeof AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute
  '/app/dashboard/validate-personal-task/$taskId': typeof AppDashboardValidatePersonalTaskTaskIdRouteRoute
  '/app/enterprises/create-contact-business/$contactId': typeof AppEnterprisesCreateContactBusinessContactIdRouteRoute
  '/app/enterprises/create-contact-travel-voucher/$contactId': typeof AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute
  '/app/enterprises/create-contact/$enterpriseId': typeof AppEnterprisesCreateContactEnterpriseIdRouteRoute
  '/app/enterprises/create-enterprise-rma/$enterpriseId': typeof AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute
  '/app/enterprises/delete-contact/$contactId': typeof AppEnterprisesDeleteContactContactIdRouteRoute
  '/app/enterprises/send-email-to-contact/$contactId': typeof AppEnterprisesSendEmailToContactContactIdRouteRoute
  '/app/enterprises/update-contact-password/$contactId': typeof AppEnterprisesUpdateContactPasswordContactIdRouteRoute
  '/app/enterprises/update-contact/$contactId': typeof AppEnterprisesUpdateContactContactIdRouteRoute
  '/app/enterprises_/$enterpriseId/address-book': typeof AppEnterprisesEnterpriseIdAddressBookRouteRouteWithChildren
  '/app/enterprises_/$enterpriseId/create-contact': typeof AppEnterprisesEnterpriseIdCreateContactRouteRoute
  '/app/enterprises_/$enterpriseId/create-ged-directory': typeof AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute
  '/app/enterprises_/$enterpriseId/create-lifesheet-comment': typeof AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute
  '/app/enterprises_/$enterpriseId/delete': typeof AppEnterprisesEnterpriseIdDeleteRouteRoute
  '/app/enterprises_/$enterpriseId/email-history': typeof AppEnterprisesEnterpriseIdEmailHistoryRouteRouteWithChildren
  '/app/enterprises_/$enterpriseId/import-contacts': typeof AppEnterprisesEnterpriseIdImportContactsRouteRoute
  '/app/enterprises_/$enterpriseId/import-ged-files': typeof AppEnterprisesEnterpriseIdImportGedFilesRouteRoute
  '/app/enterprises_/$enterpriseId/relate-business-rma': typeof AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute
  '/app/enterprises_/$enterpriseId/update': typeof AppEnterprisesEnterpriseIdUpdateRouteRoute
  '/app/enterprises_/$enterpriseId/update-accountability': typeof AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute
  '/app/enterprises_/$enterpriseId/update-category': typeof AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute
  '/app/enterprises_/$enterpriseId/update-representative': typeof AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute
  '/app/faq/archive/$faqId': typeof AppFaqArchiveFaqIdRouteRoute
  '/app/faq/delete/$faqId': typeof AppFaqDeleteFaqIdRouteRoute
  '/app/faq/ged/$faqId': typeof AppFaqGedFaqIdRouteRouteWithChildren
  '/app/faq/send-by-email/$faqId': typeof AppFaqSendByEmailFaqIdRouteRoute
  '/app/faq/update/$faqId': typeof AppFaqUpdateFaqIdRouteRoute
  '/app/products/serial-numbers/create': typeof AppProductsSerialNumbersCreateRouteRoute
  '/app/products_/$productId/informations': typeof AppProductsProductIdInformationsRouteRouteWithChildren
  '/app/products_/$productId/manage': typeof AppProductsProductIdManageRouteRouteWithChildren
  '/app/tools/credit/details': typeof AppToolsCreditDetailsRouteRoute
  '/app/tools/credit/show': typeof AppToolsCreditShowRouteRoute
  '/app/tools/ddns/create': typeof AppToolsDdnsCreateRouteRoute
  '/app/tools/departments/create': typeof AppToolsDepartmentsCreateRouteRoute
  '/app/tools/emails/$emailId': typeof AppToolsEmailsEmailIdRouteRouteWithChildren
  '/app/tools/external-links/create': typeof AppToolsExternalLinksCreateRouteRoute
  '/app/tools/formations/create': typeof AppToolsFormationsCreateRouteRouteWithChildren
  '/app/tools/mails/create': typeof AppToolsMailsCreateRouteRoute
  '/app/tools/menu/create-enterprise': typeof AppToolsMenuCreateEnterpriseRouteRoute
  '/app/tools/menu/create-product': typeof AppToolsMenuCreateProductRouteRoute
  '/app/tools/news/create': typeof AppToolsNewsCreateRouteRoute
  '/app/tools/predefined-messages/create': typeof AppToolsPredefinedMessagesCreateRouteRoute
  '/app/tools/predefined-texts/create': typeof AppToolsPredefinedTextsCreateRouteRoute
  '/app/tools/product-filters/create': typeof AppToolsProductFiltersCreateRouteRoute
  '/app/tools/product-inventory/validate-quantities': typeof AppToolsProductInventoryValidateQuantitiesRouteRoute
  '/app/tools/product-shelves/create': typeof AppToolsProductShelvesCreateRouteRoute
  '/app/tools/scheduler/create': typeof AppToolsSchedulerCreateRouteRoute
  '/app/tools/vva/create': typeof AppToolsVvaCreateRouteRoute
  '/app/products_/$productId/': typeof AppProductsProductIdIndexRoute
  '/app/businesses-rma_/business/$businessId/arc': typeof AppBusinessesRmaBusinessBusinessIdArcRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/bill': typeof AppBusinessesRmaBusinessBusinessIdBillRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/bl': typeof AppBusinessesRmaBusinessBusinessIdBlRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/bp': typeof AppBusinessesRmaBusinessBusinessIdBpRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/dashboard': typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/quotation': typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId_/study': typeof AppBusinessesRmaBusinessBusinessIdStudyRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/delivery': typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/reception': typeof AppBusinessesRmaRmaRmaIdReceptionRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/support': typeof AppBusinessesRmaRmaRmaIdSupportRouteRouteWithChildren
  '/app/dashboard/task-email/$taskId/reply': typeof AppDashboardTaskEmailTaskIdReplyRouteRoute
  '/app/dashboard/task-email/$taskId/resend': typeof AppDashboardTaskEmailTaskIdResendRouteRoute
  '/app/enterprises_/$enterpriseId/address-book/create': typeof AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute
  '/app/enterprises_/$enterpriseId/address-book/import': typeof AppEnterprisesEnterpriseIdAddressBookImportRouteRoute
  '/app/enterprises_/$enterpriseId/create-contact-business/$contactId': typeof AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute
  '/app/enterprises_/$enterpriseId/delete-contact/$contactId': typeof AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute
  '/app/enterprises_/$enterpriseId/delete-ged-object/$objectRelativePath': typeof AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute
  '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/enterprises_/$enterpriseId/rename-ged-object/$objectRelativePath': typeof AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute
  '/app/enterprises_/$enterpriseId/send-email-to-contact/$contactId': typeof AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute
  '/app/enterprises_/$enterpriseId/task-email/$taskId': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteWithChildren
  '/app/enterprises_/$enterpriseId/unlink-task/$taskId': typeof AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute
  '/app/enterprises_/$enterpriseId/unrelate-business-rma/$businessRmaId': typeof AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute
  '/app/enterprises_/$enterpriseId/update-contact-password/$contactId': typeof AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute
  '/app/enterprises_/$enterpriseId/update-contact/$contactId': typeof AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute
  '/app/faq/ged/$faqId/create-directory': typeof AppFaqGedFaqIdCreateDirectoryRouteRoute
  '/app/faq/ged/$faqId/import-files': typeof AppFaqGedFaqIdImportFilesRouteRoute
  '/app/products/serial-numbers/create-rma/$serialNumberId': typeof AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute
  '/app/products/serial-numbers/delete/$serialNumberId': typeof AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute
  '/app/products/serial-numbers/remove-from-business/$serialNumberId': typeof AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute
  '/app/products/serial-numbers/update/$serialNumberId': typeof AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute
  '/app/products_/$productId/informations/create-ged-directory': typeof AppProductsProductIdInformationsCreateGedDirectoryRouteRoute
  '/app/products_/$productId/informations/create-lifesheet-comment': typeof AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute
  '/app/products_/$productId/informations/delete-ged-object': typeof AppProductsProductIdInformationsDeleteGedObjectRouteRoute
  '/app/products_/$productId/informations/import-ged-files': typeof AppProductsProductIdInformationsImportGedFilesRouteRoute
  '/app/products_/$productId/informations/rename-ged-object': typeof AppProductsProductIdInformationsRenameGedObjectRouteRoute
  '/app/products_/$productId/manage/add-associated-product': typeof AppProductsProductIdManageAddAssociatedProductRouteRoute
  '/app/products_/$productId/manage/add-nomenclature-detail': typeof AppProductsProductIdManageAddNomenclatureDetailRouteRoute
  '/app/products_/$productId/manage/add-specification': typeof AppProductsProductIdManageAddSpecificationRouteRouteWithChildren
  '/app/products_/$productId/manage/create-stock': typeof AppProductsProductIdManageCreateStockRouteRoute
  '/app/products_/$productId/manage/create-version': typeof AppProductsProductIdManageCreateVersionRouteRoute
  '/app/tools/ddns/delete/$ddnsId': typeof AppToolsDdnsDeleteDdnsIdRouteRoute
  '/app/tools/departments/delete/$departmentId': typeof AppToolsDepartmentsDeleteDepartmentIdRouteRoute
  '/app/tools/departments/update/$departmentId': typeof AppToolsDepartmentsUpdateDepartmentIdRouteRoute
  '/app/tools/emails/$emailId/reply': typeof AppToolsEmailsEmailIdReplyRouteRoute
  '/app/tools/emails/$emailId/resend': typeof AppToolsEmailsEmailIdResendRouteRoute
  '/app/tools/external-links/archive/$externalLinkId': typeof AppToolsExternalLinksArchiveExternalLinkIdRouteRoute
  '/app/tools/external-links/delete/$externalLinkId': typeof AppToolsExternalLinksDeleteExternalLinkIdRouteRoute
  '/app/tools/external-links/update/$externalLinkId': typeof AppToolsExternalLinksUpdateExternalLinkIdRouteRoute
  '/app/tools/formations/create/add-detail': typeof AppToolsFormationsCreateAddDetailRouteRoute
  '/app/tools/formations/create/details': typeof AppToolsFormationsCreateDetailsRouteRoute
  '/app/tools/formations/delete/$formationId': typeof AppToolsFormationsDeleteFormationIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId': typeof AppToolsFormationsSubscribersFormationDetailIdRouteRouteWithChildren
  '/app/tools/formations/update/$formationId': typeof AppToolsFormationsUpdateFormationIdRouteRouteWithChildren
  '/app/tools/mails/delete/$mailId': typeof AppToolsMailsDeleteMailIdRouteRoute
  '/app/tools/mails/show/$mailId': typeof AppToolsMailsShowMailIdRouteRoute
  '/app/tools/mails/update/$mailId': typeof AppToolsMailsUpdateMailIdRouteRoute
  '/app/tools/news/delete/$newsId': typeof AppToolsNewsDeleteNewsIdRouteRoute
  '/app/tools/news/update/$newsId': typeof AppToolsNewsUpdateNewsIdRouteRoute
  '/app/tools/predefined-messages/delete/$predefinedMessageId': typeof AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute
  '/app/tools/predefined-messages/update/$predefinedMessageId': typeof AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute
  '/app/tools/predefined-texts/delete/$predefinedTextId': typeof AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute
  '/app/tools/predefined-texts/update/$predefinedTextId': typeof AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute
  '/app/tools/product-filters/delete/$productFilterId': typeof AppToolsProductFiltersDeleteProductFilterIdRouteRoute
  '/app/tools/product-filters/update/$productFilterId': typeof AppToolsProductFiltersUpdateProductFilterIdRouteRoute
  '/app/tools/product-inventory/update/$stockId': typeof AppToolsProductInventoryUpdateStockIdRouteRoute
  '/app/tools/product-shelves/delete/$productShelfId': typeof AppToolsProductShelvesDeleteProductShelfIdRouteRoute
  '/app/tools/scheduler/details/$rdvId': typeof AppToolsSchedulerDetailsRdvIdRouteRouteWithChildren
  '/app/tools/vva/delete/$vvaId': typeof AppToolsVvaDeleteVvaIdRouteRoute
  '/app/businesses-rma_/business/$businessId/': typeof AppBusinessesRmaBusinessBusinessIdIndexRoute
  '/app/businesses-rma_/rma/$rmaId/': typeof AppBusinessesRmaRmaRmaIdIndexRoute
  '/app/businesses-rma_/business/$businessId/arc/pdf': typeof AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/arc/update-shipping-price': typeof AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute
  '/app/businesses-rma_/business/$businessId/bill/credits': typeof AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/bill/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute
  '/app/businesses-rma_/business/$businessId/bl/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute
  '/app/businesses-rma_/business/$businessId/bl/update': typeof AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/bp/travel-voucher': typeof AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/address-book': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/dashboard/create-ged-directory': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/create-lifesheet': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/create-link': typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/delete': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/email-history': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/dashboard/import-ged-files': typeof AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/send-email': typeof AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/update-billing-address': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/update-representative': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/update-responsible': typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/commercial-notice': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/quotation/pdf': typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/quotation/update-shipping-price': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId_/study/automatic': typeof AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute
  '/app/businesses-rma_/business/$businessId_/study/expert': typeof AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute
  '/app/businesses-rma_/rma/$rmaId/delivery/create-detail': typeof AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute
  '/app/businesses-rma_/rma/$rmaId/delivery/pdf': typeof AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/delivery/travel-voucher': typeof AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute
  '/app/businesses-rma_/rma/$rmaId/reception/create-detail': typeof AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute
  '/app/businesses-rma_/rma/$rmaId/reception/pdf': typeof AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/support/create-detail': typeof AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/create-ged-directory': typeof AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/create-lifesheet': typeof AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/create-link': typeof AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/import-ged-files': typeof AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/pdf': typeof AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteWithChildren
  '/app/enterprises_/$enterpriseId/address-book/delete/$addressId': typeof AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute
  '/app/enterprises_/$enterpriseId/address-book/update/$addressId': typeof AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute
  '/app/enterprises_/$enterpriseId/email-history/email/$emailId': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteWithChildren
  '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/reply': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/resend': typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute
  '/app/enterprises_/$enterpriseId/task-email/$taskId/reply': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute
  '/app/enterprises_/$enterpriseId/task-email/$taskId/resend': typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute
  '/app/faq/ged/$faqId/delete/$itemRelativePath': typeof AppFaqGedFaqIdDeleteItemRelativePathRouteRoute
  '/app/faq/ged/$faqId/rename/$itemRelativePath': typeof AppFaqGedFaqIdRenameItemRelativePathRouteRoute
  '/app/products_/$productId/informations/lifesheet-email/$lifesheetId': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/products_/$productId/informations/task-email/$taskId': typeof AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteWithChildren
  '/app/products_/$productId/informations/unlink-task/$taskId': typeof AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute
  '/app/products_/$productId/manage/add-specification/$filterId': typeof AppProductsProductIdManageAddSpecificationFilterIdRouteRoute
  '/app/products_/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId': typeof AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute
  '/app/products_/$productId/manage/delete-specification/$specificationId': typeof AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute
  '/app/products_/$productId/manage/delete-stock/$stockId': typeof AppProductsProductIdManageDeleteStockStockIdRouteRoute
  '/app/products_/$productId/manage/delete-version/$versionId': typeof AppProductsProductIdManageDeleteVersionVersionIdRouteRoute
  '/app/products_/$productId/manage/remove-associated-product/$associatedProductId': typeof AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute
  '/app/products_/$productId/manage/stock-history/$stockId': typeof AppProductsProductIdManageStockHistoryStockIdRouteRoute
  '/app/products_/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId': typeof AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute
  '/app/products_/$productId/manage/update-specification/$specificationId': typeof AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute
  '/app/products_/$productId/manage/update-stock/$stockId': typeof AppProductsProductIdManageUpdateStockStockIdRouteRoute
  '/app/products_/$productId/manage/update-version/$versionId': typeof AppProductsProductIdManageUpdateVersionVersionIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/create': typeof AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute
  '/app/tools/formations/update/$formationId/add-detail': typeof AppToolsFormationsUpdateFormationIdAddDetailRouteRoute
  '/app/tools/formations/update/$formationId/details': typeof AppToolsFormationsUpdateFormationIdDetailsRouteRoute
  '/app/tools/scheduler/details/$rdvId/delete': typeof AppToolsSchedulerDetailsRdvIdDeleteRouteRoute
  '/app/tools/scheduler/details/$rdvId/update': typeof AppToolsSchedulerDetailsRdvIdUpdateRouteRoute
  '/app/businesses-rma_/business/$businessId_/study/': typeof AppBusinessesRmaBusinessBusinessIdStudyIndexRoute
  '/app/businesses-rma_/business/$businessId/arc/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/arc/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute
  '/app/businesses-rma_/business/$businessId/arc/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/bill/credits/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute
  '/app/businesses-rma_/business/$businessId/bl/update/new': typeof AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute
  '/app/businesses-rma_/business/$businessId/bp/add-serial/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/bp/create-detail-rma/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/bp/create-serial-rma/$serialId': typeof AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute
  '/app/businesses-rma_/business/$businessId/bp/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/bp/delete-serial/$serialId': typeof AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute
  '/app/businesses-rma_/business/$businessId/bp/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/address-book/create': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId': typeof AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/delete-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/delete-link/$associatedId': typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/dashboard/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/dashboard/unlink-task/$taskId': typeof AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId/quotation/create-associated-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/create-detail/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/delete-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/delete-subquotation/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/update-detail/$detailId': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/update-subquotation/$subquotationId': typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-faq': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-ged-directory': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-lifesheet': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-link': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-cumulated-time': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-no-billed-time': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-subtitle': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/import-ged-files': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/delivery/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma_/rma/$rmaId/delivery/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute
  '/app/businesses-rma_/rma/$rmaId/delivery/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma_/rma/$rmaId/reception/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma_/rma/$rmaId/reception/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute
  '/app/businesses-rma_/rma/$rmaId/reception/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/delete-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/delete-ged-object/$relativePath': typeof AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/delete-link/$associatedId': typeof AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/support/pdf/send-by-email': typeof AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteWithChildren
  '/app/businesses-rma_/rma/$rmaId/support/unlink-task/$taskId': typeof AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/update-detail/$detailId': typeof AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute
  '/app/enterprises_/$enterpriseId/email-history/email/$emailId/reply': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute
  '/app/enterprises_/$enterpriseId/email-history/email/$emailId/resend': typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute
  '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/reply': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/resend': typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute
  '/app/products_/$productId/informations/task-email/$taskId/reply': typeof AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute
  '/app/products_/$productId/informations/task-email/$taskId/resend': typeof AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId': typeof AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute
  '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId': typeof AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/address-book/delete/$addressId': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/address-book/update/$addressId': typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/reply': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute
  '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/resend': typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute
  '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages': typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-link/$associatedId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf/send-by-email': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/rename-ged-object/$objectRelativePath': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/reply': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute
  '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/resend': typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute
  '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend': typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/auth'
    | '/app/businesses-rma'
    | '/app/dashboard'
    | '/app/enterprises'
    | '/app/external-links'
    | '/app/faq'
    | '/app/products'
    | '/app/tools'
    | '/auth/login'
    | '/auth/forgot-password'
    | '/app/'
    | '/auth/'
    | '/app/businesses-rma/representative-turnover'
    | '/app/businesses-rma/search-by-products'
    | '/app/dashboard/create-collective-task'
    | '/app/dashboard/create-personal-task'
    | '/app/dashboard/create-progressive-info'
    | '/app/dashboard/delete-collective-tasks'
    | '/app/enterprises/create'
    | '/app/enterprises/$enterpriseId'
    | '/app/external-links/$externalLinkId'
    | '/app/faq/create'
    | '/app/products/create'
    | '/app/products/serial-numbers'
    | '/app/products/$productId'
    | '/app/tools/credit'
    | '/app/tools/ddns'
    | '/app/tools/departments'
    | '/app/tools/emails'
    | '/app/tools/external-links'
    | '/app/tools/formations'
    | '/app/tools/global-turnover'
    | '/app/tools/mails'
    | '/app/tools/menu'
    | '/app/tools/news'
    | '/app/tools/predefined-messages'
    | '/app/tools/predefined-texts'
    | '/app/tools/product-filters'
    | '/app/tools/product-inventory'
    | '/app/tools/product-shelves'
    | '/app/tools/representatives-map'
    | '/app/tools/representatives-turnover'
    | '/app/tools/scheduler'
    | '/app/tools/vva'
    | '/auth/reset-password/$token'
    | '/app/tools/'
    | '/app/businesses-rma/business/$businessId'
    | '/app/businesses-rma/rma/$rmaId'
    | '/app/dashboard/archive-personal-task/$taskId'
    | '/app/dashboard/create-aircall-contact/$number'
    | '/app/dashboard/delete-collective-task/$taskId'
    | '/app/dashboard/delete-progressive-info/$progressiveInfoId'
    | '/app/dashboard/link-personal-task/$taskId'
    | '/app/dashboard/other-personal-tasks/$profileId'
    | '/app/dashboard/personal-task-details/$taskId'
    | '/app/dashboard/scheduler-event-details/$eventId'
    | '/app/dashboard/take-collective-task/$taskId'
    | '/app/dashboard/task-comments/$taskId'
    | '/app/dashboard/task-email/$taskId'
    | '/app/dashboard/transfer-task/$taskId'
    | '/app/dashboard/unlink-personal-task/$taskId'
    | '/app/dashboard/update-aircall-contact/$contactId'
    | '/app/dashboard/update-personal-task-deadline/$taskId'
    | '/app/dashboard/update-progressive-info/$progressiveInfoId'
    | '/app/dashboard/validate-personal-task/$taskId'
    | '/app/enterprises/create-contact-business/$contactId'
    | '/app/enterprises/create-contact-travel-voucher/$contactId'
    | '/app/enterprises/create-contact/$enterpriseId'
    | '/app/enterprises/create-enterprise-rma/$enterpriseId'
    | '/app/enterprises/delete-contact/$contactId'
    | '/app/enterprises/send-email-to-contact/$contactId'
    | '/app/enterprises/update-contact-password/$contactId'
    | '/app/enterprises/update-contact/$contactId'
    | '/app/enterprises/$enterpriseId/address-book'
    | '/app/enterprises/$enterpriseId/create-contact'
    | '/app/enterprises/$enterpriseId/create-ged-directory'
    | '/app/enterprises/$enterpriseId/create-lifesheet-comment'
    | '/app/enterprises/$enterpriseId/delete'
    | '/app/enterprises/$enterpriseId/email-history'
    | '/app/enterprises/$enterpriseId/import-contacts'
    | '/app/enterprises/$enterpriseId/import-ged-files'
    | '/app/enterprises/$enterpriseId/relate-business-rma'
    | '/app/enterprises/$enterpriseId/update'
    | '/app/enterprises/$enterpriseId/update-accountability'
    | '/app/enterprises/$enterpriseId/update-category'
    | '/app/enterprises/$enterpriseId/update-representative'
    | '/app/faq/archive/$faqId'
    | '/app/faq/delete/$faqId'
    | '/app/faq/ged/$faqId'
    | '/app/faq/send-by-email/$faqId'
    | '/app/faq/update/$faqId'
    | '/app/products/serial-numbers/create'
    | '/app/products/$productId/informations'
    | '/app/products/$productId/manage'
    | '/app/tools/credit/details'
    | '/app/tools/credit/show'
    | '/app/tools/ddns/create'
    | '/app/tools/departments/create'
    | '/app/tools/emails/$emailId'
    | '/app/tools/external-links/create'
    | '/app/tools/formations/create'
    | '/app/tools/mails/create'
    | '/app/tools/menu/create-enterprise'
    | '/app/tools/menu/create-product'
    | '/app/tools/news/create'
    | '/app/tools/predefined-messages/create'
    | '/app/tools/predefined-texts/create'
    | '/app/tools/product-filters/create'
    | '/app/tools/product-inventory/validate-quantities'
    | '/app/tools/product-shelves/create'
    | '/app/tools/scheduler/create'
    | '/app/tools/vva/create'
    | '/app/products/$productId/'
    | '/app/businesses-rma/business/$businessId/arc'
    | '/app/businesses-rma/business/$businessId/bill'
    | '/app/businesses-rma/business/$businessId/bl'
    | '/app/businesses-rma/business/$businessId/bp'
    | '/app/businesses-rma/business/$businessId/dashboard'
    | '/app/businesses-rma/business/$businessId/quotation'
    | '/app/businesses-rma/business/$businessId/study'
    | '/app/businesses-rma/rma/$rmaId/delivery'
    | '/app/businesses-rma/rma/$rmaId/reception'
    | '/app/businesses-rma/rma/$rmaId/support'
    | '/app/dashboard/task-email/$taskId/reply'
    | '/app/dashboard/task-email/$taskId/resend'
    | '/app/enterprises/$enterpriseId/address-book/create'
    | '/app/enterprises/$enterpriseId/address-book/import'
    | '/app/enterprises/$enterpriseId/create-contact-business/$contactId'
    | '/app/enterprises/$enterpriseId/delete-contact/$contactId'
    | '/app/enterprises/$enterpriseId/delete-ged-object/$objectRelativePath'
    | '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId'
    | '/app/enterprises/$enterpriseId/rename-ged-object/$objectRelativePath'
    | '/app/enterprises/$enterpriseId/send-email-to-contact/$contactId'
    | '/app/enterprises/$enterpriseId/task-email/$taskId'
    | '/app/enterprises/$enterpriseId/unlink-task/$taskId'
    | '/app/enterprises/$enterpriseId/unrelate-business-rma/$businessRmaId'
    | '/app/enterprises/$enterpriseId/update-contact-password/$contactId'
    | '/app/enterprises/$enterpriseId/update-contact/$contactId'
    | '/app/faq/ged/$faqId/create-directory'
    | '/app/faq/ged/$faqId/import-files'
    | '/app/products/serial-numbers/create-rma/$serialNumberId'
    | '/app/products/serial-numbers/delete/$serialNumberId'
    | '/app/products/serial-numbers/remove-from-business/$serialNumberId'
    | '/app/products/serial-numbers/update/$serialNumberId'
    | '/app/products/$productId/informations/create-ged-directory'
    | '/app/products/$productId/informations/create-lifesheet-comment'
    | '/app/products/$productId/informations/delete-ged-object'
    | '/app/products/$productId/informations/import-ged-files'
    | '/app/products/$productId/informations/rename-ged-object'
    | '/app/products/$productId/manage/add-associated-product'
    | '/app/products/$productId/manage/add-nomenclature-detail'
    | '/app/products/$productId/manage/add-specification'
    | '/app/products/$productId/manage/create-stock'
    | '/app/products/$productId/manage/create-version'
    | '/app/tools/ddns/delete/$ddnsId'
    | '/app/tools/departments/delete/$departmentId'
    | '/app/tools/departments/update/$departmentId'
    | '/app/tools/emails/$emailId/reply'
    | '/app/tools/emails/$emailId/resend'
    | '/app/tools/external-links/archive/$externalLinkId'
    | '/app/tools/external-links/delete/$externalLinkId'
    | '/app/tools/external-links/update/$externalLinkId'
    | '/app/tools/formations/create/add-detail'
    | '/app/tools/formations/create/details'
    | '/app/tools/formations/delete/$formationId'
    | '/app/tools/formations/subscribers/$formationDetailId'
    | '/app/tools/formations/update/$formationId'
    | '/app/tools/mails/delete/$mailId'
    | '/app/tools/mails/show/$mailId'
    | '/app/tools/mails/update/$mailId'
    | '/app/tools/news/delete/$newsId'
    | '/app/tools/news/update/$newsId'
    | '/app/tools/predefined-messages/delete/$predefinedMessageId'
    | '/app/tools/predefined-messages/update/$predefinedMessageId'
    | '/app/tools/predefined-texts/delete/$predefinedTextId'
    | '/app/tools/predefined-texts/update/$predefinedTextId'
    | '/app/tools/product-filters/delete/$productFilterId'
    | '/app/tools/product-filters/update/$productFilterId'
    | '/app/tools/product-inventory/update/$stockId'
    | '/app/tools/product-shelves/delete/$productShelfId'
    | '/app/tools/scheduler/details/$rdvId'
    | '/app/tools/vva/delete/$vvaId'
    | '/app/businesses-rma/business/$businessId/'
    | '/app/businesses-rma/rma/$rmaId/'
    | '/app/businesses-rma/business/$businessId/arc/pdf'
    | '/app/businesses-rma/business/$businessId/arc/update-shipping-price'
    | '/app/businesses-rma/business/$businessId/bill/credits'
    | '/app/businesses-rma/business/$businessId/bill/send-by-email'
    | '/app/businesses-rma/business/$businessId/bl/send-by-email'
    | '/app/businesses-rma/business/$businessId/bl/update'
    | '/app/businesses-rma/business/$businessId/bp/travel-voucher'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book'
    | '/app/businesses-rma/business/$businessId/dashboard/create-ged-directory'
    | '/app/businesses-rma/business/$businessId/dashboard/create-lifesheet'
    | '/app/businesses-rma/business/$businessId/dashboard/create-link'
    | '/app/businesses-rma/business/$businessId/dashboard/delete'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history'
    | '/app/businesses-rma/business/$businessId/dashboard/import-ged-files'
    | '/app/businesses-rma/business/$businessId/dashboard/send-email'
    | '/app/businesses-rma/business/$businessId/dashboard/update-billing-address'
    | '/app/businesses-rma/business/$businessId/dashboard/update-representative'
    | '/app/businesses-rma/business/$businessId/dashboard/update-responsible'
    | '/app/businesses-rma/business/$businessId/quotation/commercial-notice'
    | '/app/businesses-rma/business/$businessId/quotation/pdf'
    | '/app/businesses-rma/business/$businessId/quotation/update-shipping-price'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId'
    | '/app/businesses-rma/business/$businessId/study/automatic'
    | '/app/businesses-rma/business/$businessId/study/expert'
    | '/app/businesses-rma/rma/$rmaId/delivery/create-detail'
    | '/app/businesses-rma/rma/$rmaId/delivery/pdf'
    | '/app/businesses-rma/rma/$rmaId/delivery/travel-voucher'
    | '/app/businesses-rma/rma/$rmaId/reception/create-detail'
    | '/app/businesses-rma/rma/$rmaId/reception/pdf'
    | '/app/businesses-rma/rma/$rmaId/support/create-detail'
    | '/app/businesses-rma/rma/$rmaId/support/create-ged-directory'
    | '/app/businesses-rma/rma/$rmaId/support/create-lifesheet'
    | '/app/businesses-rma/rma/$rmaId/support/create-link'
    | '/app/businesses-rma/rma/$rmaId/support/import-ged-files'
    | '/app/businesses-rma/rma/$rmaId/support/pdf'
    | '/app/enterprises/$enterpriseId/address-book/delete/$addressId'
    | '/app/enterprises/$enterpriseId/address-book/update/$addressId'
    | '/app/enterprises/$enterpriseId/email-history/email/$emailId'
    | '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/reply'
    | '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/resend'
    | '/app/enterprises/$enterpriseId/task-email/$taskId/reply'
    | '/app/enterprises/$enterpriseId/task-email/$taskId/resend'
    | '/app/faq/ged/$faqId/delete/$itemRelativePath'
    | '/app/faq/ged/$faqId/rename/$itemRelativePath'
    | '/app/products/$productId/informations/lifesheet-email/$lifesheetId'
    | '/app/products/$productId/informations/task-email/$taskId'
    | '/app/products/$productId/informations/unlink-task/$taskId'
    | '/app/products/$productId/manage/add-specification/$filterId'
    | '/app/products/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId'
    | '/app/products/$productId/manage/delete-specification/$specificationId'
    | '/app/products/$productId/manage/delete-stock/$stockId'
    | '/app/products/$productId/manage/delete-version/$versionId'
    | '/app/products/$productId/manage/remove-associated-product/$associatedProductId'
    | '/app/products/$productId/manage/stock-history/$stockId'
    | '/app/products/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId'
    | '/app/products/$productId/manage/update-specification/$specificationId'
    | '/app/products/$productId/manage/update-stock/$stockId'
    | '/app/products/$productId/manage/update-version/$versionId'
    | '/app/tools/formations/subscribers/$formationDetailId/create'
    | '/app/tools/formations/update/$formationId/add-detail'
    | '/app/tools/formations/update/$formationId/details'
    | '/app/tools/scheduler/details/$rdvId/delete'
    | '/app/tools/scheduler/details/$rdvId/update'
    | '/app/businesses-rma/business/$businessId/study/'
    | '/app/businesses-rma/business/$businessId/arc/delete-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/arc/pdf/send-by-email'
    | '/app/businesses-rma/business/$businessId/arc/update-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/bill/credits/send-by-email'
    | '/app/businesses-rma/business/$businessId/bl/update/new'
    | '/app/businesses-rma/business/$businessId/bp/add-serial/$detailId'
    | '/app/businesses-rma/business/$businessId/bp/create-detail-rma/$detailId'
    | '/app/businesses-rma/business/$businessId/bp/create-serial-rma/$serialId'
    | '/app/businesses-rma/business/$businessId/bp/delete-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/bp/delete-serial/$serialId'
    | '/app/businesses-rma/business/$businessId/bp/update-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book/create'
    | '/app/businesses-rma/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId'
    | '/app/businesses-rma/business/$businessId/dashboard/delete-ged-object/$objectRelativePath'
    | '/app/businesses-rma/business/$businessId/dashboard/delete-link/$associatedId'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId'
    | '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma/business/$businessId/dashboard/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId'
    | '/app/businesses-rma/business/$businessId/dashboard/unlink-task/$taskId'
    | '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email'
    | '/app/businesses-rma/business/$businessId/quotation/create-associated-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/quotation/create-detail/$subquotationId'
    | '/app/businesses-rma/business/$businessId/quotation/delete-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/quotation/delete-subquotation/$subquotationId'
    | '/app/businesses-rma/business/$businessId/quotation/pdf/send-by-email'
    | '/app/businesses-rma/business/$businessId/quotation/update-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/quotation/update-subquotation/$subquotationId'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-faq'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-ged-directory'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-lifesheet'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-link'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-cumulated-time'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-no-billed-time'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-subtitle'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/import-ged-files'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf'
    | '/app/businesses-rma/rma/$rmaId/delivery/delete-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/delivery/pdf/send-by-email'
    | '/app/businesses-rma/rma/$rmaId/delivery/update-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/reception/delete-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/reception/pdf/send-by-email'
    | '/app/businesses-rma/rma/$rmaId/reception/update-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/support/delete-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/support/delete-ged-object/$relativePath'
    | '/app/businesses-rma/rma/$rmaId/support/delete-link/$associatedId'
    | '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma/rma/$rmaId/support/pdf/send-by-email'
    | '/app/businesses-rma/rma/$rmaId/support/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId'
    | '/app/businesses-rma/rma/$rmaId/support/unlink-task/$taskId'
    | '/app/businesses-rma/rma/$rmaId/support/update-detail/$detailId'
    | '/app/enterprises/$enterpriseId/email-history/email/$emailId/reply'
    | '/app/enterprises/$enterpriseId/email-history/email/$emailId/resend'
    | '/app/products/$productId/informations/lifesheet-email/$lifesheetId/reply'
    | '/app/products/$productId/informations/lifesheet-email/$lifesheetId/resend'
    | '/app/products/$productId/informations/task-email/$taskId/reply'
    | '/app/products/$productId/informations/task-email/$taskId/resend'
    | '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId'
    | '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book/delete/$addressId'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book/update/$addressId'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/reply'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/resend'
    | '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend'
    | '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/reply'
    | '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/resend'
    | '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-ged-object/$objectRelativePath'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-link/$associatedId'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf/send-by-email'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend'
    | '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/reply'
    | '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/resend'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app/businesses-rma'
    | '/app/dashboard'
    | '/app/enterprises'
    | '/app/external-links'
    | '/app/faq'
    | '/app/products'
    | '/auth/login'
    | '/auth/forgot-password'
    | '/app'
    | '/auth'
    | '/app/businesses-rma/representative-turnover'
    | '/app/businesses-rma/search-by-products'
    | '/app/dashboard/create-collective-task'
    | '/app/dashboard/create-personal-task'
    | '/app/dashboard/create-progressive-info'
    | '/app/dashboard/delete-collective-tasks'
    | '/app/enterprises/create'
    | '/app/enterprises/$enterpriseId'
    | '/app/external-links/$externalLinkId'
    | '/app/faq/create'
    | '/app/products/create'
    | '/app/products/serial-numbers'
    | '/app/tools/credit'
    | '/app/tools/ddns'
    | '/app/tools/departments'
    | '/app/tools/emails'
    | '/app/tools/external-links'
    | '/app/tools/formations'
    | '/app/tools/global-turnover'
    | '/app/tools/mails'
    | '/app/tools/menu'
    | '/app/tools/news'
    | '/app/tools/predefined-messages'
    | '/app/tools/predefined-texts'
    | '/app/tools/product-filters'
    | '/app/tools/product-inventory'
    | '/app/tools/product-shelves'
    | '/app/tools/representatives-map'
    | '/app/tools/representatives-turnover'
    | '/app/tools/scheduler'
    | '/app/tools/vva'
    | '/auth/reset-password/$token'
    | '/app/tools'
    | '/app/dashboard/archive-personal-task/$taskId'
    | '/app/dashboard/create-aircall-contact/$number'
    | '/app/dashboard/delete-collective-task/$taskId'
    | '/app/dashboard/delete-progressive-info/$progressiveInfoId'
    | '/app/dashboard/link-personal-task/$taskId'
    | '/app/dashboard/other-personal-tasks/$profileId'
    | '/app/dashboard/personal-task-details/$taskId'
    | '/app/dashboard/scheduler-event-details/$eventId'
    | '/app/dashboard/take-collective-task/$taskId'
    | '/app/dashboard/task-comments/$taskId'
    | '/app/dashboard/task-email/$taskId'
    | '/app/dashboard/transfer-task/$taskId'
    | '/app/dashboard/unlink-personal-task/$taskId'
    | '/app/dashboard/update-aircall-contact/$contactId'
    | '/app/dashboard/update-personal-task-deadline/$taskId'
    | '/app/dashboard/update-progressive-info/$progressiveInfoId'
    | '/app/dashboard/validate-personal-task/$taskId'
    | '/app/enterprises/create-contact-business/$contactId'
    | '/app/enterprises/create-contact-travel-voucher/$contactId'
    | '/app/enterprises/create-contact/$enterpriseId'
    | '/app/enterprises/create-enterprise-rma/$enterpriseId'
    | '/app/enterprises/delete-contact/$contactId'
    | '/app/enterprises/send-email-to-contact/$contactId'
    | '/app/enterprises/update-contact-password/$contactId'
    | '/app/enterprises/update-contact/$contactId'
    | '/app/enterprises/$enterpriseId/address-book'
    | '/app/enterprises/$enterpriseId/create-contact'
    | '/app/enterprises/$enterpriseId/create-ged-directory'
    | '/app/enterprises/$enterpriseId/create-lifesheet-comment'
    | '/app/enterprises/$enterpriseId/delete'
    | '/app/enterprises/$enterpriseId/email-history'
    | '/app/enterprises/$enterpriseId/import-contacts'
    | '/app/enterprises/$enterpriseId/import-ged-files'
    | '/app/enterprises/$enterpriseId/relate-business-rma'
    | '/app/enterprises/$enterpriseId/update'
    | '/app/enterprises/$enterpriseId/update-accountability'
    | '/app/enterprises/$enterpriseId/update-category'
    | '/app/enterprises/$enterpriseId/update-representative'
    | '/app/faq/archive/$faqId'
    | '/app/faq/delete/$faqId'
    | '/app/faq/ged/$faqId'
    | '/app/faq/send-by-email/$faqId'
    | '/app/faq/update/$faqId'
    | '/app/products/serial-numbers/create'
    | '/app/products/$productId/informations'
    | '/app/products/$productId/manage'
    | '/app/tools/credit/details'
    | '/app/tools/credit/show'
    | '/app/tools/ddns/create'
    | '/app/tools/departments/create'
    | '/app/tools/emails/$emailId'
    | '/app/tools/external-links/create'
    | '/app/tools/formations/create'
    | '/app/tools/mails/create'
    | '/app/tools/menu/create-enterprise'
    | '/app/tools/menu/create-product'
    | '/app/tools/news/create'
    | '/app/tools/predefined-messages/create'
    | '/app/tools/predefined-texts/create'
    | '/app/tools/product-filters/create'
    | '/app/tools/product-inventory/validate-quantities'
    | '/app/tools/product-shelves/create'
    | '/app/tools/scheduler/create'
    | '/app/tools/vva/create'
    | '/app/products/$productId'
    | '/app/businesses-rma/business/$businessId/arc'
    | '/app/businesses-rma/business/$businessId/bill'
    | '/app/businesses-rma/business/$businessId/bl'
    | '/app/businesses-rma/business/$businessId/bp'
    | '/app/businesses-rma/business/$businessId/dashboard'
    | '/app/businesses-rma/business/$businessId/quotation'
    | '/app/businesses-rma/rma/$rmaId/delivery'
    | '/app/businesses-rma/rma/$rmaId/reception'
    | '/app/businesses-rma/rma/$rmaId/support'
    | '/app/dashboard/task-email/$taskId/reply'
    | '/app/dashboard/task-email/$taskId/resend'
    | '/app/enterprises/$enterpriseId/address-book/create'
    | '/app/enterprises/$enterpriseId/address-book/import'
    | '/app/enterprises/$enterpriseId/create-contact-business/$contactId'
    | '/app/enterprises/$enterpriseId/delete-contact/$contactId'
    | '/app/enterprises/$enterpriseId/delete-ged-object/$objectRelativePath'
    | '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId'
    | '/app/enterprises/$enterpriseId/rename-ged-object/$objectRelativePath'
    | '/app/enterprises/$enterpriseId/send-email-to-contact/$contactId'
    | '/app/enterprises/$enterpriseId/task-email/$taskId'
    | '/app/enterprises/$enterpriseId/unlink-task/$taskId'
    | '/app/enterprises/$enterpriseId/unrelate-business-rma/$businessRmaId'
    | '/app/enterprises/$enterpriseId/update-contact-password/$contactId'
    | '/app/enterprises/$enterpriseId/update-contact/$contactId'
    | '/app/faq/ged/$faqId/create-directory'
    | '/app/faq/ged/$faqId/import-files'
    | '/app/products/serial-numbers/create-rma/$serialNumberId'
    | '/app/products/serial-numbers/delete/$serialNumberId'
    | '/app/products/serial-numbers/remove-from-business/$serialNumberId'
    | '/app/products/serial-numbers/update/$serialNumberId'
    | '/app/products/$productId/informations/create-ged-directory'
    | '/app/products/$productId/informations/create-lifesheet-comment'
    | '/app/products/$productId/informations/delete-ged-object'
    | '/app/products/$productId/informations/import-ged-files'
    | '/app/products/$productId/informations/rename-ged-object'
    | '/app/products/$productId/manage/add-associated-product'
    | '/app/products/$productId/manage/add-nomenclature-detail'
    | '/app/products/$productId/manage/add-specification'
    | '/app/products/$productId/manage/create-stock'
    | '/app/products/$productId/manage/create-version'
    | '/app/tools/ddns/delete/$ddnsId'
    | '/app/tools/departments/delete/$departmentId'
    | '/app/tools/departments/update/$departmentId'
    | '/app/tools/emails/$emailId/reply'
    | '/app/tools/emails/$emailId/resend'
    | '/app/tools/external-links/archive/$externalLinkId'
    | '/app/tools/external-links/delete/$externalLinkId'
    | '/app/tools/external-links/update/$externalLinkId'
    | '/app/tools/formations/create/add-detail'
    | '/app/tools/formations/create/details'
    | '/app/tools/formations/delete/$formationId'
    | '/app/tools/formations/subscribers/$formationDetailId'
    | '/app/tools/formations/update/$formationId'
    | '/app/tools/mails/delete/$mailId'
    | '/app/tools/mails/show/$mailId'
    | '/app/tools/mails/update/$mailId'
    | '/app/tools/news/delete/$newsId'
    | '/app/tools/news/update/$newsId'
    | '/app/tools/predefined-messages/delete/$predefinedMessageId'
    | '/app/tools/predefined-messages/update/$predefinedMessageId'
    | '/app/tools/predefined-texts/delete/$predefinedTextId'
    | '/app/tools/predefined-texts/update/$predefinedTextId'
    | '/app/tools/product-filters/delete/$productFilterId'
    | '/app/tools/product-filters/update/$productFilterId'
    | '/app/tools/product-inventory/update/$stockId'
    | '/app/tools/product-shelves/delete/$productShelfId'
    | '/app/tools/scheduler/details/$rdvId'
    | '/app/tools/vva/delete/$vvaId'
    | '/app/businesses-rma/business/$businessId'
    | '/app/businesses-rma/rma/$rmaId'
    | '/app/businesses-rma/business/$businessId/arc/pdf'
    | '/app/businesses-rma/business/$businessId/arc/update-shipping-price'
    | '/app/businesses-rma/business/$businessId/bill/credits'
    | '/app/businesses-rma/business/$businessId/bill/send-by-email'
    | '/app/businesses-rma/business/$businessId/bl/send-by-email'
    | '/app/businesses-rma/business/$businessId/bl/update'
    | '/app/businesses-rma/business/$businessId/bp/travel-voucher'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book'
    | '/app/businesses-rma/business/$businessId/dashboard/create-ged-directory'
    | '/app/businesses-rma/business/$businessId/dashboard/create-lifesheet'
    | '/app/businesses-rma/business/$businessId/dashboard/create-link'
    | '/app/businesses-rma/business/$businessId/dashboard/delete'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history'
    | '/app/businesses-rma/business/$businessId/dashboard/import-ged-files'
    | '/app/businesses-rma/business/$businessId/dashboard/send-email'
    | '/app/businesses-rma/business/$businessId/dashboard/update-billing-address'
    | '/app/businesses-rma/business/$businessId/dashboard/update-representative'
    | '/app/businesses-rma/business/$businessId/dashboard/update-responsible'
    | '/app/businesses-rma/business/$businessId/quotation/commercial-notice'
    | '/app/businesses-rma/business/$businessId/quotation/pdf'
    | '/app/businesses-rma/business/$businessId/quotation/update-shipping-price'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId'
    | '/app/businesses-rma/business/$businessId/study/automatic'
    | '/app/businesses-rma/business/$businessId/study/expert'
    | '/app/businesses-rma/rma/$rmaId/delivery/create-detail'
    | '/app/businesses-rma/rma/$rmaId/delivery/pdf'
    | '/app/businesses-rma/rma/$rmaId/delivery/travel-voucher'
    | '/app/businesses-rma/rma/$rmaId/reception/create-detail'
    | '/app/businesses-rma/rma/$rmaId/reception/pdf'
    | '/app/businesses-rma/rma/$rmaId/support/create-detail'
    | '/app/businesses-rma/rma/$rmaId/support/create-ged-directory'
    | '/app/businesses-rma/rma/$rmaId/support/create-lifesheet'
    | '/app/businesses-rma/rma/$rmaId/support/create-link'
    | '/app/businesses-rma/rma/$rmaId/support/import-ged-files'
    | '/app/businesses-rma/rma/$rmaId/support/pdf'
    | '/app/enterprises/$enterpriseId/address-book/delete/$addressId'
    | '/app/enterprises/$enterpriseId/address-book/update/$addressId'
    | '/app/enterprises/$enterpriseId/email-history/email/$emailId'
    | '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/reply'
    | '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/resend'
    | '/app/enterprises/$enterpriseId/task-email/$taskId/reply'
    | '/app/enterprises/$enterpriseId/task-email/$taskId/resend'
    | '/app/faq/ged/$faqId/delete/$itemRelativePath'
    | '/app/faq/ged/$faqId/rename/$itemRelativePath'
    | '/app/products/$productId/informations/lifesheet-email/$lifesheetId'
    | '/app/products/$productId/informations/task-email/$taskId'
    | '/app/products/$productId/informations/unlink-task/$taskId'
    | '/app/products/$productId/manage/add-specification/$filterId'
    | '/app/products/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId'
    | '/app/products/$productId/manage/delete-specification/$specificationId'
    | '/app/products/$productId/manage/delete-stock/$stockId'
    | '/app/products/$productId/manage/delete-version/$versionId'
    | '/app/products/$productId/manage/remove-associated-product/$associatedProductId'
    | '/app/products/$productId/manage/stock-history/$stockId'
    | '/app/products/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId'
    | '/app/products/$productId/manage/update-specification/$specificationId'
    | '/app/products/$productId/manage/update-stock/$stockId'
    | '/app/products/$productId/manage/update-version/$versionId'
    | '/app/tools/formations/subscribers/$formationDetailId/create'
    | '/app/tools/formations/update/$formationId/add-detail'
    | '/app/tools/formations/update/$formationId/details'
    | '/app/tools/scheduler/details/$rdvId/delete'
    | '/app/tools/scheduler/details/$rdvId/update'
    | '/app/businesses-rma/business/$businessId/study'
    | '/app/businesses-rma/business/$businessId/arc/delete-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/arc/pdf/send-by-email'
    | '/app/businesses-rma/business/$businessId/arc/update-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/bill/credits/send-by-email'
    | '/app/businesses-rma/business/$businessId/bl/update/new'
    | '/app/businesses-rma/business/$businessId/bp/add-serial/$detailId'
    | '/app/businesses-rma/business/$businessId/bp/create-detail-rma/$detailId'
    | '/app/businesses-rma/business/$businessId/bp/create-serial-rma/$serialId'
    | '/app/businesses-rma/business/$businessId/bp/delete-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/bp/delete-serial/$serialId'
    | '/app/businesses-rma/business/$businessId/bp/update-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book/create'
    | '/app/businesses-rma/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId'
    | '/app/businesses-rma/business/$businessId/dashboard/delete-ged-object/$objectRelativePath'
    | '/app/businesses-rma/business/$businessId/dashboard/delete-link/$associatedId'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId'
    | '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma/business/$businessId/dashboard/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId'
    | '/app/businesses-rma/business/$businessId/dashboard/unlink-task/$taskId'
    | '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email'
    | '/app/businesses-rma/business/$businessId/quotation/create-associated-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/quotation/create-detail/$subquotationId'
    | '/app/businesses-rma/business/$businessId/quotation/delete-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/quotation/delete-subquotation/$subquotationId'
    | '/app/businesses-rma/business/$businessId/quotation/pdf/send-by-email'
    | '/app/businesses-rma/business/$businessId/quotation/update-detail/$detailId'
    | '/app/businesses-rma/business/$businessId/quotation/update-subquotation/$subquotationId'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-faq'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-ged-directory'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-lifesheet'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-link'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-cumulated-time'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-no-billed-time'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-subtitle'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/import-ged-files'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf'
    | '/app/businesses-rma/rma/$rmaId/delivery/delete-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/delivery/pdf/send-by-email'
    | '/app/businesses-rma/rma/$rmaId/delivery/update-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/reception/delete-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/reception/pdf/send-by-email'
    | '/app/businesses-rma/rma/$rmaId/reception/update-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/support/delete-detail/$detailId'
    | '/app/businesses-rma/rma/$rmaId/support/delete-ged-object/$relativePath'
    | '/app/businesses-rma/rma/$rmaId/support/delete-link/$associatedId'
    | '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma/rma/$rmaId/support/pdf/send-by-email'
    | '/app/businesses-rma/rma/$rmaId/support/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId'
    | '/app/businesses-rma/rma/$rmaId/support/unlink-task/$taskId'
    | '/app/businesses-rma/rma/$rmaId/support/update-detail/$detailId'
    | '/app/enterprises/$enterpriseId/email-history/email/$emailId/reply'
    | '/app/enterprises/$enterpriseId/email-history/email/$emailId/resend'
    | '/app/products/$productId/informations/lifesheet-email/$lifesheetId/reply'
    | '/app/products/$productId/informations/lifesheet-email/$lifesheetId/resend'
    | '/app/products/$productId/informations/task-email/$taskId/reply'
    | '/app/products/$productId/informations/task-email/$taskId/resend'
    | '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId'
    | '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book/delete/$addressId'
    | '/app/businesses-rma/business/$businessId/dashboard/address-book/update/$addressId'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/reply'
    | '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/resend'
    | '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend'
    | '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/reply'
    | '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/resend'
    | '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-ged-object/$objectRelativePath'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-link/$associatedId'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf/send-by-email'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend'
    | '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/reply'
    | '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/resend'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/auth'
    | '/app/businesses-rma'
    | '/app/dashboard'
    | '/app/enterprises'
    | '/app/external-links'
    | '/app/faq'
    | '/app/products'
    | '/app/tools'
    | '/auth/login'
    | '/auth/forgot-password'
    | '/app/'
    | '/auth/'
    | '/app/businesses-rma/representative-turnover'
    | '/app/businesses-rma/search-by-products'
    | '/app/dashboard/create-collective-task'
    | '/app/dashboard/create-personal-task'
    | '/app/dashboard/create-progressive-info'
    | '/app/dashboard/delete-collective-tasks'
    | '/app/enterprises/create'
    | '/app/enterprises_/$enterpriseId'
    | '/app/external-links_/$externalLinkId'
    | '/app/faq/create'
    | '/app/products/create'
    | '/app/products/serial-numbers'
    | '/app/products_/$productId'
    | '/app/tools/credit'
    | '/app/tools/ddns'
    | '/app/tools/departments'
    | '/app/tools/emails'
    | '/app/tools/external-links'
    | '/app/tools/formations'
    | '/app/tools/global-turnover'
    | '/app/tools/mails'
    | '/app/tools/menu'
    | '/app/tools/news'
    | '/app/tools/predefined-messages'
    | '/app/tools/predefined-texts'
    | '/app/tools/product-filters'
    | '/app/tools/product-inventory'
    | '/app/tools/product-shelves'
    | '/app/tools/representatives-map'
    | '/app/tools/representatives-turnover'
    | '/app/tools/scheduler'
    | '/app/tools/vva'
    | '/auth/reset-password/$token'
    | '/app/tools/'
    | '/app/businesses-rma_/business/$businessId'
    | '/app/businesses-rma_/rma/$rmaId'
    | '/app/dashboard/archive-personal-task/$taskId'
    | '/app/dashboard/create-aircall-contact/$number'
    | '/app/dashboard/delete-collective-task/$taskId'
    | '/app/dashboard/delete-progressive-info/$progressiveInfoId'
    | '/app/dashboard/link-personal-task/$taskId'
    | '/app/dashboard/other-personal-tasks/$profileId'
    | '/app/dashboard/personal-task-details/$taskId'
    | '/app/dashboard/scheduler-event-details/$eventId'
    | '/app/dashboard/take-collective-task/$taskId'
    | '/app/dashboard/task-comments/$taskId'
    | '/app/dashboard/task-email/$taskId'
    | '/app/dashboard/transfer-task/$taskId'
    | '/app/dashboard/unlink-personal-task/$taskId'
    | '/app/dashboard/update-aircall-contact/$contactId'
    | '/app/dashboard/update-personal-task-deadline/$taskId'
    | '/app/dashboard/update-progressive-info/$progressiveInfoId'
    | '/app/dashboard/validate-personal-task/$taskId'
    | '/app/enterprises/create-contact-business/$contactId'
    | '/app/enterprises/create-contact-travel-voucher/$contactId'
    | '/app/enterprises/create-contact/$enterpriseId'
    | '/app/enterprises/create-enterprise-rma/$enterpriseId'
    | '/app/enterprises/delete-contact/$contactId'
    | '/app/enterprises/send-email-to-contact/$contactId'
    | '/app/enterprises/update-contact-password/$contactId'
    | '/app/enterprises/update-contact/$contactId'
    | '/app/enterprises_/$enterpriseId/address-book'
    | '/app/enterprises_/$enterpriseId/create-contact'
    | '/app/enterprises_/$enterpriseId/create-ged-directory'
    | '/app/enterprises_/$enterpriseId/create-lifesheet-comment'
    | '/app/enterprises_/$enterpriseId/delete'
    | '/app/enterprises_/$enterpriseId/email-history'
    | '/app/enterprises_/$enterpriseId/import-contacts'
    | '/app/enterprises_/$enterpriseId/import-ged-files'
    | '/app/enterprises_/$enterpriseId/relate-business-rma'
    | '/app/enterprises_/$enterpriseId/update'
    | '/app/enterprises_/$enterpriseId/update-accountability'
    | '/app/enterprises_/$enterpriseId/update-category'
    | '/app/enterprises_/$enterpriseId/update-representative'
    | '/app/faq/archive/$faqId'
    | '/app/faq/delete/$faqId'
    | '/app/faq/ged/$faqId'
    | '/app/faq/send-by-email/$faqId'
    | '/app/faq/update/$faqId'
    | '/app/products/serial-numbers/create'
    | '/app/products_/$productId/informations'
    | '/app/products_/$productId/manage'
    | '/app/tools/credit/details'
    | '/app/tools/credit/show'
    | '/app/tools/ddns/create'
    | '/app/tools/departments/create'
    | '/app/tools/emails/$emailId'
    | '/app/tools/external-links/create'
    | '/app/tools/formations/create'
    | '/app/tools/mails/create'
    | '/app/tools/menu/create-enterprise'
    | '/app/tools/menu/create-product'
    | '/app/tools/news/create'
    | '/app/tools/predefined-messages/create'
    | '/app/tools/predefined-texts/create'
    | '/app/tools/product-filters/create'
    | '/app/tools/product-inventory/validate-quantities'
    | '/app/tools/product-shelves/create'
    | '/app/tools/scheduler/create'
    | '/app/tools/vva/create'
    | '/app/products_/$productId/'
    | '/app/businesses-rma_/business/$businessId/arc'
    | '/app/businesses-rma_/business/$businessId/bill'
    | '/app/businesses-rma_/business/$businessId/bl'
    | '/app/businesses-rma_/business/$businessId/bp'
    | '/app/businesses-rma_/business/$businessId/dashboard'
    | '/app/businesses-rma_/business/$businessId/quotation'
    | '/app/businesses-rma_/business/$businessId_/study'
    | '/app/businesses-rma_/rma/$rmaId/delivery'
    | '/app/businesses-rma_/rma/$rmaId/reception'
    | '/app/businesses-rma_/rma/$rmaId/support'
    | '/app/dashboard/task-email/$taskId/reply'
    | '/app/dashboard/task-email/$taskId/resend'
    | '/app/enterprises_/$enterpriseId/address-book/create'
    | '/app/enterprises_/$enterpriseId/address-book/import'
    | '/app/enterprises_/$enterpriseId/create-contact-business/$contactId'
    | '/app/enterprises_/$enterpriseId/delete-contact/$contactId'
    | '/app/enterprises_/$enterpriseId/delete-ged-object/$objectRelativePath'
    | '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId'
    | '/app/enterprises_/$enterpriseId/rename-ged-object/$objectRelativePath'
    | '/app/enterprises_/$enterpriseId/send-email-to-contact/$contactId'
    | '/app/enterprises_/$enterpriseId/task-email/$taskId'
    | '/app/enterprises_/$enterpriseId/unlink-task/$taskId'
    | '/app/enterprises_/$enterpriseId/unrelate-business-rma/$businessRmaId'
    | '/app/enterprises_/$enterpriseId/update-contact-password/$contactId'
    | '/app/enterprises_/$enterpriseId/update-contact/$contactId'
    | '/app/faq/ged/$faqId/create-directory'
    | '/app/faq/ged/$faqId/import-files'
    | '/app/products/serial-numbers/create-rma/$serialNumberId'
    | '/app/products/serial-numbers/delete/$serialNumberId'
    | '/app/products/serial-numbers/remove-from-business/$serialNumberId'
    | '/app/products/serial-numbers/update/$serialNumberId'
    | '/app/products_/$productId/informations/create-ged-directory'
    | '/app/products_/$productId/informations/create-lifesheet-comment'
    | '/app/products_/$productId/informations/delete-ged-object'
    | '/app/products_/$productId/informations/import-ged-files'
    | '/app/products_/$productId/informations/rename-ged-object'
    | '/app/products_/$productId/manage/add-associated-product'
    | '/app/products_/$productId/manage/add-nomenclature-detail'
    | '/app/products_/$productId/manage/add-specification'
    | '/app/products_/$productId/manage/create-stock'
    | '/app/products_/$productId/manage/create-version'
    | '/app/tools/ddns/delete/$ddnsId'
    | '/app/tools/departments/delete/$departmentId'
    | '/app/tools/departments/update/$departmentId'
    | '/app/tools/emails/$emailId/reply'
    | '/app/tools/emails/$emailId/resend'
    | '/app/tools/external-links/archive/$externalLinkId'
    | '/app/tools/external-links/delete/$externalLinkId'
    | '/app/tools/external-links/update/$externalLinkId'
    | '/app/tools/formations/create/add-detail'
    | '/app/tools/formations/create/details'
    | '/app/tools/formations/delete/$formationId'
    | '/app/tools/formations/subscribers/$formationDetailId'
    | '/app/tools/formations/update/$formationId'
    | '/app/tools/mails/delete/$mailId'
    | '/app/tools/mails/show/$mailId'
    | '/app/tools/mails/update/$mailId'
    | '/app/tools/news/delete/$newsId'
    | '/app/tools/news/update/$newsId'
    | '/app/tools/predefined-messages/delete/$predefinedMessageId'
    | '/app/tools/predefined-messages/update/$predefinedMessageId'
    | '/app/tools/predefined-texts/delete/$predefinedTextId'
    | '/app/tools/predefined-texts/update/$predefinedTextId'
    | '/app/tools/product-filters/delete/$productFilterId'
    | '/app/tools/product-filters/update/$productFilterId'
    | '/app/tools/product-inventory/update/$stockId'
    | '/app/tools/product-shelves/delete/$productShelfId'
    | '/app/tools/scheduler/details/$rdvId'
    | '/app/tools/vva/delete/$vvaId'
    | '/app/businesses-rma_/business/$businessId/'
    | '/app/businesses-rma_/rma/$rmaId/'
    | '/app/businesses-rma_/business/$businessId/arc/pdf'
    | '/app/businesses-rma_/business/$businessId/arc/update-shipping-price'
    | '/app/businesses-rma_/business/$businessId/bill/credits'
    | '/app/businesses-rma_/business/$businessId/bill/send-by-email'
    | '/app/businesses-rma_/business/$businessId/bl/send-by-email'
    | '/app/businesses-rma_/business/$businessId/bl/update'
    | '/app/businesses-rma_/business/$businessId/bp/travel-voucher'
    | '/app/businesses-rma_/business/$businessId/dashboard/address-book'
    | '/app/businesses-rma_/business/$businessId/dashboard/create-ged-directory'
    | '/app/businesses-rma_/business/$businessId/dashboard/create-lifesheet'
    | '/app/businesses-rma_/business/$businessId/dashboard/create-link'
    | '/app/businesses-rma_/business/$businessId/dashboard/delete'
    | '/app/businesses-rma_/business/$businessId/dashboard/email-history'
    | '/app/businesses-rma_/business/$businessId/dashboard/import-ged-files'
    | '/app/businesses-rma_/business/$businessId/dashboard/send-email'
    | '/app/businesses-rma_/business/$businessId/dashboard/update-billing-address'
    | '/app/businesses-rma_/business/$businessId/dashboard/update-representative'
    | '/app/businesses-rma_/business/$businessId/dashboard/update-responsible'
    | '/app/businesses-rma_/business/$businessId/quotation/commercial-notice'
    | '/app/businesses-rma_/business/$businessId/quotation/pdf'
    | '/app/businesses-rma_/business/$businessId/quotation/update-shipping-price'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId'
    | '/app/businesses-rma_/business/$businessId_/study/automatic'
    | '/app/businesses-rma_/business/$businessId_/study/expert'
    | '/app/businesses-rma_/rma/$rmaId/delivery/create-detail'
    | '/app/businesses-rma_/rma/$rmaId/delivery/pdf'
    | '/app/businesses-rma_/rma/$rmaId/delivery/travel-voucher'
    | '/app/businesses-rma_/rma/$rmaId/reception/create-detail'
    | '/app/businesses-rma_/rma/$rmaId/reception/pdf'
    | '/app/businesses-rma_/rma/$rmaId/support/create-detail'
    | '/app/businesses-rma_/rma/$rmaId/support/create-ged-directory'
    | '/app/businesses-rma_/rma/$rmaId/support/create-lifesheet'
    | '/app/businesses-rma_/rma/$rmaId/support/create-link'
    | '/app/businesses-rma_/rma/$rmaId/support/import-ged-files'
    | '/app/businesses-rma_/rma/$rmaId/support/pdf'
    | '/app/enterprises_/$enterpriseId/address-book/delete/$addressId'
    | '/app/enterprises_/$enterpriseId/address-book/update/$addressId'
    | '/app/enterprises_/$enterpriseId/email-history/email/$emailId'
    | '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/reply'
    | '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/resend'
    | '/app/enterprises_/$enterpriseId/task-email/$taskId/reply'
    | '/app/enterprises_/$enterpriseId/task-email/$taskId/resend'
    | '/app/faq/ged/$faqId/delete/$itemRelativePath'
    | '/app/faq/ged/$faqId/rename/$itemRelativePath'
    | '/app/products_/$productId/informations/lifesheet-email/$lifesheetId'
    | '/app/products_/$productId/informations/task-email/$taskId'
    | '/app/products_/$productId/informations/unlink-task/$taskId'
    | '/app/products_/$productId/manage/add-specification/$filterId'
    | '/app/products_/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId'
    | '/app/products_/$productId/manage/delete-specification/$specificationId'
    | '/app/products_/$productId/manage/delete-stock/$stockId'
    | '/app/products_/$productId/manage/delete-version/$versionId'
    | '/app/products_/$productId/manage/remove-associated-product/$associatedProductId'
    | '/app/products_/$productId/manage/stock-history/$stockId'
    | '/app/products_/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId'
    | '/app/products_/$productId/manage/update-specification/$specificationId'
    | '/app/products_/$productId/manage/update-stock/$stockId'
    | '/app/products_/$productId/manage/update-version/$versionId'
    | '/app/tools/formations/subscribers/$formationDetailId/create'
    | '/app/tools/formations/update/$formationId/add-detail'
    | '/app/tools/formations/update/$formationId/details'
    | '/app/tools/scheduler/details/$rdvId/delete'
    | '/app/tools/scheduler/details/$rdvId/update'
    | '/app/businesses-rma_/business/$businessId_/study/'
    | '/app/businesses-rma_/business/$businessId/arc/delete-detail/$detailId'
    | '/app/businesses-rma_/business/$businessId/arc/pdf/send-by-email'
    | '/app/businesses-rma_/business/$businessId/arc/update-detail/$detailId'
    | '/app/businesses-rma_/business/$businessId/bill/credits/send-by-email'
    | '/app/businesses-rma_/business/$businessId/bl/update/new'
    | '/app/businesses-rma_/business/$businessId/bp/add-serial/$detailId'
    | '/app/businesses-rma_/business/$businessId/bp/create-detail-rma/$detailId'
    | '/app/businesses-rma_/business/$businessId/bp/create-serial-rma/$serialId'
    | '/app/businesses-rma_/business/$businessId/bp/delete-detail/$detailId'
    | '/app/businesses-rma_/business/$businessId/bp/delete-serial/$serialId'
    | '/app/businesses-rma_/business/$businessId/bp/update-detail/$detailId'
    | '/app/businesses-rma_/business/$businessId/dashboard/address-book/create'
    | '/app/businesses-rma_/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId'
    | '/app/businesses-rma_/business/$businessId/dashboard/delete-ged-object/$objectRelativePath'
    | '/app/businesses-rma_/business/$businessId/dashboard/delete-link/$associatedId'
    | '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId'
    | '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma_/business/$businessId/dashboard/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId'
    | '/app/businesses-rma_/business/$businessId/dashboard/unlink-task/$taskId'
    | '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email'
    | '/app/businesses-rma_/business/$businessId/quotation/create-associated-detail/$detailId'
    | '/app/businesses-rma_/business/$businessId/quotation/create-detail/$subquotationId'
    | '/app/businesses-rma_/business/$businessId/quotation/delete-detail/$detailId'
    | '/app/businesses-rma_/business/$businessId/quotation/delete-subquotation/$subquotationId'
    | '/app/businesses-rma_/business/$businessId/quotation/pdf/send-by-email'
    | '/app/businesses-rma_/business/$businessId/quotation/update-detail/$detailId'
    | '/app/businesses-rma_/business/$businessId/quotation/update-subquotation/$subquotationId'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-faq'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-ged-directory'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-lifesheet'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-link'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-cumulated-time'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-no-billed-time'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-subtitle'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/import-ged-files'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf'
    | '/app/businesses-rma_/rma/$rmaId/delivery/delete-detail/$detailId'
    | '/app/businesses-rma_/rma/$rmaId/delivery/pdf/send-by-email'
    | '/app/businesses-rma_/rma/$rmaId/delivery/update-detail/$detailId'
    | '/app/businesses-rma_/rma/$rmaId/reception/delete-detail/$detailId'
    | '/app/businesses-rma_/rma/$rmaId/reception/pdf/send-by-email'
    | '/app/businesses-rma_/rma/$rmaId/reception/update-detail/$detailId'
    | '/app/businesses-rma_/rma/$rmaId/support/delete-detail/$detailId'
    | '/app/businesses-rma_/rma/$rmaId/support/delete-ged-object/$relativePath'
    | '/app/businesses-rma_/rma/$rmaId/support/delete-link/$associatedId'
    | '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma_/rma/$rmaId/support/pdf/send-by-email'
    | '/app/businesses-rma_/rma/$rmaId/support/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId'
    | '/app/businesses-rma_/rma/$rmaId/support/unlink-task/$taskId'
    | '/app/businesses-rma_/rma/$rmaId/support/update-detail/$detailId'
    | '/app/enterprises_/$enterpriseId/email-history/email/$emailId/reply'
    | '/app/enterprises_/$enterpriseId/email-history/email/$emailId/resend'
    | '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/reply'
    | '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/resend'
    | '/app/products_/$productId/informations/task-email/$taskId/reply'
    | '/app/products_/$productId/informations/task-email/$taskId/resend'
    | '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId'
    | '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId'
    | '/app/businesses-rma_/business/$businessId/dashboard/address-book/delete/$addressId'
    | '/app/businesses-rma_/business/$businessId/dashboard/address-book/update/$addressId'
    | '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/reply'
    | '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/resend'
    | '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend'
    | '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/reply'
    | '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/resend'
    | '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-ged-object/$objectRelativePath'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-link/$associatedId'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf/send-by-email'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/rename-ged-object/$objectRelativePath'
    | '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend'
    | '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/reply'
    | '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/resend'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply'
    | '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/app/tools': {
      id: '/app/tools'
      path: '/tools'
      fullPath: '/app/tools'
      preLoaderRoute: typeof AppToolsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/products': {
      id: '/app/products'
      path: '/products'
      fullPath: '/app/products'
      preLoaderRoute: typeof AppProductsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/faq': {
      id: '/app/faq'
      path: '/faq'
      fullPath: '/app/faq'
      preLoaderRoute: typeof AppFaqRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/external-links': {
      id: '/app/external-links'
      path: '/external-links'
      fullPath: '/app/external-links'
      preLoaderRoute: typeof AppExternalLinksRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/enterprises': {
      id: '/app/enterprises'
      path: '/enterprises'
      fullPath: '/app/enterprises'
      preLoaderRoute: typeof AppEnterprisesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/businesses-rma': {
      id: '/app/businesses-rma'
      path: '/businesses-rma'
      fullPath: '/app/businesses-rma'
      preLoaderRoute: typeof AppBusinessesRmaRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/tools/': {
      id: '/app/tools/'
      path: '/'
      fullPath: '/app/tools/'
      preLoaderRoute: typeof AppToolsIndexRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/auth/reset-password/$token': {
      id: '/auth/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/app/tools/vva': {
      id: '/app/tools/vva'
      path: '/vva'
      fullPath: '/app/tools/vva'
      preLoaderRoute: typeof AppToolsVvaRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/scheduler': {
      id: '/app/tools/scheduler'
      path: '/scheduler'
      fullPath: '/app/tools/scheduler'
      preLoaderRoute: typeof AppToolsSchedulerRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/representatives-turnover': {
      id: '/app/tools/representatives-turnover'
      path: '/representatives-turnover'
      fullPath: '/app/tools/representatives-turnover'
      preLoaderRoute: typeof AppToolsRepresentativesTurnoverRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/representatives-map': {
      id: '/app/tools/representatives-map'
      path: '/representatives-map'
      fullPath: '/app/tools/representatives-map'
      preLoaderRoute: typeof AppToolsRepresentativesMapRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/product-shelves': {
      id: '/app/tools/product-shelves'
      path: '/product-shelves'
      fullPath: '/app/tools/product-shelves'
      preLoaderRoute: typeof AppToolsProductShelvesRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/product-inventory': {
      id: '/app/tools/product-inventory'
      path: '/product-inventory'
      fullPath: '/app/tools/product-inventory'
      preLoaderRoute: typeof AppToolsProductInventoryRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/product-filters': {
      id: '/app/tools/product-filters'
      path: '/product-filters'
      fullPath: '/app/tools/product-filters'
      preLoaderRoute: typeof AppToolsProductFiltersRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/predefined-texts': {
      id: '/app/tools/predefined-texts'
      path: '/predefined-texts'
      fullPath: '/app/tools/predefined-texts'
      preLoaderRoute: typeof AppToolsPredefinedTextsRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/predefined-messages': {
      id: '/app/tools/predefined-messages'
      path: '/predefined-messages'
      fullPath: '/app/tools/predefined-messages'
      preLoaderRoute: typeof AppToolsPredefinedMessagesRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/news': {
      id: '/app/tools/news'
      path: '/news'
      fullPath: '/app/tools/news'
      preLoaderRoute: typeof AppToolsNewsRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/menu': {
      id: '/app/tools/menu'
      path: '/menu'
      fullPath: '/app/tools/menu'
      preLoaderRoute: typeof AppToolsMenuRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/mails': {
      id: '/app/tools/mails'
      path: '/mails'
      fullPath: '/app/tools/mails'
      preLoaderRoute: typeof AppToolsMailsRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/global-turnover': {
      id: '/app/tools/global-turnover'
      path: '/global-turnover'
      fullPath: '/app/tools/global-turnover'
      preLoaderRoute: typeof AppToolsGlobalTurnoverRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/formations': {
      id: '/app/tools/formations'
      path: '/formations'
      fullPath: '/app/tools/formations'
      preLoaderRoute: typeof AppToolsFormationsRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/external-links': {
      id: '/app/tools/external-links'
      path: '/external-links'
      fullPath: '/app/tools/external-links'
      preLoaderRoute: typeof AppToolsExternalLinksRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/emails': {
      id: '/app/tools/emails'
      path: '/emails'
      fullPath: '/app/tools/emails'
      preLoaderRoute: typeof AppToolsEmailsRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/departments': {
      id: '/app/tools/departments'
      path: '/departments'
      fullPath: '/app/tools/departments'
      preLoaderRoute: typeof AppToolsDepartmentsRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/ddns': {
      id: '/app/tools/ddns'
      path: '/ddns'
      fullPath: '/app/tools/ddns'
      preLoaderRoute: typeof AppToolsDdnsRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/tools/credit': {
      id: '/app/tools/credit'
      path: '/credit'
      fullPath: '/app/tools/credit'
      preLoaderRoute: typeof AppToolsCreditRouteRouteImport
      parentRoute: typeof AppToolsRouteRoute
    }
    '/app/products_/$productId': {
      id: '/app/products_/$productId'
      path: '/products/$productId'
      fullPath: '/app/products/$productId'
      preLoaderRoute: typeof AppProductsProductIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/products/serial-numbers': {
      id: '/app/products/serial-numbers'
      path: '/serial-numbers'
      fullPath: '/app/products/serial-numbers'
      preLoaderRoute: typeof AppProductsSerialNumbersRouteRouteImport
      parentRoute: typeof AppProductsRouteRoute
    }
    '/app/products/create': {
      id: '/app/products/create'
      path: '/create'
      fullPath: '/app/products/create'
      preLoaderRoute: typeof AppProductsCreateRouteRouteImport
      parentRoute: typeof AppProductsRouteRoute
    }
    '/app/faq/create': {
      id: '/app/faq/create'
      path: '/create'
      fullPath: '/app/faq/create'
      preLoaderRoute: typeof AppFaqCreateRouteRouteImport
      parentRoute: typeof AppFaqRouteRoute
    }
    '/app/external-links_/$externalLinkId': {
      id: '/app/external-links_/$externalLinkId'
      path: '/external-links/$externalLinkId'
      fullPath: '/app/external-links/$externalLinkId'
      preLoaderRoute: typeof AppExternalLinksExternalLinkIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/enterprises_/$enterpriseId': {
      id: '/app/enterprises_/$enterpriseId'
      path: '/enterprises/$enterpriseId'
      fullPath: '/app/enterprises/$enterpriseId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/enterprises/create': {
      id: '/app/enterprises/create'
      path: '/create'
      fullPath: '/app/enterprises/create'
      preLoaderRoute: typeof AppEnterprisesCreateRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/dashboard/delete-collective-tasks': {
      id: '/app/dashboard/delete-collective-tasks'
      path: '/delete-collective-tasks'
      fullPath: '/app/dashboard/delete-collective-tasks'
      preLoaderRoute: typeof AppDashboardDeleteCollectiveTasksRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/create-progressive-info': {
      id: '/app/dashboard/create-progressive-info'
      path: '/create-progressive-info'
      fullPath: '/app/dashboard/create-progressive-info'
      preLoaderRoute: typeof AppDashboardCreateProgressiveInfoRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/create-personal-task': {
      id: '/app/dashboard/create-personal-task'
      path: '/create-personal-task'
      fullPath: '/app/dashboard/create-personal-task'
      preLoaderRoute: typeof AppDashboardCreatePersonalTaskRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/create-collective-task': {
      id: '/app/dashboard/create-collective-task'
      path: '/create-collective-task'
      fullPath: '/app/dashboard/create-collective-task'
      preLoaderRoute: typeof AppDashboardCreateCollectiveTaskRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/businesses-rma/search-by-products': {
      id: '/app/businesses-rma/search-by-products'
      path: '/search-by-products'
      fullPath: '/app/businesses-rma/search-by-products'
      preLoaderRoute: typeof AppBusinessesRmaSearchByProductsRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRouteRoute
    }
    '/app/businesses-rma/representative-turnover': {
      id: '/app/businesses-rma/representative-turnover'
      path: '/representative-turnover'
      fullPath: '/app/businesses-rma/representative-turnover'
      preLoaderRoute: typeof AppBusinessesRmaRepresentativeTurnoverRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRouteRoute
    }
    '/app/products_/$productId/': {
      id: '/app/products_/$productId/'
      path: '/'
      fullPath: '/app/products/$productId/'
      preLoaderRoute: typeof AppProductsProductIdIndexRouteImport
      parentRoute: typeof AppProductsProductIdRouteRoute
    }
    '/app/tools/vva/create': {
      id: '/app/tools/vva/create'
      path: '/create'
      fullPath: '/app/tools/vva/create'
      preLoaderRoute: typeof AppToolsVvaCreateRouteRouteImport
      parentRoute: typeof AppToolsVvaRouteRoute
    }
    '/app/tools/scheduler/create': {
      id: '/app/tools/scheduler/create'
      path: '/create'
      fullPath: '/app/tools/scheduler/create'
      preLoaderRoute: typeof AppToolsSchedulerCreateRouteRouteImport
      parentRoute: typeof AppToolsSchedulerRouteRoute
    }
    '/app/tools/product-shelves/create': {
      id: '/app/tools/product-shelves/create'
      path: '/create'
      fullPath: '/app/tools/product-shelves/create'
      preLoaderRoute: typeof AppToolsProductShelvesCreateRouteRouteImport
      parentRoute: typeof AppToolsProductShelvesRouteRoute
    }
    '/app/tools/product-inventory/validate-quantities': {
      id: '/app/tools/product-inventory/validate-quantities'
      path: '/validate-quantities'
      fullPath: '/app/tools/product-inventory/validate-quantities'
      preLoaderRoute: typeof AppToolsProductInventoryValidateQuantitiesRouteRouteImport
      parentRoute: typeof AppToolsProductInventoryRouteRoute
    }
    '/app/tools/product-filters/create': {
      id: '/app/tools/product-filters/create'
      path: '/create'
      fullPath: '/app/tools/product-filters/create'
      preLoaderRoute: typeof AppToolsProductFiltersCreateRouteRouteImport
      parentRoute: typeof AppToolsProductFiltersRouteRoute
    }
    '/app/tools/predefined-texts/create': {
      id: '/app/tools/predefined-texts/create'
      path: '/create'
      fullPath: '/app/tools/predefined-texts/create'
      preLoaderRoute: typeof AppToolsPredefinedTextsCreateRouteRouteImport
      parentRoute: typeof AppToolsPredefinedTextsRouteRoute
    }
    '/app/tools/predefined-messages/create': {
      id: '/app/tools/predefined-messages/create'
      path: '/create'
      fullPath: '/app/tools/predefined-messages/create'
      preLoaderRoute: typeof AppToolsPredefinedMessagesCreateRouteRouteImport
      parentRoute: typeof AppToolsPredefinedMessagesRouteRoute
    }
    '/app/tools/news/create': {
      id: '/app/tools/news/create'
      path: '/create'
      fullPath: '/app/tools/news/create'
      preLoaderRoute: typeof AppToolsNewsCreateRouteRouteImport
      parentRoute: typeof AppToolsNewsRouteRoute
    }
    '/app/tools/menu/create-product': {
      id: '/app/tools/menu/create-product'
      path: '/create-product'
      fullPath: '/app/tools/menu/create-product'
      preLoaderRoute: typeof AppToolsMenuCreateProductRouteRouteImport
      parentRoute: typeof AppToolsMenuRouteRoute
    }
    '/app/tools/menu/create-enterprise': {
      id: '/app/tools/menu/create-enterprise'
      path: '/create-enterprise'
      fullPath: '/app/tools/menu/create-enterprise'
      preLoaderRoute: typeof AppToolsMenuCreateEnterpriseRouteRouteImport
      parentRoute: typeof AppToolsMenuRouteRoute
    }
    '/app/tools/mails/create': {
      id: '/app/tools/mails/create'
      path: '/create'
      fullPath: '/app/tools/mails/create'
      preLoaderRoute: typeof AppToolsMailsCreateRouteRouteImport
      parentRoute: typeof AppToolsMailsRouteRoute
    }
    '/app/tools/formations/create': {
      id: '/app/tools/formations/create'
      path: '/create'
      fullPath: '/app/tools/formations/create'
      preLoaderRoute: typeof AppToolsFormationsCreateRouteRouteImport
      parentRoute: typeof AppToolsFormationsRouteRoute
    }
    '/app/tools/external-links/create': {
      id: '/app/tools/external-links/create'
      path: '/create'
      fullPath: '/app/tools/external-links/create'
      preLoaderRoute: typeof AppToolsExternalLinksCreateRouteRouteImport
      parentRoute: typeof AppToolsExternalLinksRouteRoute
    }
    '/app/tools/emails/$emailId': {
      id: '/app/tools/emails/$emailId'
      path: '/$emailId'
      fullPath: '/app/tools/emails/$emailId'
      preLoaderRoute: typeof AppToolsEmailsEmailIdRouteRouteImport
      parentRoute: typeof AppToolsEmailsRouteRoute
    }
    '/app/tools/departments/create': {
      id: '/app/tools/departments/create'
      path: '/create'
      fullPath: '/app/tools/departments/create'
      preLoaderRoute: typeof AppToolsDepartmentsCreateRouteRouteImport
      parentRoute: typeof AppToolsDepartmentsRouteRoute
    }
    '/app/tools/ddns/create': {
      id: '/app/tools/ddns/create'
      path: '/create'
      fullPath: '/app/tools/ddns/create'
      preLoaderRoute: typeof AppToolsDdnsCreateRouteRouteImport
      parentRoute: typeof AppToolsDdnsRouteRoute
    }
    '/app/tools/credit/show': {
      id: '/app/tools/credit/show'
      path: '/show'
      fullPath: '/app/tools/credit/show'
      preLoaderRoute: typeof AppToolsCreditShowRouteRouteImport
      parentRoute: typeof AppToolsCreditRouteRoute
    }
    '/app/tools/credit/details': {
      id: '/app/tools/credit/details'
      path: '/details'
      fullPath: '/app/tools/credit/details'
      preLoaderRoute: typeof AppToolsCreditDetailsRouteRouteImport
      parentRoute: typeof AppToolsCreditRouteRoute
    }
    '/app/products_/$productId/manage': {
      id: '/app/products_/$productId/manage'
      path: '/manage'
      fullPath: '/app/products/$productId/manage'
      preLoaderRoute: typeof AppProductsProductIdManageRouteRouteImport
      parentRoute: typeof AppProductsProductIdRouteRoute
    }
    '/app/products_/$productId/informations': {
      id: '/app/products_/$productId/informations'
      path: '/informations'
      fullPath: '/app/products/$productId/informations'
      preLoaderRoute: typeof AppProductsProductIdInformationsRouteRouteImport
      parentRoute: typeof AppProductsProductIdRouteRoute
    }
    '/app/products/serial-numbers/create': {
      id: '/app/products/serial-numbers/create'
      path: '/create'
      fullPath: '/app/products/serial-numbers/create'
      preLoaderRoute: typeof AppProductsSerialNumbersCreateRouteRouteImport
      parentRoute: typeof AppProductsSerialNumbersRouteRoute
    }
    '/app/faq/update/$faqId': {
      id: '/app/faq/update/$faqId'
      path: '/update/$faqId'
      fullPath: '/app/faq/update/$faqId'
      preLoaderRoute: typeof AppFaqUpdateFaqIdRouteRouteImport
      parentRoute: typeof AppFaqRouteRoute
    }
    '/app/faq/send-by-email/$faqId': {
      id: '/app/faq/send-by-email/$faqId'
      path: '/send-by-email/$faqId'
      fullPath: '/app/faq/send-by-email/$faqId'
      preLoaderRoute: typeof AppFaqSendByEmailFaqIdRouteRouteImport
      parentRoute: typeof AppFaqRouteRoute
    }
    '/app/faq/ged/$faqId': {
      id: '/app/faq/ged/$faqId'
      path: '/ged/$faqId'
      fullPath: '/app/faq/ged/$faqId'
      preLoaderRoute: typeof AppFaqGedFaqIdRouteRouteImport
      parentRoute: typeof AppFaqRouteRoute
    }
    '/app/faq/delete/$faqId': {
      id: '/app/faq/delete/$faqId'
      path: '/delete/$faqId'
      fullPath: '/app/faq/delete/$faqId'
      preLoaderRoute: typeof AppFaqDeleteFaqIdRouteRouteImport
      parentRoute: typeof AppFaqRouteRoute
    }
    '/app/faq/archive/$faqId': {
      id: '/app/faq/archive/$faqId'
      path: '/archive/$faqId'
      fullPath: '/app/faq/archive/$faqId'
      preLoaderRoute: typeof AppFaqArchiveFaqIdRouteRouteImport
      parentRoute: typeof AppFaqRouteRoute
    }
    '/app/enterprises_/$enterpriseId/update-representative': {
      id: '/app/enterprises_/$enterpriseId/update-representative'
      path: '/update-representative'
      fullPath: '/app/enterprises/$enterpriseId/update-representative'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/update-category': {
      id: '/app/enterprises_/$enterpriseId/update-category'
      path: '/update-category'
      fullPath: '/app/enterprises/$enterpriseId/update-category'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUpdateCategoryRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/update-accountability': {
      id: '/app/enterprises_/$enterpriseId/update-accountability'
      path: '/update-accountability'
      fullPath: '/app/enterprises/$enterpriseId/update-accountability'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/update': {
      id: '/app/enterprises_/$enterpriseId/update'
      path: '/update'
      fullPath: '/app/enterprises/$enterpriseId/update'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUpdateRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/relate-business-rma': {
      id: '/app/enterprises_/$enterpriseId/relate-business-rma'
      path: '/relate-business-rma'
      fullPath: '/app/enterprises/$enterpriseId/relate-business-rma'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/import-ged-files': {
      id: '/app/enterprises_/$enterpriseId/import-ged-files'
      path: '/import-ged-files'
      fullPath: '/app/enterprises/$enterpriseId/import-ged-files'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdImportGedFilesRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/import-contacts': {
      id: '/app/enterprises_/$enterpriseId/import-contacts'
      path: '/import-contacts'
      fullPath: '/app/enterprises/$enterpriseId/import-contacts'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdImportContactsRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/email-history': {
      id: '/app/enterprises_/$enterpriseId/email-history'
      path: '/email-history'
      fullPath: '/app/enterprises/$enterpriseId/email-history'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/delete': {
      id: '/app/enterprises_/$enterpriseId/delete'
      path: '/delete'
      fullPath: '/app/enterprises/$enterpriseId/delete'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdDeleteRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/create-lifesheet-comment': {
      id: '/app/enterprises_/$enterpriseId/create-lifesheet-comment'
      path: '/create-lifesheet-comment'
      fullPath: '/app/enterprises/$enterpriseId/create-lifesheet-comment'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/create-ged-directory': {
      id: '/app/enterprises_/$enterpriseId/create-ged-directory'
      path: '/create-ged-directory'
      fullPath: '/app/enterprises/$enterpriseId/create-ged-directory'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/create-contact': {
      id: '/app/enterprises_/$enterpriseId/create-contact'
      path: '/create-contact'
      fullPath: '/app/enterprises/$enterpriseId/create-contact'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdCreateContactRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/address-book': {
      id: '/app/enterprises_/$enterpriseId/address-book'
      path: '/address-book'
      fullPath: '/app/enterprises/$enterpriseId/address-book'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdAddressBookRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises/update-contact/$contactId': {
      id: '/app/enterprises/update-contact/$contactId'
      path: '/update-contact/$contactId'
      fullPath: '/app/enterprises/update-contact/$contactId'
      preLoaderRoute: typeof AppEnterprisesUpdateContactContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/enterprises/update-contact-password/$contactId': {
      id: '/app/enterprises/update-contact-password/$contactId'
      path: '/update-contact-password/$contactId'
      fullPath: '/app/enterprises/update-contact-password/$contactId'
      preLoaderRoute: typeof AppEnterprisesUpdateContactPasswordContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/enterprises/send-email-to-contact/$contactId': {
      id: '/app/enterprises/send-email-to-contact/$contactId'
      path: '/send-email-to-contact/$contactId'
      fullPath: '/app/enterprises/send-email-to-contact/$contactId'
      preLoaderRoute: typeof AppEnterprisesSendEmailToContactContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/enterprises/delete-contact/$contactId': {
      id: '/app/enterprises/delete-contact/$contactId'
      path: '/delete-contact/$contactId'
      fullPath: '/app/enterprises/delete-contact/$contactId'
      preLoaderRoute: typeof AppEnterprisesDeleteContactContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/enterprises/create-enterprise-rma/$enterpriseId': {
      id: '/app/enterprises/create-enterprise-rma/$enterpriseId'
      path: '/create-enterprise-rma/$enterpriseId'
      fullPath: '/app/enterprises/create-enterprise-rma/$enterpriseId'
      preLoaderRoute: typeof AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/enterprises/create-contact/$enterpriseId': {
      id: '/app/enterprises/create-contact/$enterpriseId'
      path: '/create-contact/$enterpriseId'
      fullPath: '/app/enterprises/create-contact/$enterpriseId'
      preLoaderRoute: typeof AppEnterprisesCreateContactEnterpriseIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/enterprises/create-contact-travel-voucher/$contactId': {
      id: '/app/enterprises/create-contact-travel-voucher/$contactId'
      path: '/create-contact-travel-voucher/$contactId'
      fullPath: '/app/enterprises/create-contact-travel-voucher/$contactId'
      preLoaderRoute: typeof AppEnterprisesCreateContactTravelVoucherContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/enterprises/create-contact-business/$contactId': {
      id: '/app/enterprises/create-contact-business/$contactId'
      path: '/create-contact-business/$contactId'
      fullPath: '/app/enterprises/create-contact-business/$contactId'
      preLoaderRoute: typeof AppEnterprisesCreateContactBusinessContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesRouteRoute
    }
    '/app/dashboard/validate-personal-task/$taskId': {
      id: '/app/dashboard/validate-personal-task/$taskId'
      path: '/validate-personal-task/$taskId'
      fullPath: '/app/dashboard/validate-personal-task/$taskId'
      preLoaderRoute: typeof AppDashboardValidatePersonalTaskTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/update-progressive-info/$progressiveInfoId': {
      id: '/app/dashboard/update-progressive-info/$progressiveInfoId'
      path: '/update-progressive-info/$progressiveInfoId'
      fullPath: '/app/dashboard/update-progressive-info/$progressiveInfoId'
      preLoaderRoute: typeof AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/update-personal-task-deadline/$taskId': {
      id: '/app/dashboard/update-personal-task-deadline/$taskId'
      path: '/update-personal-task-deadline/$taskId'
      fullPath: '/app/dashboard/update-personal-task-deadline/$taskId'
      preLoaderRoute: typeof AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/update-aircall-contact/$contactId': {
      id: '/app/dashboard/update-aircall-contact/$contactId'
      path: '/update-aircall-contact/$contactId'
      fullPath: '/app/dashboard/update-aircall-contact/$contactId'
      preLoaderRoute: typeof AppDashboardUpdateAircallContactContactIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/unlink-personal-task/$taskId': {
      id: '/app/dashboard/unlink-personal-task/$taskId'
      path: '/unlink-personal-task/$taskId'
      fullPath: '/app/dashboard/unlink-personal-task/$taskId'
      preLoaderRoute: typeof AppDashboardUnlinkPersonalTaskTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/transfer-task/$taskId': {
      id: '/app/dashboard/transfer-task/$taskId'
      path: '/transfer-task/$taskId'
      fullPath: '/app/dashboard/transfer-task/$taskId'
      preLoaderRoute: typeof AppDashboardTransferTaskTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/task-email/$taskId': {
      id: '/app/dashboard/task-email/$taskId'
      path: '/task-email/$taskId'
      fullPath: '/app/dashboard/task-email/$taskId'
      preLoaderRoute: typeof AppDashboardTaskEmailTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/task-comments/$taskId': {
      id: '/app/dashboard/task-comments/$taskId'
      path: '/task-comments/$taskId'
      fullPath: '/app/dashboard/task-comments/$taskId'
      preLoaderRoute: typeof AppDashboardTaskCommentsTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/take-collective-task/$taskId': {
      id: '/app/dashboard/take-collective-task/$taskId'
      path: '/take-collective-task/$taskId'
      fullPath: '/app/dashboard/take-collective-task/$taskId'
      preLoaderRoute: typeof AppDashboardTakeCollectiveTaskTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/scheduler-event-details/$eventId': {
      id: '/app/dashboard/scheduler-event-details/$eventId'
      path: '/scheduler-event-details/$eventId'
      fullPath: '/app/dashboard/scheduler-event-details/$eventId'
      preLoaderRoute: typeof AppDashboardSchedulerEventDetailsEventIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/personal-task-details/$taskId': {
      id: '/app/dashboard/personal-task-details/$taskId'
      path: '/personal-task-details/$taskId'
      fullPath: '/app/dashboard/personal-task-details/$taskId'
      preLoaderRoute: typeof AppDashboardPersonalTaskDetailsTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/other-personal-tasks/$profileId': {
      id: '/app/dashboard/other-personal-tasks/$profileId'
      path: '/other-personal-tasks/$profileId'
      fullPath: '/app/dashboard/other-personal-tasks/$profileId'
      preLoaderRoute: typeof AppDashboardOtherPersonalTasksProfileIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/link-personal-task/$taskId': {
      id: '/app/dashboard/link-personal-task/$taskId'
      path: '/link-personal-task/$taskId'
      fullPath: '/app/dashboard/link-personal-task/$taskId'
      preLoaderRoute: typeof AppDashboardLinkPersonalTaskTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/delete-progressive-info/$progressiveInfoId': {
      id: '/app/dashboard/delete-progressive-info/$progressiveInfoId'
      path: '/delete-progressive-info/$progressiveInfoId'
      fullPath: '/app/dashboard/delete-progressive-info/$progressiveInfoId'
      preLoaderRoute: typeof AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/delete-collective-task/$taskId': {
      id: '/app/dashboard/delete-collective-task/$taskId'
      path: '/delete-collective-task/$taskId'
      fullPath: '/app/dashboard/delete-collective-task/$taskId'
      preLoaderRoute: typeof AppDashboardDeleteCollectiveTaskTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/create-aircall-contact/$number': {
      id: '/app/dashboard/create-aircall-contact/$number'
      path: '/create-aircall-contact/$number'
      fullPath: '/app/dashboard/create-aircall-contact/$number'
      preLoaderRoute: typeof AppDashboardCreateAircallContactNumberRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/dashboard/archive-personal-task/$taskId': {
      id: '/app/dashboard/archive-personal-task/$taskId'
      path: '/archive-personal-task/$taskId'
      fullPath: '/app/dashboard/archive-personal-task/$taskId'
      preLoaderRoute: typeof AppDashboardArchivePersonalTaskTaskIdRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId': {
      id: '/app/businesses-rma_/rma/$rmaId'
      path: '/businesses-rma/rma/$rmaId'
      fullPath: '/app/businesses-rma/rma/$rmaId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/businesses-rma_/business/$businessId': {
      id: '/app/businesses-rma_/business/$businessId'
      path: '/businesses-rma/business/$businessId'
      fullPath: '/app/businesses-rma/business/$businessId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/': {
      id: '/app/businesses-rma_/rma/$rmaId/'
      path: '/'
      fullPath: '/app/businesses-rma/rma/$rmaId/'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdIndexRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/': {
      id: '/app/businesses-rma_/business/$businessId/'
      path: '/'
      fullPath: '/app/businesses-rma/business/$businessId/'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdIndexRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRoute
    }
    '/app/tools/vva/delete/$vvaId': {
      id: '/app/tools/vva/delete/$vvaId'
      path: '/delete/$vvaId'
      fullPath: '/app/tools/vva/delete/$vvaId'
      preLoaderRoute: typeof AppToolsVvaDeleteVvaIdRouteRouteImport
      parentRoute: typeof AppToolsVvaRouteRoute
    }
    '/app/tools/scheduler/details/$rdvId': {
      id: '/app/tools/scheduler/details/$rdvId'
      path: '/details/$rdvId'
      fullPath: '/app/tools/scheduler/details/$rdvId'
      preLoaderRoute: typeof AppToolsSchedulerDetailsRdvIdRouteRouteImport
      parentRoute: typeof AppToolsSchedulerRouteRoute
    }
    '/app/tools/product-shelves/delete/$productShelfId': {
      id: '/app/tools/product-shelves/delete/$productShelfId'
      path: '/delete/$productShelfId'
      fullPath: '/app/tools/product-shelves/delete/$productShelfId'
      preLoaderRoute: typeof AppToolsProductShelvesDeleteProductShelfIdRouteRouteImport
      parentRoute: typeof AppToolsProductShelvesRouteRoute
    }
    '/app/tools/product-inventory/update/$stockId': {
      id: '/app/tools/product-inventory/update/$stockId'
      path: '/update/$stockId'
      fullPath: '/app/tools/product-inventory/update/$stockId'
      preLoaderRoute: typeof AppToolsProductInventoryUpdateStockIdRouteRouteImport
      parentRoute: typeof AppToolsProductInventoryRouteRoute
    }
    '/app/tools/product-filters/update/$productFilterId': {
      id: '/app/tools/product-filters/update/$productFilterId'
      path: '/update/$productFilterId'
      fullPath: '/app/tools/product-filters/update/$productFilterId'
      preLoaderRoute: typeof AppToolsProductFiltersUpdateProductFilterIdRouteRouteImport
      parentRoute: typeof AppToolsProductFiltersRouteRoute
    }
    '/app/tools/product-filters/delete/$productFilterId': {
      id: '/app/tools/product-filters/delete/$productFilterId'
      path: '/delete/$productFilterId'
      fullPath: '/app/tools/product-filters/delete/$productFilterId'
      preLoaderRoute: typeof AppToolsProductFiltersDeleteProductFilterIdRouteRouteImport
      parentRoute: typeof AppToolsProductFiltersRouteRoute
    }
    '/app/tools/predefined-texts/update/$predefinedTextId': {
      id: '/app/tools/predefined-texts/update/$predefinedTextId'
      path: '/update/$predefinedTextId'
      fullPath: '/app/tools/predefined-texts/update/$predefinedTextId'
      preLoaderRoute: typeof AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRouteImport
      parentRoute: typeof AppToolsPredefinedTextsRouteRoute
    }
    '/app/tools/predefined-texts/delete/$predefinedTextId': {
      id: '/app/tools/predefined-texts/delete/$predefinedTextId'
      path: '/delete/$predefinedTextId'
      fullPath: '/app/tools/predefined-texts/delete/$predefinedTextId'
      preLoaderRoute: typeof AppToolsPredefinedTextsDeletePredefinedTextIdRouteRouteImport
      parentRoute: typeof AppToolsPredefinedTextsRouteRoute
    }
    '/app/tools/predefined-messages/update/$predefinedMessageId': {
      id: '/app/tools/predefined-messages/update/$predefinedMessageId'
      path: '/update/$predefinedMessageId'
      fullPath: '/app/tools/predefined-messages/update/$predefinedMessageId'
      preLoaderRoute: typeof AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRouteImport
      parentRoute: typeof AppToolsPredefinedMessagesRouteRoute
    }
    '/app/tools/predefined-messages/delete/$predefinedMessageId': {
      id: '/app/tools/predefined-messages/delete/$predefinedMessageId'
      path: '/delete/$predefinedMessageId'
      fullPath: '/app/tools/predefined-messages/delete/$predefinedMessageId'
      preLoaderRoute: typeof AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRouteImport
      parentRoute: typeof AppToolsPredefinedMessagesRouteRoute
    }
    '/app/tools/news/update/$newsId': {
      id: '/app/tools/news/update/$newsId'
      path: '/update/$newsId'
      fullPath: '/app/tools/news/update/$newsId'
      preLoaderRoute: typeof AppToolsNewsUpdateNewsIdRouteRouteImport
      parentRoute: typeof AppToolsNewsRouteRoute
    }
    '/app/tools/news/delete/$newsId': {
      id: '/app/tools/news/delete/$newsId'
      path: '/delete/$newsId'
      fullPath: '/app/tools/news/delete/$newsId'
      preLoaderRoute: typeof AppToolsNewsDeleteNewsIdRouteRouteImport
      parentRoute: typeof AppToolsNewsRouteRoute
    }
    '/app/tools/mails/update/$mailId': {
      id: '/app/tools/mails/update/$mailId'
      path: '/update/$mailId'
      fullPath: '/app/tools/mails/update/$mailId'
      preLoaderRoute: typeof AppToolsMailsUpdateMailIdRouteRouteImport
      parentRoute: typeof AppToolsMailsRouteRoute
    }
    '/app/tools/mails/show/$mailId': {
      id: '/app/tools/mails/show/$mailId'
      path: '/show/$mailId'
      fullPath: '/app/tools/mails/show/$mailId'
      preLoaderRoute: typeof AppToolsMailsShowMailIdRouteRouteImport
      parentRoute: typeof AppToolsMailsRouteRoute
    }
    '/app/tools/mails/delete/$mailId': {
      id: '/app/tools/mails/delete/$mailId'
      path: '/delete/$mailId'
      fullPath: '/app/tools/mails/delete/$mailId'
      preLoaderRoute: typeof AppToolsMailsDeleteMailIdRouteRouteImport
      parentRoute: typeof AppToolsMailsRouteRoute
    }
    '/app/tools/formations/update/$formationId': {
      id: '/app/tools/formations/update/$formationId'
      path: '/update/$formationId'
      fullPath: '/app/tools/formations/update/$formationId'
      preLoaderRoute: typeof AppToolsFormationsUpdateFormationIdRouteRouteImport
      parentRoute: typeof AppToolsFormationsRouteRoute
    }
    '/app/tools/formations/subscribers/$formationDetailId': {
      id: '/app/tools/formations/subscribers/$formationDetailId'
      path: '/subscribers/$formationDetailId'
      fullPath: '/app/tools/formations/subscribers/$formationDetailId'
      preLoaderRoute: typeof AppToolsFormationsSubscribersFormationDetailIdRouteRouteImport
      parentRoute: typeof AppToolsFormationsRouteRoute
    }
    '/app/tools/formations/delete/$formationId': {
      id: '/app/tools/formations/delete/$formationId'
      path: '/delete/$formationId'
      fullPath: '/app/tools/formations/delete/$formationId'
      preLoaderRoute: typeof AppToolsFormationsDeleteFormationIdRouteRouteImport
      parentRoute: typeof AppToolsFormationsRouteRoute
    }
    '/app/tools/formations/create/details': {
      id: '/app/tools/formations/create/details'
      path: '/details'
      fullPath: '/app/tools/formations/create/details'
      preLoaderRoute: typeof AppToolsFormationsCreateDetailsRouteRouteImport
      parentRoute: typeof AppToolsFormationsCreateRouteRoute
    }
    '/app/tools/formations/create/add-detail': {
      id: '/app/tools/formations/create/add-detail'
      path: '/add-detail'
      fullPath: '/app/tools/formations/create/add-detail'
      preLoaderRoute: typeof AppToolsFormationsCreateAddDetailRouteRouteImport
      parentRoute: typeof AppToolsFormationsCreateRouteRoute
    }
    '/app/tools/external-links/update/$externalLinkId': {
      id: '/app/tools/external-links/update/$externalLinkId'
      path: '/update/$externalLinkId'
      fullPath: '/app/tools/external-links/update/$externalLinkId'
      preLoaderRoute: typeof AppToolsExternalLinksUpdateExternalLinkIdRouteRouteImport
      parentRoute: typeof AppToolsExternalLinksRouteRoute
    }
    '/app/tools/external-links/delete/$externalLinkId': {
      id: '/app/tools/external-links/delete/$externalLinkId'
      path: '/delete/$externalLinkId'
      fullPath: '/app/tools/external-links/delete/$externalLinkId'
      preLoaderRoute: typeof AppToolsExternalLinksDeleteExternalLinkIdRouteRouteImport
      parentRoute: typeof AppToolsExternalLinksRouteRoute
    }
    '/app/tools/external-links/archive/$externalLinkId': {
      id: '/app/tools/external-links/archive/$externalLinkId'
      path: '/archive/$externalLinkId'
      fullPath: '/app/tools/external-links/archive/$externalLinkId'
      preLoaderRoute: typeof AppToolsExternalLinksArchiveExternalLinkIdRouteRouteImport
      parentRoute: typeof AppToolsExternalLinksRouteRoute
    }
    '/app/tools/emails/$emailId/resend': {
      id: '/app/tools/emails/$emailId/resend'
      path: '/resend'
      fullPath: '/app/tools/emails/$emailId/resend'
      preLoaderRoute: typeof AppToolsEmailsEmailIdResendRouteRouteImport
      parentRoute: typeof AppToolsEmailsEmailIdRouteRoute
    }
    '/app/tools/emails/$emailId/reply': {
      id: '/app/tools/emails/$emailId/reply'
      path: '/reply'
      fullPath: '/app/tools/emails/$emailId/reply'
      preLoaderRoute: typeof AppToolsEmailsEmailIdReplyRouteRouteImport
      parentRoute: typeof AppToolsEmailsEmailIdRouteRoute
    }
    '/app/tools/departments/update/$departmentId': {
      id: '/app/tools/departments/update/$departmentId'
      path: '/update/$departmentId'
      fullPath: '/app/tools/departments/update/$departmentId'
      preLoaderRoute: typeof AppToolsDepartmentsUpdateDepartmentIdRouteRouteImport
      parentRoute: typeof AppToolsDepartmentsRouteRoute
    }
    '/app/tools/departments/delete/$departmentId': {
      id: '/app/tools/departments/delete/$departmentId'
      path: '/delete/$departmentId'
      fullPath: '/app/tools/departments/delete/$departmentId'
      preLoaderRoute: typeof AppToolsDepartmentsDeleteDepartmentIdRouteRouteImport
      parentRoute: typeof AppToolsDepartmentsRouteRoute
    }
    '/app/tools/ddns/delete/$ddnsId': {
      id: '/app/tools/ddns/delete/$ddnsId'
      path: '/delete/$ddnsId'
      fullPath: '/app/tools/ddns/delete/$ddnsId'
      preLoaderRoute: typeof AppToolsDdnsDeleteDdnsIdRouteRouteImport
      parentRoute: typeof AppToolsDdnsRouteRoute
    }
    '/app/products_/$productId/manage/create-version': {
      id: '/app/products_/$productId/manage/create-version'
      path: '/create-version'
      fullPath: '/app/products/$productId/manage/create-version'
      preLoaderRoute: typeof AppProductsProductIdManageCreateVersionRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/create-stock': {
      id: '/app/products_/$productId/manage/create-stock'
      path: '/create-stock'
      fullPath: '/app/products/$productId/manage/create-stock'
      preLoaderRoute: typeof AppProductsProductIdManageCreateStockRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/add-specification': {
      id: '/app/products_/$productId/manage/add-specification'
      path: '/add-specification'
      fullPath: '/app/products/$productId/manage/add-specification'
      preLoaderRoute: typeof AppProductsProductIdManageAddSpecificationRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/add-nomenclature-detail': {
      id: '/app/products_/$productId/manage/add-nomenclature-detail'
      path: '/add-nomenclature-detail'
      fullPath: '/app/products/$productId/manage/add-nomenclature-detail'
      preLoaderRoute: typeof AppProductsProductIdManageAddNomenclatureDetailRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/add-associated-product': {
      id: '/app/products_/$productId/manage/add-associated-product'
      path: '/add-associated-product'
      fullPath: '/app/products/$productId/manage/add-associated-product'
      preLoaderRoute: typeof AppProductsProductIdManageAddAssociatedProductRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/informations/rename-ged-object': {
      id: '/app/products_/$productId/informations/rename-ged-object'
      path: '/rename-ged-object'
      fullPath: '/app/products/$productId/informations/rename-ged-object'
      preLoaderRoute: typeof AppProductsProductIdInformationsRenameGedObjectRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/products_/$productId/informations/import-ged-files': {
      id: '/app/products_/$productId/informations/import-ged-files'
      path: '/import-ged-files'
      fullPath: '/app/products/$productId/informations/import-ged-files'
      preLoaderRoute: typeof AppProductsProductIdInformationsImportGedFilesRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/products_/$productId/informations/delete-ged-object': {
      id: '/app/products_/$productId/informations/delete-ged-object'
      path: '/delete-ged-object'
      fullPath: '/app/products/$productId/informations/delete-ged-object'
      preLoaderRoute: typeof AppProductsProductIdInformationsDeleteGedObjectRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/products_/$productId/informations/create-lifesheet-comment': {
      id: '/app/products_/$productId/informations/create-lifesheet-comment'
      path: '/create-lifesheet-comment'
      fullPath: '/app/products/$productId/informations/create-lifesheet-comment'
      preLoaderRoute: typeof AppProductsProductIdInformationsCreateLifesheetCommentRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/products_/$productId/informations/create-ged-directory': {
      id: '/app/products_/$productId/informations/create-ged-directory'
      path: '/create-ged-directory'
      fullPath: '/app/products/$productId/informations/create-ged-directory'
      preLoaderRoute: typeof AppProductsProductIdInformationsCreateGedDirectoryRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/products/serial-numbers/update/$serialNumberId': {
      id: '/app/products/serial-numbers/update/$serialNumberId'
      path: '/update/$serialNumberId'
      fullPath: '/app/products/serial-numbers/update/$serialNumberId'
      preLoaderRoute: typeof AppProductsSerialNumbersUpdateSerialNumberIdRouteRouteImport
      parentRoute: typeof AppProductsSerialNumbersRouteRoute
    }
    '/app/products/serial-numbers/remove-from-business/$serialNumberId': {
      id: '/app/products/serial-numbers/remove-from-business/$serialNumberId'
      path: '/remove-from-business/$serialNumberId'
      fullPath: '/app/products/serial-numbers/remove-from-business/$serialNumberId'
      preLoaderRoute: typeof AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRouteImport
      parentRoute: typeof AppProductsSerialNumbersRouteRoute
    }
    '/app/products/serial-numbers/delete/$serialNumberId': {
      id: '/app/products/serial-numbers/delete/$serialNumberId'
      path: '/delete/$serialNumberId'
      fullPath: '/app/products/serial-numbers/delete/$serialNumberId'
      preLoaderRoute: typeof AppProductsSerialNumbersDeleteSerialNumberIdRouteRouteImport
      parentRoute: typeof AppProductsSerialNumbersRouteRoute
    }
    '/app/products/serial-numbers/create-rma/$serialNumberId': {
      id: '/app/products/serial-numbers/create-rma/$serialNumberId'
      path: '/create-rma/$serialNumberId'
      fullPath: '/app/products/serial-numbers/create-rma/$serialNumberId'
      preLoaderRoute: typeof AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRouteImport
      parentRoute: typeof AppProductsSerialNumbersRouteRoute
    }
    '/app/faq/ged/$faqId/import-files': {
      id: '/app/faq/ged/$faqId/import-files'
      path: '/import-files'
      fullPath: '/app/faq/ged/$faqId/import-files'
      preLoaderRoute: typeof AppFaqGedFaqIdImportFilesRouteRouteImport
      parentRoute: typeof AppFaqGedFaqIdRouteRoute
    }
    '/app/faq/ged/$faqId/create-directory': {
      id: '/app/faq/ged/$faqId/create-directory'
      path: '/create-directory'
      fullPath: '/app/faq/ged/$faqId/create-directory'
      preLoaderRoute: typeof AppFaqGedFaqIdCreateDirectoryRouteRouteImport
      parentRoute: typeof AppFaqGedFaqIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/update-contact/$contactId': {
      id: '/app/enterprises_/$enterpriseId/update-contact/$contactId'
      path: '/update-contact/$contactId'
      fullPath: '/app/enterprises/$enterpriseId/update-contact/$contactId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/update-contact-password/$contactId': {
      id: '/app/enterprises_/$enterpriseId/update-contact-password/$contactId'
      path: '/update-contact-password/$contactId'
      fullPath: '/app/enterprises/$enterpriseId/update-contact-password/$contactId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/unrelate-business-rma/$businessRmaId': {
      id: '/app/enterprises_/$enterpriseId/unrelate-business-rma/$businessRmaId'
      path: '/unrelate-business-rma/$businessRmaId'
      fullPath: '/app/enterprises/$enterpriseId/unrelate-business-rma/$businessRmaId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/unlink-task/$taskId': {
      id: '/app/enterprises_/$enterpriseId/unlink-task/$taskId'
      path: '/unlink-task/$taskId'
      fullPath: '/app/enterprises/$enterpriseId/unlink-task/$taskId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/task-email/$taskId': {
      id: '/app/enterprises_/$enterpriseId/task-email/$taskId'
      path: '/task-email/$taskId'
      fullPath: '/app/enterprises/$enterpriseId/task-email/$taskId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/send-email-to-contact/$contactId': {
      id: '/app/enterprises_/$enterpriseId/send-email-to-contact/$contactId'
      path: '/send-email-to-contact/$contactId'
      fullPath: '/app/enterprises/$enterpriseId/send-email-to-contact/$contactId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/rename-ged-object/$objectRelativePath': {
      id: '/app/enterprises_/$enterpriseId/rename-ged-object/$objectRelativePath'
      path: '/rename-ged-object/$objectRelativePath'
      fullPath: '/app/enterprises/$enterpriseId/rename-ged-object/$objectRelativePath'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId': {
      id: '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId'
      path: '/lifesheet-email/$lifesheetId'
      fullPath: '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/delete-ged-object/$objectRelativePath': {
      id: '/app/enterprises_/$enterpriseId/delete-ged-object/$objectRelativePath'
      path: '/delete-ged-object/$objectRelativePath'
      fullPath: '/app/enterprises/$enterpriseId/delete-ged-object/$objectRelativePath'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/delete-contact/$contactId': {
      id: '/app/enterprises_/$enterpriseId/delete-contact/$contactId'
      path: '/delete-contact/$contactId'
      fullPath: '/app/enterprises/$enterpriseId/delete-contact/$contactId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/create-contact-business/$contactId': {
      id: '/app/enterprises_/$enterpriseId/create-contact-business/$contactId'
      path: '/create-contact-business/$contactId'
      fullPath: '/app/enterprises/$enterpriseId/create-contact-business/$contactId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/address-book/import': {
      id: '/app/enterprises_/$enterpriseId/address-book/import'
      path: '/import'
      fullPath: '/app/enterprises/$enterpriseId/address-book/import'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdAddressBookImportRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdAddressBookRouteRoute
    }
    '/app/enterprises_/$enterpriseId/address-book/create': {
      id: '/app/enterprises_/$enterpriseId/address-book/create'
      path: '/create'
      fullPath: '/app/enterprises/$enterpriseId/address-book/create'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdAddressBookCreateRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdAddressBookRouteRoute
    }
    '/app/dashboard/task-email/$taskId/resend': {
      id: '/app/dashboard/task-email/$taskId/resend'
      path: '/resend'
      fullPath: '/app/dashboard/task-email/$taskId/resend'
      preLoaderRoute: typeof AppDashboardTaskEmailTaskIdResendRouteRouteImport
      parentRoute: typeof AppDashboardTaskEmailTaskIdRouteRoute
    }
    '/app/dashboard/task-email/$taskId/reply': {
      id: '/app/dashboard/task-email/$taskId/reply'
      path: '/reply'
      fullPath: '/app/dashboard/task-email/$taskId/reply'
      preLoaderRoute: typeof AppDashboardTaskEmailTaskIdReplyRouteRouteImport
      parentRoute: typeof AppDashboardTaskEmailTaskIdRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support': {
      id: '/app/businesses-rma_/rma/$rmaId/support'
      path: '/support'
      fullPath: '/app/businesses-rma/rma/$rmaId/support'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/reception': {
      id: '/app/businesses-rma_/rma/$rmaId/reception'
      path: '/reception'
      fullPath: '/app/businesses-rma/rma/$rmaId/reception'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdReceptionRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/delivery': {
      id: '/app/businesses-rma_/rma/$rmaId/delivery'
      path: '/delivery'
      fullPath: '/app/businesses-rma/rma/$rmaId/delivery'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/study': {
      id: '/app/businesses-rma_/business/$businessId_/study'
      path: '/businesses-rma/business/$businessId/study'
      fullPath: '/app/businesses-rma/business/$businessId/study'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation': {
      id: '/app/businesses-rma_/business/$businessId/quotation'
      path: '/quotation'
      fullPath: '/app/businesses-rma/business/$businessId/quotation'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard': {
      id: '/app/businesses-rma_/business/$businessId/dashboard'
      path: '/dashboard'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp': {
      id: '/app/businesses-rma_/business/$businessId/bp'
      path: '/bp'
      fullPath: '/app/businesses-rma/business/$businessId/bp'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bl': {
      id: '/app/businesses-rma_/business/$businessId/bl'
      path: '/bl'
      fullPath: '/app/businesses-rma/business/$businessId/bl'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBlRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bill': {
      id: '/app/businesses-rma_/business/$businessId/bill'
      path: '/bill'
      fullPath: '/app/businesses-rma/business/$businessId/bill'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBillRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/arc': {
      id: '/app/businesses-rma_/business/$businessId/arc'
      path: '/arc'
      fullPath: '/app/businesses-rma/business/$businessId/arc'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdArcRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/study/': {
      id: '/app/businesses-rma_/business/$businessId_/study/'
      path: '/'
      fullPath: '/app/businesses-rma/business/$businessId/study/'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyIndexRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyRouteRoute
    }
    '/app/tools/scheduler/details/$rdvId/update': {
      id: '/app/tools/scheduler/details/$rdvId/update'
      path: '/update'
      fullPath: '/app/tools/scheduler/details/$rdvId/update'
      preLoaderRoute: typeof AppToolsSchedulerDetailsRdvIdUpdateRouteRouteImport
      parentRoute: typeof AppToolsSchedulerDetailsRdvIdRouteRoute
    }
    '/app/tools/scheduler/details/$rdvId/delete': {
      id: '/app/tools/scheduler/details/$rdvId/delete'
      path: '/delete'
      fullPath: '/app/tools/scheduler/details/$rdvId/delete'
      preLoaderRoute: typeof AppToolsSchedulerDetailsRdvIdDeleteRouteRouteImport
      parentRoute: typeof AppToolsSchedulerDetailsRdvIdRouteRoute
    }
    '/app/tools/formations/update/$formationId/details': {
      id: '/app/tools/formations/update/$formationId/details'
      path: '/details'
      fullPath: '/app/tools/formations/update/$formationId/details'
      preLoaderRoute: typeof AppToolsFormationsUpdateFormationIdDetailsRouteRouteImport
      parentRoute: typeof AppToolsFormationsUpdateFormationIdRouteRoute
    }
    '/app/tools/formations/update/$formationId/add-detail': {
      id: '/app/tools/formations/update/$formationId/add-detail'
      path: '/add-detail'
      fullPath: '/app/tools/formations/update/$formationId/add-detail'
      preLoaderRoute: typeof AppToolsFormationsUpdateFormationIdAddDetailRouteRouteImport
      parentRoute: typeof AppToolsFormationsUpdateFormationIdRouteRoute
    }
    '/app/tools/formations/subscribers/$formationDetailId/create': {
      id: '/app/tools/formations/subscribers/$formationDetailId/create'
      path: '/create'
      fullPath: '/app/tools/formations/subscribers/$formationDetailId/create'
      preLoaderRoute: typeof AppToolsFormationsSubscribersFormationDetailIdCreateRouteRouteImport
      parentRoute: typeof AppToolsFormationsSubscribersFormationDetailIdRouteRoute
    }
    '/app/products_/$productId/manage/update-version/$versionId': {
      id: '/app/products_/$productId/manage/update-version/$versionId'
      path: '/update-version/$versionId'
      fullPath: '/app/products/$productId/manage/update-version/$versionId'
      preLoaderRoute: typeof AppProductsProductIdManageUpdateVersionVersionIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/update-stock/$stockId': {
      id: '/app/products_/$productId/manage/update-stock/$stockId'
      path: '/update-stock/$stockId'
      fullPath: '/app/products/$productId/manage/update-stock/$stockId'
      preLoaderRoute: typeof AppProductsProductIdManageUpdateStockStockIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/update-specification/$specificationId': {
      id: '/app/products_/$productId/manage/update-specification/$specificationId'
      path: '/update-specification/$specificationId'
      fullPath: '/app/products/$productId/manage/update-specification/$specificationId'
      preLoaderRoute: typeof AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId': {
      id: '/app/products_/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId'
      path: '/update-nomenclature-detail/$nomenclatureDetailId'
      fullPath: '/app/products/$productId/manage/update-nomenclature-detail/$nomenclatureDetailId'
      preLoaderRoute: typeof AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/stock-history/$stockId': {
      id: '/app/products_/$productId/manage/stock-history/$stockId'
      path: '/stock-history/$stockId'
      fullPath: '/app/products/$productId/manage/stock-history/$stockId'
      preLoaderRoute: typeof AppProductsProductIdManageStockHistoryStockIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/remove-associated-product/$associatedProductId': {
      id: '/app/products_/$productId/manage/remove-associated-product/$associatedProductId'
      path: '/remove-associated-product/$associatedProductId'
      fullPath: '/app/products/$productId/manage/remove-associated-product/$associatedProductId'
      preLoaderRoute: typeof AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/delete-version/$versionId': {
      id: '/app/products_/$productId/manage/delete-version/$versionId'
      path: '/delete-version/$versionId'
      fullPath: '/app/products/$productId/manage/delete-version/$versionId'
      preLoaderRoute: typeof AppProductsProductIdManageDeleteVersionVersionIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/delete-stock/$stockId': {
      id: '/app/products_/$productId/manage/delete-stock/$stockId'
      path: '/delete-stock/$stockId'
      fullPath: '/app/products/$productId/manage/delete-stock/$stockId'
      preLoaderRoute: typeof AppProductsProductIdManageDeleteStockStockIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/delete-specification/$specificationId': {
      id: '/app/products_/$productId/manage/delete-specification/$specificationId'
      path: '/delete-specification/$specificationId'
      fullPath: '/app/products/$productId/manage/delete-specification/$specificationId'
      preLoaderRoute: typeof AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId': {
      id: '/app/products_/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId'
      path: '/delete-nomenclature-detail/$nomenclatureDetailId'
      fullPath: '/app/products/$productId/manage/delete-nomenclature-detail/$nomenclatureDetailId'
      preLoaderRoute: typeof AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageRouteRoute
    }
    '/app/products_/$productId/manage/add-specification/$filterId': {
      id: '/app/products_/$productId/manage/add-specification/$filterId'
      path: '/$filterId'
      fullPath: '/app/products/$productId/manage/add-specification/$filterId'
      preLoaderRoute: typeof AppProductsProductIdManageAddSpecificationFilterIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdManageAddSpecificationRouteRoute
    }
    '/app/products_/$productId/informations/unlink-task/$taskId': {
      id: '/app/products_/$productId/informations/unlink-task/$taskId'
      path: '/unlink-task/$taskId'
      fullPath: '/app/products/$productId/informations/unlink-task/$taskId'
      preLoaderRoute: typeof AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/products_/$productId/informations/task-email/$taskId': {
      id: '/app/products_/$productId/informations/task-email/$taskId'
      path: '/task-email/$taskId'
      fullPath: '/app/products/$productId/informations/task-email/$taskId'
      preLoaderRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/products_/$productId/informations/lifesheet-email/$lifesheetId': {
      id: '/app/products_/$productId/informations/lifesheet-email/$lifesheetId'
      path: '/lifesheet-email/$lifesheetId'
      fullPath: '/app/products/$productId/informations/lifesheet-email/$lifesheetId'
      preLoaderRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsRouteRoute
    }
    '/app/faq/ged/$faqId/rename/$itemRelativePath': {
      id: '/app/faq/ged/$faqId/rename/$itemRelativePath'
      path: '/rename/$itemRelativePath'
      fullPath: '/app/faq/ged/$faqId/rename/$itemRelativePath'
      preLoaderRoute: typeof AppFaqGedFaqIdRenameItemRelativePathRouteRouteImport
      parentRoute: typeof AppFaqGedFaqIdRouteRoute
    }
    '/app/faq/ged/$faqId/delete/$itemRelativePath': {
      id: '/app/faq/ged/$faqId/delete/$itemRelativePath'
      path: '/delete/$itemRelativePath'
      fullPath: '/app/faq/ged/$faqId/delete/$itemRelativePath'
      preLoaderRoute: typeof AppFaqGedFaqIdDeleteItemRelativePathRouteRouteImport
      parentRoute: typeof AppFaqGedFaqIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/task-email/$taskId/resend': {
      id: '/app/enterprises_/$enterpriseId/task-email/$taskId/resend'
      path: '/resend'
      fullPath: '/app/enterprises/$enterpriseId/task-email/$taskId/resend'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/task-email/$taskId/reply': {
      id: '/app/enterprises_/$enterpriseId/task-email/$taskId/reply'
      path: '/reply'
      fullPath: '/app/enterprises/$enterpriseId/task-email/$taskId/reply'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/resend': {
      id: '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/resend'
      path: '/resend'
      fullPath: '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/resend'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/reply': {
      id: '/app/enterprises_/$enterpriseId/lifesheet-email/$lifesheetId/reply'
      path: '/reply'
      fullPath: '/app/enterprises/$enterpriseId/lifesheet-email/$lifesheetId/reply'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/email-history/email/$emailId': {
      id: '/app/enterprises_/$enterpriseId/email-history/email/$emailId'
      path: '/email/$emailId'
      fullPath: '/app/enterprises/$enterpriseId/email-history/email/$emailId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryRouteRoute
    }
    '/app/enterprises_/$enterpriseId/address-book/update/$addressId': {
      id: '/app/enterprises_/$enterpriseId/address-book/update/$addressId'
      path: '/update/$addressId'
      fullPath: '/app/enterprises/$enterpriseId/address-book/update/$addressId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdAddressBookRouteRoute
    }
    '/app/enterprises_/$enterpriseId/address-book/delete/$addressId': {
      id: '/app/enterprises_/$enterpriseId/address-book/delete/$addressId'
      path: '/delete/$addressId'
      fullPath: '/app/enterprises/$enterpriseId/address-book/delete/$addressId'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdAddressBookRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/pdf': {
      id: '/app/businesses-rma_/rma/$rmaId/support/pdf'
      path: '/pdf'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/pdf'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/import-ged-files': {
      id: '/app/businesses-rma_/rma/$rmaId/support/import-ged-files'
      path: '/import-ged-files'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/import-ged-files'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/create-link': {
      id: '/app/businesses-rma_/rma/$rmaId/support/create-link'
      path: '/create-link'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/create-link'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/create-lifesheet': {
      id: '/app/businesses-rma_/rma/$rmaId/support/create-lifesheet'
      path: '/create-lifesheet'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/create-lifesheet'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/create-ged-directory': {
      id: '/app/businesses-rma_/rma/$rmaId/support/create-ged-directory'
      path: '/create-ged-directory'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/create-ged-directory'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/create-detail': {
      id: '/app/businesses-rma_/rma/$rmaId/support/create-detail'
      path: '/create-detail'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/create-detail'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/reception/pdf': {
      id: '/app/businesses-rma_/rma/$rmaId/reception/pdf'
      path: '/pdf'
      fullPath: '/app/businesses-rma/rma/$rmaId/reception/pdf'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdReceptionRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/reception/create-detail': {
      id: '/app/businesses-rma_/rma/$rmaId/reception/create-detail'
      path: '/create-detail'
      fullPath: '/app/businesses-rma/rma/$rmaId/reception/create-detail'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdReceptionRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/delivery/travel-voucher': {
      id: '/app/businesses-rma_/rma/$rmaId/delivery/travel-voucher'
      path: '/travel-voucher'
      fullPath: '/app/businesses-rma/rma/$rmaId/delivery/travel-voucher'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/delivery/pdf': {
      id: '/app/businesses-rma_/rma/$rmaId/delivery/pdf'
      path: '/pdf'
      fullPath: '/app/businesses-rma/rma/$rmaId/delivery/pdf'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/delivery/create-detail': {
      id: '/app/businesses-rma_/rma/$rmaId/delivery/create-detail'
      path: '/create-detail'
      fullPath: '/app/businesses-rma/rma/$rmaId/delivery/create-detail'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/study/expert': {
      id: '/app/businesses-rma_/business/$businessId_/study/expert'
      path: '/expert'
      fullPath: '/app/businesses-rma/business/$businessId/study/expert'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/study/automatic': {
      id: '/app/businesses-rma_/business/$businessId_/study/automatic'
      path: '/automatic'
      fullPath: '/app/businesses-rma/business/$businessId/study/automatic'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId'
      path: '/businesses-rma/business/$businessId/assistance/$assistanceId'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/update-shipping-price': {
      id: '/app/businesses-rma_/business/$businessId/quotation/update-shipping-price'
      path: '/update-shipping-price'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/update-shipping-price'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/pdf': {
      id: '/app/businesses-rma_/business/$businessId/quotation/pdf'
      path: '/pdf'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/pdf'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/commercial-notice': {
      id: '/app/businesses-rma_/business/$businessId/quotation/commercial-notice'
      path: '/commercial-notice'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/commercial-notice'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/update-responsible': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/update-responsible'
      path: '/update-responsible'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/update-responsible'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/update-representative': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/update-representative'
      path: '/update-representative'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/update-representative'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/update-billing-address': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/update-billing-address'
      path: '/update-billing-address'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/update-billing-address'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/send-email': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/send-email'
      path: '/send-email'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/send-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/import-ged-files': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/import-ged-files'
      path: '/import-ged-files'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/import-ged-files'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/email-history': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/email-history'
      path: '/email-history'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/email-history'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/delete': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/delete'
      path: '/delete'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/delete'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/create-link': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/create-link'
      path: '/create-link'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/create-link'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/create-lifesheet': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/create-lifesheet'
      path: '/create-lifesheet'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/create-lifesheet'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/create-ged-directory': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/create-ged-directory'
      path: '/create-ged-directory'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/create-ged-directory'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/address-book': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/address-book'
      path: '/address-book'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/address-book'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp/travel-voucher': {
      id: '/app/businesses-rma_/business/$businessId/bp/travel-voucher'
      path: '/travel-voucher'
      fullPath: '/app/businesses-rma/business/$businessId/bp/travel-voucher'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bl/update': {
      id: '/app/businesses-rma_/business/$businessId/bl/update'
      path: '/update'
      fullPath: '/app/businesses-rma/business/$businessId/bl/update'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBlRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bl/send-by-email': {
      id: '/app/businesses-rma_/business/$businessId/bl/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/business/$businessId/bl/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBlRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bill/send-by-email': {
      id: '/app/businesses-rma_/business/$businessId/bill/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/business/$businessId/bill/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBillRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bill/credits': {
      id: '/app/businesses-rma_/business/$businessId/bill/credits'
      path: '/credits'
      fullPath: '/app/businesses-rma/business/$businessId/bill/credits'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBillRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/arc/update-shipping-price': {
      id: '/app/businesses-rma_/business/$businessId/arc/update-shipping-price'
      path: '/update-shipping-price'
      fullPath: '/app/businesses-rma/business/$businessId/arc/update-shipping-price'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdArcRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/arc/pdf': {
      id: '/app/businesses-rma_/business/$businessId/arc/pdf'
      path: '/pdf'
      fullPath: '/app/businesses-rma/business/$businessId/arc/pdf'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdArcRouteRoute
    }
    '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId': {
      id: '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId'
      path: '/send-email/$subscriptionId'
      fullPath: '/app/tools/formations/subscribers/$formationDetailId/send-email/$subscriptionId'
      preLoaderRoute: typeof AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRouteImport
      parentRoute: typeof AppToolsFormationsSubscribersFormationDetailIdRouteRoute
    }
    '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId': {
      id: '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId'
      path: '/delete/$subscriptionId'
      fullPath: '/app/tools/formations/subscribers/$formationDetailId/delete/$subscriptionId'
      preLoaderRoute: typeof AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRouteImport
      parentRoute: typeof AppToolsFormationsSubscribersFormationDetailIdRouteRoute
    }
    '/app/products_/$productId/informations/task-email/$taskId/resend': {
      id: '/app/products_/$productId/informations/task-email/$taskId/resend'
      path: '/resend'
      fullPath: '/app/products/$productId/informations/task-email/$taskId/resend'
      preLoaderRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute
    }
    '/app/products_/$productId/informations/task-email/$taskId/reply': {
      id: '/app/products_/$productId/informations/task-email/$taskId/reply'
      path: '/reply'
      fullPath: '/app/products/$productId/informations/task-email/$taskId/reply'
      preLoaderRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute
    }
    '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/resend': {
      id: '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/resend'
      path: '/resend'
      fullPath: '/app/products/$productId/informations/lifesheet-email/$lifesheetId/resend'
      preLoaderRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/reply': {
      id: '/app/products_/$productId/informations/lifesheet-email/$lifesheetId/reply'
      path: '/reply'
      fullPath: '/app/products/$productId/informations/lifesheet-email/$lifesheetId/reply'
      preLoaderRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRouteImport
      parentRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/email-history/email/$emailId/resend': {
      id: '/app/enterprises_/$enterpriseId/email-history/email/$emailId/resend'
      path: '/resend'
      fullPath: '/app/enterprises/$enterpriseId/email-history/email/$emailId/resend'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute
    }
    '/app/enterprises_/$enterpriseId/email-history/email/$emailId/reply': {
      id: '/app/enterprises_/$enterpriseId/email-history/email/$emailId/reply'
      path: '/reply'
      fullPath: '/app/enterprises/$enterpriseId/email-history/email/$emailId/reply'
      preLoaderRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRouteImport
      parentRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/update-detail/$detailId': {
      id: '/app/businesses-rma_/rma/$rmaId/support/update-detail/$detailId'
      path: '/update-detail/$detailId'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/update-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/unlink-task/$taskId': {
      id: '/app/businesses-rma_/rma/$rmaId/support/unlink-task/$taskId'
      path: '/unlink-task/$taskId'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/unlink-task/$taskId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId': {
      id: '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId'
      path: '/task-email/$taskId'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/rename-ged-object/$objectRelativePath': {
      id: '/app/businesses-rma_/rma/$rmaId/support/rename-ged-object/$objectRelativePath'
      path: '/rename-ged-object/$objectRelativePath'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/rename-ged-object/$objectRelativePath'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/pdf/send-by-email': {
      id: '/app/businesses-rma_/rma/$rmaId/support/pdf/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/pdf/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportPdfRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId': {
      id: '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId'
      path: '/lifesheet-email/$lifesheetId'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/delete-link/$associatedId': {
      id: '/app/businesses-rma_/rma/$rmaId/support/delete-link/$associatedId'
      path: '/delete-link/$associatedId'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/delete-link/$associatedId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/delete-ged-object/$relativePath': {
      id: '/app/businesses-rma_/rma/$rmaId/support/delete-ged-object/$relativePath'
      path: '/delete-ged-object/$relativePath'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/delete-ged-object/$relativePath'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/delete-detail/$detailId': {
      id: '/app/businesses-rma_/rma/$rmaId/support/delete-detail/$detailId'
      path: '/delete-detail/$detailId'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/delete-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/reception/update-detail/$detailId': {
      id: '/app/businesses-rma_/rma/$rmaId/reception/update-detail/$detailId'
      path: '/update-detail/$detailId'
      fullPath: '/app/businesses-rma/rma/$rmaId/reception/update-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdReceptionRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/reception/pdf/send-by-email': {
      id: '/app/businesses-rma_/rma/$rmaId/reception/pdf/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/rma/$rmaId/reception/pdf/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdReceptionPdfRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/reception/delete-detail/$detailId': {
      id: '/app/businesses-rma_/rma/$rmaId/reception/delete-detail/$detailId'
      path: '/delete-detail/$detailId'
      fullPath: '/app/businesses-rma/rma/$rmaId/reception/delete-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdReceptionRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/delivery/update-detail/$detailId': {
      id: '/app/businesses-rma_/rma/$rmaId/delivery/update-detail/$detailId'
      path: '/update-detail/$detailId'
      fullPath: '/app/businesses-rma/rma/$rmaId/delivery/update-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/delivery/pdf/send-by-email': {
      id: '/app/businesses-rma_/rma/$rmaId/delivery/pdf/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/rma/$rmaId/delivery/pdf/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/delivery/delete-detail/$detailId': {
      id: '/app/businesses-rma_/rma/$rmaId/delivery/delete-detail/$detailId'
      path: '/delete-detail/$detailId'
      fullPath: '/app/businesses-rma/rma/$rmaId/delivery/delete-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf'
      path: '/pdf'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/import-ged-files': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/import-ged-files'
      path: '/import-ged-files'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/import-ged-files'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-subtitle': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-subtitle'
      path: '/edit-subtitle'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-subtitle'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-no-billed-time': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-no-billed-time'
      path: '/edit-no-billed-time'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-no-billed-time'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-cumulated-time': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/edit-cumulated-time'
      path: '/edit-cumulated-time'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/edit-cumulated-time'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete'
      path: '/delete'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-link': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-link'
      path: '/create-link'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-link'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-lifesheet': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-lifesheet'
      path: '/create-lifesheet'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-lifesheet'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-ged-directory': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-ged-directory'
      path: '/create-ged-directory'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-ged-directory'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-faq': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/create-faq'
      path: '/create-faq'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/create-faq'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/update-subquotation/$subquotationId': {
      id: '/app/businesses-rma_/business/$businessId/quotation/update-subquotation/$subquotationId'
      path: '/update-subquotation/$subquotationId'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/update-subquotation/$subquotationId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/update-detail/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/quotation/update-detail/$detailId'
      path: '/update-detail/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/update-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/pdf/send-by-email': {
      id: '/app/businesses-rma_/business/$businessId/quotation/pdf/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/pdf/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/delete-subquotation/$subquotationId': {
      id: '/app/businesses-rma_/business/$businessId/quotation/delete-subquotation/$subquotationId'
      path: '/delete-subquotation/$subquotationId'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/delete-subquotation/$subquotationId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/delete-detail/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/quotation/delete-detail/$detailId'
      path: '/delete-detail/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/delete-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/create-detail/$subquotationId': {
      id: '/app/businesses-rma_/business/$businessId/quotation/create-detail/$subquotationId'
      path: '/create-detail/$subquotationId'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/create-detail/$subquotationId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/create-associated-detail/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/quotation/create-associated-detail/$detailId'
      path: '/create-associated-detail/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/create-associated-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email': {
      id: '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/unlink-task/$taskId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/unlink-task/$taskId'
      path: '/unlink-task/$taskId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/unlink-task/$taskId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId'
      path: '/task-email/$taskId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/rename-ged-object/$objectRelativePath': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/rename-ged-object/$objectRelativePath'
      path: '/rename-ged-object/$objectRelativePath'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/rename-ged-object/$objectRelativePath'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId'
      path: '/lifesheet-email/$lifesheetId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId'
      path: '/$emailId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/delete-link/$associatedId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/delete-link/$associatedId'
      path: '/delete-link/$associatedId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/delete-link/$associatedId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/delete-ged-object/$objectRelativePath': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/delete-ged-object/$objectRelativePath'
      path: '/delete-ged-object/$objectRelativePath'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/delete-ged-object/$objectRelativePath'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId'
      path: '/confirm-quotation-import/$otherBusinessId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/confirm-quotation-import/$otherBusinessId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/address-book/create': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/address-book/create'
      path: '/create'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/address-book/create'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp/update-detail/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/bp/update-detail/$detailId'
      path: '/update-detail/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/bp/update-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp/delete-serial/$serialId': {
      id: '/app/businesses-rma_/business/$businessId/bp/delete-serial/$serialId'
      path: '/delete-serial/$serialId'
      fullPath: '/app/businesses-rma/business/$businessId/bp/delete-serial/$serialId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp/delete-detail/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/bp/delete-detail/$detailId'
      path: '/delete-detail/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/bp/delete-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp/create-serial-rma/$serialId': {
      id: '/app/businesses-rma_/business/$businessId/bp/create-serial-rma/$serialId'
      path: '/create-serial-rma/$serialId'
      fullPath: '/app/businesses-rma/business/$businessId/bp/create-serial-rma/$serialId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp/create-detail-rma/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/bp/create-detail-rma/$detailId'
      path: '/create-detail-rma/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/bp/create-detail-rma/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bp/add-serial/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/bp/add-serial/$detailId'
      path: '/add-serial/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/bp/add-serial/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bl/update/new': {
      id: '/app/businesses-rma_/business/$businessId/bl/update/new'
      path: '/new'
      fullPath: '/app/businesses-rma/business/$businessId/bl/update/new'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/bill/credits/send-by-email': {
      id: '/app/businesses-rma_/business/$businessId/bill/credits/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/business/$businessId/bill/credits/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/arc/update-detail/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/arc/update-detail/$detailId'
      path: '/update-detail/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/arc/update-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdArcRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/arc/pdf/send-by-email': {
      id: '/app/businesses-rma_/business/$businessId/arc/pdf/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/business/$businessId/arc/pdf/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdArcPdfRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/arc/delete-detail/$detailId': {
      id: '/app/businesses-rma_/business/$businessId/arc/delete-detail/$detailId'
      path: '/delete-detail/$detailId'
      fullPath: '/app/businesses-rma/business/$businessId/arc/delete-detail/$detailId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdArcRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/resend': {
      id: '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/resend'
      path: '/resend'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/resend'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/reply': {
      id: '/app/businesses-rma_/rma/$rmaId/support/task-email/$taskId/reply'
      path: '/reply'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/task-email/$taskId/reply'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend': {
      id: '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend'
      path: '/resend'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/resend'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply': {
      id: '/app/businesses-rma_/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply'
      path: '/reply'
      fullPath: '/app/businesses-rma/rma/$rmaId/support/lifesheet-email/$lifesheetId/reply'
      preLoaderRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRouteImport
      parentRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/rename-ged-object/$objectRelativePath': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/rename-ged-object/$objectRelativePath'
      path: '/rename-ged-object/$objectRelativePath'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/rename-ged-object/$objectRelativePath'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf/send-by-email': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/pdf/send-by-email'
      path: '/send-by-email'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/pdf/send-by-email'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId'
      path: '/lifesheet-email/$lifesheetId'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-link/$associatedId': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-link/$associatedId'
      path: '/delete-link/$associatedId'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-link/$associatedId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-ged-object/$objectRelativePath': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/delete-ged-object/$objectRelativePath'
      path: '/delete-ged-object/$objectRelativePath'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/delete-ged-object/$objectRelativePath'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages': {
      id: '/app/businesses-rma_/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages'
      path: '/predefined-messages'
      fullPath: '/app/businesses-rma/business/$businessId/quotation/commercial-notice/send-by-email/predefined-messages'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/resend': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/resend'
      path: '/resend'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/resend'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/reply': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/task-email/$taskId/reply'
      path: '/reply'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/task-email/$taskId/reply'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend'
      path: '/resend'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/resend'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply'
      path: '/reply'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/lifesheet-email/$lifesheetId/reply'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/resend': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/resend'
      path: '/resend'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/resend'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/reply': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/email-history/$emailId/reply'
      path: '/reply'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/email-history/$emailId/reply'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/address-book/update/$addressId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/address-book/update/$addressId'
      path: '/update/$addressId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/address-book/update/$addressId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute
    }
    '/app/businesses-rma_/business/$businessId/dashboard/address-book/delete/$addressId': {
      id: '/app/businesses-rma_/business/$businessId/dashboard/address-book/delete/$addressId'
      path: '/delete/$addressId'
      fullPath: '/app/businesses-rma/business/$businessId/dashboard/address-book/delete/$addressId'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend'
      path: '/resend'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/resend'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute
    }
    '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply': {
      id: '/app/businesses-rma_/business/$businessId_/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply'
      path: '/reply'
      fullPath: '/app/businesses-rma/business/$businessId/assistance/$assistanceId/lifesheet-email/$lifesheetId/reply'
      preLoaderRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRouteImport
      parentRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute
    }
  }
}

interface AppBusinessesRmaRouteRouteChildren {
  AppBusinessesRmaRepresentativeTurnoverRouteRoute: typeof AppBusinessesRmaRepresentativeTurnoverRouteRoute
  AppBusinessesRmaSearchByProductsRouteRoute: typeof AppBusinessesRmaSearchByProductsRouteRoute
}

const AppBusinessesRmaRouteRouteChildren: AppBusinessesRmaRouteRouteChildren = {
  AppBusinessesRmaRepresentativeTurnoverRouteRoute:
    AppBusinessesRmaRepresentativeTurnoverRouteRoute,
  AppBusinessesRmaSearchByProductsRouteRoute:
    AppBusinessesRmaSearchByProductsRouteRoute,
}

const AppBusinessesRmaRouteRouteWithChildren =
  AppBusinessesRmaRouteRoute._addFileChildren(
    AppBusinessesRmaRouteRouteChildren,
  )

interface AppDashboardTaskEmailTaskIdRouteRouteChildren {
  AppDashboardTaskEmailTaskIdReplyRouteRoute: typeof AppDashboardTaskEmailTaskIdReplyRouteRoute
  AppDashboardTaskEmailTaskIdResendRouteRoute: typeof AppDashboardTaskEmailTaskIdResendRouteRoute
}

const AppDashboardTaskEmailTaskIdRouteRouteChildren: AppDashboardTaskEmailTaskIdRouteRouteChildren =
  {
    AppDashboardTaskEmailTaskIdReplyRouteRoute:
      AppDashboardTaskEmailTaskIdReplyRouteRoute,
    AppDashboardTaskEmailTaskIdResendRouteRoute:
      AppDashboardTaskEmailTaskIdResendRouteRoute,
  }

const AppDashboardTaskEmailTaskIdRouteRouteWithChildren =
  AppDashboardTaskEmailTaskIdRouteRoute._addFileChildren(
    AppDashboardTaskEmailTaskIdRouteRouteChildren,
  )

interface AppDashboardRouteRouteChildren {
  AppDashboardCreateCollectiveTaskRouteRoute: typeof AppDashboardCreateCollectiveTaskRouteRoute
  AppDashboardCreatePersonalTaskRouteRoute: typeof AppDashboardCreatePersonalTaskRouteRoute
  AppDashboardCreateProgressiveInfoRouteRoute: typeof AppDashboardCreateProgressiveInfoRouteRoute
  AppDashboardDeleteCollectiveTasksRouteRoute: typeof AppDashboardDeleteCollectiveTasksRouteRoute
  AppDashboardArchivePersonalTaskTaskIdRouteRoute: typeof AppDashboardArchivePersonalTaskTaskIdRouteRoute
  AppDashboardCreateAircallContactNumberRouteRoute: typeof AppDashboardCreateAircallContactNumberRouteRoute
  AppDashboardDeleteCollectiveTaskTaskIdRouteRoute: typeof AppDashboardDeleteCollectiveTaskTaskIdRouteRoute
  AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute: typeof AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute
  AppDashboardLinkPersonalTaskTaskIdRouteRoute: typeof AppDashboardLinkPersonalTaskTaskIdRouteRoute
  AppDashboardOtherPersonalTasksProfileIdRouteRoute: typeof AppDashboardOtherPersonalTasksProfileIdRouteRoute
  AppDashboardPersonalTaskDetailsTaskIdRouteRoute: typeof AppDashboardPersonalTaskDetailsTaskIdRouteRoute
  AppDashboardSchedulerEventDetailsEventIdRouteRoute: typeof AppDashboardSchedulerEventDetailsEventIdRouteRoute
  AppDashboardTakeCollectiveTaskTaskIdRouteRoute: typeof AppDashboardTakeCollectiveTaskTaskIdRouteRoute
  AppDashboardTaskCommentsTaskIdRouteRoute: typeof AppDashboardTaskCommentsTaskIdRouteRoute
  AppDashboardTaskEmailTaskIdRouteRoute: typeof AppDashboardTaskEmailTaskIdRouteRouteWithChildren
  AppDashboardTransferTaskTaskIdRouteRoute: typeof AppDashboardTransferTaskTaskIdRouteRoute
  AppDashboardUnlinkPersonalTaskTaskIdRouteRoute: typeof AppDashboardUnlinkPersonalTaskTaskIdRouteRoute
  AppDashboardUpdateAircallContactContactIdRouteRoute: typeof AppDashboardUpdateAircallContactContactIdRouteRoute
  AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute: typeof AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute
  AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute: typeof AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute
  AppDashboardValidatePersonalTaskTaskIdRouteRoute: typeof AppDashboardValidatePersonalTaskTaskIdRouteRoute
}

const AppDashboardRouteRouteChildren: AppDashboardRouteRouteChildren = {
  AppDashboardCreateCollectiveTaskRouteRoute:
    AppDashboardCreateCollectiveTaskRouteRoute,
  AppDashboardCreatePersonalTaskRouteRoute:
    AppDashboardCreatePersonalTaskRouteRoute,
  AppDashboardCreateProgressiveInfoRouteRoute:
    AppDashboardCreateProgressiveInfoRouteRoute,
  AppDashboardDeleteCollectiveTasksRouteRoute:
    AppDashboardDeleteCollectiveTasksRouteRoute,
  AppDashboardArchivePersonalTaskTaskIdRouteRoute:
    AppDashboardArchivePersonalTaskTaskIdRouteRoute,
  AppDashboardCreateAircallContactNumberRouteRoute:
    AppDashboardCreateAircallContactNumberRouteRoute,
  AppDashboardDeleteCollectiveTaskTaskIdRouteRoute:
    AppDashboardDeleteCollectiveTaskTaskIdRouteRoute,
  AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute:
    AppDashboardDeleteProgressiveInfoProgressiveInfoIdRouteRoute,
  AppDashboardLinkPersonalTaskTaskIdRouteRoute:
    AppDashboardLinkPersonalTaskTaskIdRouteRoute,
  AppDashboardOtherPersonalTasksProfileIdRouteRoute:
    AppDashboardOtherPersonalTasksProfileIdRouteRoute,
  AppDashboardPersonalTaskDetailsTaskIdRouteRoute:
    AppDashboardPersonalTaskDetailsTaskIdRouteRoute,
  AppDashboardSchedulerEventDetailsEventIdRouteRoute:
    AppDashboardSchedulerEventDetailsEventIdRouteRoute,
  AppDashboardTakeCollectiveTaskTaskIdRouteRoute:
    AppDashboardTakeCollectiveTaskTaskIdRouteRoute,
  AppDashboardTaskCommentsTaskIdRouteRoute:
    AppDashboardTaskCommentsTaskIdRouteRoute,
  AppDashboardTaskEmailTaskIdRouteRoute:
    AppDashboardTaskEmailTaskIdRouteRouteWithChildren,
  AppDashboardTransferTaskTaskIdRouteRoute:
    AppDashboardTransferTaskTaskIdRouteRoute,
  AppDashboardUnlinkPersonalTaskTaskIdRouteRoute:
    AppDashboardUnlinkPersonalTaskTaskIdRouteRoute,
  AppDashboardUpdateAircallContactContactIdRouteRoute:
    AppDashboardUpdateAircallContactContactIdRouteRoute,
  AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute:
    AppDashboardUpdatePersonalTaskDeadlineTaskIdRouteRoute,
  AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute:
    AppDashboardUpdateProgressiveInfoProgressiveInfoIdRouteRoute,
  AppDashboardValidatePersonalTaskTaskIdRouteRoute:
    AppDashboardValidatePersonalTaskTaskIdRouteRoute,
}

const AppDashboardRouteRouteWithChildren =
  AppDashboardRouteRoute._addFileChildren(AppDashboardRouteRouteChildren)

interface AppEnterprisesRouteRouteChildren {
  AppEnterprisesCreateRouteRoute: typeof AppEnterprisesCreateRouteRoute
  AppEnterprisesCreateContactBusinessContactIdRouteRoute: typeof AppEnterprisesCreateContactBusinessContactIdRouteRoute
  AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute: typeof AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute
  AppEnterprisesCreateContactEnterpriseIdRouteRoute: typeof AppEnterprisesCreateContactEnterpriseIdRouteRoute
  AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute: typeof AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute
  AppEnterprisesDeleteContactContactIdRouteRoute: typeof AppEnterprisesDeleteContactContactIdRouteRoute
  AppEnterprisesSendEmailToContactContactIdRouteRoute: typeof AppEnterprisesSendEmailToContactContactIdRouteRoute
  AppEnterprisesUpdateContactPasswordContactIdRouteRoute: typeof AppEnterprisesUpdateContactPasswordContactIdRouteRoute
  AppEnterprisesUpdateContactContactIdRouteRoute: typeof AppEnterprisesUpdateContactContactIdRouteRoute
}

const AppEnterprisesRouteRouteChildren: AppEnterprisesRouteRouteChildren = {
  AppEnterprisesCreateRouteRoute: AppEnterprisesCreateRouteRoute,
  AppEnterprisesCreateContactBusinessContactIdRouteRoute:
    AppEnterprisesCreateContactBusinessContactIdRouteRoute,
  AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute:
    AppEnterprisesCreateContactTravelVoucherContactIdRouteRoute,
  AppEnterprisesCreateContactEnterpriseIdRouteRoute:
    AppEnterprisesCreateContactEnterpriseIdRouteRoute,
  AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute:
    AppEnterprisesCreateEnterpriseRmaEnterpriseIdRouteRoute,
  AppEnterprisesDeleteContactContactIdRouteRoute:
    AppEnterprisesDeleteContactContactIdRouteRoute,
  AppEnterprisesSendEmailToContactContactIdRouteRoute:
    AppEnterprisesSendEmailToContactContactIdRouteRoute,
  AppEnterprisesUpdateContactPasswordContactIdRouteRoute:
    AppEnterprisesUpdateContactPasswordContactIdRouteRoute,
  AppEnterprisesUpdateContactContactIdRouteRoute:
    AppEnterprisesUpdateContactContactIdRouteRoute,
}

const AppEnterprisesRouteRouteWithChildren =
  AppEnterprisesRouteRoute._addFileChildren(AppEnterprisesRouteRouteChildren)

interface AppFaqGedFaqIdRouteRouteChildren {
  AppFaqGedFaqIdCreateDirectoryRouteRoute: typeof AppFaqGedFaqIdCreateDirectoryRouteRoute
  AppFaqGedFaqIdImportFilesRouteRoute: typeof AppFaqGedFaqIdImportFilesRouteRoute
  AppFaqGedFaqIdDeleteItemRelativePathRouteRoute: typeof AppFaqGedFaqIdDeleteItemRelativePathRouteRoute
  AppFaqGedFaqIdRenameItemRelativePathRouteRoute: typeof AppFaqGedFaqIdRenameItemRelativePathRouteRoute
}

const AppFaqGedFaqIdRouteRouteChildren: AppFaqGedFaqIdRouteRouteChildren = {
  AppFaqGedFaqIdCreateDirectoryRouteRoute:
    AppFaqGedFaqIdCreateDirectoryRouteRoute,
  AppFaqGedFaqIdImportFilesRouteRoute: AppFaqGedFaqIdImportFilesRouteRoute,
  AppFaqGedFaqIdDeleteItemRelativePathRouteRoute:
    AppFaqGedFaqIdDeleteItemRelativePathRouteRoute,
  AppFaqGedFaqIdRenameItemRelativePathRouteRoute:
    AppFaqGedFaqIdRenameItemRelativePathRouteRoute,
}

const AppFaqGedFaqIdRouteRouteWithChildren =
  AppFaqGedFaqIdRouteRoute._addFileChildren(AppFaqGedFaqIdRouteRouteChildren)

interface AppFaqRouteRouteChildren {
  AppFaqCreateRouteRoute: typeof AppFaqCreateRouteRoute
  AppFaqArchiveFaqIdRouteRoute: typeof AppFaqArchiveFaqIdRouteRoute
  AppFaqDeleteFaqIdRouteRoute: typeof AppFaqDeleteFaqIdRouteRoute
  AppFaqGedFaqIdRouteRoute: typeof AppFaqGedFaqIdRouteRouteWithChildren
  AppFaqSendByEmailFaqIdRouteRoute: typeof AppFaqSendByEmailFaqIdRouteRoute
  AppFaqUpdateFaqIdRouteRoute: typeof AppFaqUpdateFaqIdRouteRoute
}

const AppFaqRouteRouteChildren: AppFaqRouteRouteChildren = {
  AppFaqCreateRouteRoute: AppFaqCreateRouteRoute,
  AppFaqArchiveFaqIdRouteRoute: AppFaqArchiveFaqIdRouteRoute,
  AppFaqDeleteFaqIdRouteRoute: AppFaqDeleteFaqIdRouteRoute,
  AppFaqGedFaqIdRouteRoute: AppFaqGedFaqIdRouteRouteWithChildren,
  AppFaqSendByEmailFaqIdRouteRoute: AppFaqSendByEmailFaqIdRouteRoute,
  AppFaqUpdateFaqIdRouteRoute: AppFaqUpdateFaqIdRouteRoute,
}

const AppFaqRouteRouteWithChildren = AppFaqRouteRoute._addFileChildren(
  AppFaqRouteRouteChildren,
)

interface AppProductsSerialNumbersRouteRouteChildren {
  AppProductsSerialNumbersCreateRouteRoute: typeof AppProductsSerialNumbersCreateRouteRoute
  AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute: typeof AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute
  AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute: typeof AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute
  AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute: typeof AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute
  AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute: typeof AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute
}

const AppProductsSerialNumbersRouteRouteChildren: AppProductsSerialNumbersRouteRouteChildren =
  {
    AppProductsSerialNumbersCreateRouteRoute:
      AppProductsSerialNumbersCreateRouteRoute,
    AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute:
      AppProductsSerialNumbersCreateRmaSerialNumberIdRouteRoute,
    AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute:
      AppProductsSerialNumbersDeleteSerialNumberIdRouteRoute,
    AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute:
      AppProductsSerialNumbersRemoveFromBusinessSerialNumberIdRouteRoute,
    AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute:
      AppProductsSerialNumbersUpdateSerialNumberIdRouteRoute,
  }

const AppProductsSerialNumbersRouteRouteWithChildren =
  AppProductsSerialNumbersRouteRoute._addFileChildren(
    AppProductsSerialNumbersRouteRouteChildren,
  )

interface AppProductsRouteRouteChildren {
  AppProductsCreateRouteRoute: typeof AppProductsCreateRouteRoute
  AppProductsSerialNumbersRouteRoute: typeof AppProductsSerialNumbersRouteRouteWithChildren
}

const AppProductsRouteRouteChildren: AppProductsRouteRouteChildren = {
  AppProductsCreateRouteRoute: AppProductsCreateRouteRoute,
  AppProductsSerialNumbersRouteRoute:
    AppProductsSerialNumbersRouteRouteWithChildren,
}

const AppProductsRouteRouteWithChildren =
  AppProductsRouteRoute._addFileChildren(AppProductsRouteRouteChildren)

interface AppToolsCreditRouteRouteChildren {
  AppToolsCreditDetailsRouteRoute: typeof AppToolsCreditDetailsRouteRoute
  AppToolsCreditShowRouteRoute: typeof AppToolsCreditShowRouteRoute
}

const AppToolsCreditRouteRouteChildren: AppToolsCreditRouteRouteChildren = {
  AppToolsCreditDetailsRouteRoute: AppToolsCreditDetailsRouteRoute,
  AppToolsCreditShowRouteRoute: AppToolsCreditShowRouteRoute,
}

const AppToolsCreditRouteRouteWithChildren =
  AppToolsCreditRouteRoute._addFileChildren(AppToolsCreditRouteRouteChildren)

interface AppToolsDdnsRouteRouteChildren {
  AppToolsDdnsCreateRouteRoute: typeof AppToolsDdnsCreateRouteRoute
  AppToolsDdnsDeleteDdnsIdRouteRoute: typeof AppToolsDdnsDeleteDdnsIdRouteRoute
}

const AppToolsDdnsRouteRouteChildren: AppToolsDdnsRouteRouteChildren = {
  AppToolsDdnsCreateRouteRoute: AppToolsDdnsCreateRouteRoute,
  AppToolsDdnsDeleteDdnsIdRouteRoute: AppToolsDdnsDeleteDdnsIdRouteRoute,
}

const AppToolsDdnsRouteRouteWithChildren =
  AppToolsDdnsRouteRoute._addFileChildren(AppToolsDdnsRouteRouteChildren)

interface AppToolsDepartmentsRouteRouteChildren {
  AppToolsDepartmentsCreateRouteRoute: typeof AppToolsDepartmentsCreateRouteRoute
  AppToolsDepartmentsDeleteDepartmentIdRouteRoute: typeof AppToolsDepartmentsDeleteDepartmentIdRouteRoute
  AppToolsDepartmentsUpdateDepartmentIdRouteRoute: typeof AppToolsDepartmentsUpdateDepartmentIdRouteRoute
}

const AppToolsDepartmentsRouteRouteChildren: AppToolsDepartmentsRouteRouteChildren =
  {
    AppToolsDepartmentsCreateRouteRoute: AppToolsDepartmentsCreateRouteRoute,
    AppToolsDepartmentsDeleteDepartmentIdRouteRoute:
      AppToolsDepartmentsDeleteDepartmentIdRouteRoute,
    AppToolsDepartmentsUpdateDepartmentIdRouteRoute:
      AppToolsDepartmentsUpdateDepartmentIdRouteRoute,
  }

const AppToolsDepartmentsRouteRouteWithChildren =
  AppToolsDepartmentsRouteRoute._addFileChildren(
    AppToolsDepartmentsRouteRouteChildren,
  )

interface AppToolsEmailsEmailIdRouteRouteChildren {
  AppToolsEmailsEmailIdReplyRouteRoute: typeof AppToolsEmailsEmailIdReplyRouteRoute
  AppToolsEmailsEmailIdResendRouteRoute: typeof AppToolsEmailsEmailIdResendRouteRoute
}

const AppToolsEmailsEmailIdRouteRouteChildren: AppToolsEmailsEmailIdRouteRouteChildren =
  {
    AppToolsEmailsEmailIdReplyRouteRoute: AppToolsEmailsEmailIdReplyRouteRoute,
    AppToolsEmailsEmailIdResendRouteRoute:
      AppToolsEmailsEmailIdResendRouteRoute,
  }

const AppToolsEmailsEmailIdRouteRouteWithChildren =
  AppToolsEmailsEmailIdRouteRoute._addFileChildren(
    AppToolsEmailsEmailIdRouteRouteChildren,
  )

interface AppToolsEmailsRouteRouteChildren {
  AppToolsEmailsEmailIdRouteRoute: typeof AppToolsEmailsEmailIdRouteRouteWithChildren
}

const AppToolsEmailsRouteRouteChildren: AppToolsEmailsRouteRouteChildren = {
  AppToolsEmailsEmailIdRouteRoute: AppToolsEmailsEmailIdRouteRouteWithChildren,
}

const AppToolsEmailsRouteRouteWithChildren =
  AppToolsEmailsRouteRoute._addFileChildren(AppToolsEmailsRouteRouteChildren)

interface AppToolsExternalLinksRouteRouteChildren {
  AppToolsExternalLinksCreateRouteRoute: typeof AppToolsExternalLinksCreateRouteRoute
  AppToolsExternalLinksArchiveExternalLinkIdRouteRoute: typeof AppToolsExternalLinksArchiveExternalLinkIdRouteRoute
  AppToolsExternalLinksDeleteExternalLinkIdRouteRoute: typeof AppToolsExternalLinksDeleteExternalLinkIdRouteRoute
  AppToolsExternalLinksUpdateExternalLinkIdRouteRoute: typeof AppToolsExternalLinksUpdateExternalLinkIdRouteRoute
}

const AppToolsExternalLinksRouteRouteChildren: AppToolsExternalLinksRouteRouteChildren =
  {
    AppToolsExternalLinksCreateRouteRoute:
      AppToolsExternalLinksCreateRouteRoute,
    AppToolsExternalLinksArchiveExternalLinkIdRouteRoute:
      AppToolsExternalLinksArchiveExternalLinkIdRouteRoute,
    AppToolsExternalLinksDeleteExternalLinkIdRouteRoute:
      AppToolsExternalLinksDeleteExternalLinkIdRouteRoute,
    AppToolsExternalLinksUpdateExternalLinkIdRouteRoute:
      AppToolsExternalLinksUpdateExternalLinkIdRouteRoute,
  }

const AppToolsExternalLinksRouteRouteWithChildren =
  AppToolsExternalLinksRouteRoute._addFileChildren(
    AppToolsExternalLinksRouteRouteChildren,
  )

interface AppToolsFormationsCreateRouteRouteChildren {
  AppToolsFormationsCreateAddDetailRouteRoute: typeof AppToolsFormationsCreateAddDetailRouteRoute
  AppToolsFormationsCreateDetailsRouteRoute: typeof AppToolsFormationsCreateDetailsRouteRoute
}

const AppToolsFormationsCreateRouteRouteChildren: AppToolsFormationsCreateRouteRouteChildren =
  {
    AppToolsFormationsCreateAddDetailRouteRoute:
      AppToolsFormationsCreateAddDetailRouteRoute,
    AppToolsFormationsCreateDetailsRouteRoute:
      AppToolsFormationsCreateDetailsRouteRoute,
  }

const AppToolsFormationsCreateRouteRouteWithChildren =
  AppToolsFormationsCreateRouteRoute._addFileChildren(
    AppToolsFormationsCreateRouteRouteChildren,
  )

interface AppToolsFormationsSubscribersFormationDetailIdRouteRouteChildren {
  AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute: typeof AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute
  AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute: typeof AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute
  AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute: typeof AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute
}

const AppToolsFormationsSubscribersFormationDetailIdRouteRouteChildren: AppToolsFormationsSubscribersFormationDetailIdRouteRouteChildren =
  {
    AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute:
      AppToolsFormationsSubscribersFormationDetailIdCreateRouteRoute,
    AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute:
      AppToolsFormationsSubscribersFormationDetailIdDeleteSubscriptionIdRouteRoute,
    AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute:
      AppToolsFormationsSubscribersFormationDetailIdSendEmailSubscriptionIdRouteRoute,
  }

const AppToolsFormationsSubscribersFormationDetailIdRouteRouteWithChildren =
  AppToolsFormationsSubscribersFormationDetailIdRouteRoute._addFileChildren(
    AppToolsFormationsSubscribersFormationDetailIdRouteRouteChildren,
  )

interface AppToolsFormationsUpdateFormationIdRouteRouteChildren {
  AppToolsFormationsUpdateFormationIdAddDetailRouteRoute: typeof AppToolsFormationsUpdateFormationIdAddDetailRouteRoute
  AppToolsFormationsUpdateFormationIdDetailsRouteRoute: typeof AppToolsFormationsUpdateFormationIdDetailsRouteRoute
}

const AppToolsFormationsUpdateFormationIdRouteRouteChildren: AppToolsFormationsUpdateFormationIdRouteRouteChildren =
  {
    AppToolsFormationsUpdateFormationIdAddDetailRouteRoute:
      AppToolsFormationsUpdateFormationIdAddDetailRouteRoute,
    AppToolsFormationsUpdateFormationIdDetailsRouteRoute:
      AppToolsFormationsUpdateFormationIdDetailsRouteRoute,
  }

const AppToolsFormationsUpdateFormationIdRouteRouteWithChildren =
  AppToolsFormationsUpdateFormationIdRouteRoute._addFileChildren(
    AppToolsFormationsUpdateFormationIdRouteRouteChildren,
  )

interface AppToolsFormationsRouteRouteChildren {
  AppToolsFormationsCreateRouteRoute: typeof AppToolsFormationsCreateRouteRouteWithChildren
  AppToolsFormationsDeleteFormationIdRouteRoute: typeof AppToolsFormationsDeleteFormationIdRouteRoute
  AppToolsFormationsSubscribersFormationDetailIdRouteRoute: typeof AppToolsFormationsSubscribersFormationDetailIdRouteRouteWithChildren
  AppToolsFormationsUpdateFormationIdRouteRoute: typeof AppToolsFormationsUpdateFormationIdRouteRouteWithChildren
}

const AppToolsFormationsRouteRouteChildren: AppToolsFormationsRouteRouteChildren =
  {
    AppToolsFormationsCreateRouteRoute:
      AppToolsFormationsCreateRouteRouteWithChildren,
    AppToolsFormationsDeleteFormationIdRouteRoute:
      AppToolsFormationsDeleteFormationIdRouteRoute,
    AppToolsFormationsSubscribersFormationDetailIdRouteRoute:
      AppToolsFormationsSubscribersFormationDetailIdRouteRouteWithChildren,
    AppToolsFormationsUpdateFormationIdRouteRoute:
      AppToolsFormationsUpdateFormationIdRouteRouteWithChildren,
  }

const AppToolsFormationsRouteRouteWithChildren =
  AppToolsFormationsRouteRoute._addFileChildren(
    AppToolsFormationsRouteRouteChildren,
  )

interface AppToolsMailsRouteRouteChildren {
  AppToolsMailsCreateRouteRoute: typeof AppToolsMailsCreateRouteRoute
  AppToolsMailsDeleteMailIdRouteRoute: typeof AppToolsMailsDeleteMailIdRouteRoute
  AppToolsMailsShowMailIdRouteRoute: typeof AppToolsMailsShowMailIdRouteRoute
  AppToolsMailsUpdateMailIdRouteRoute: typeof AppToolsMailsUpdateMailIdRouteRoute
}

const AppToolsMailsRouteRouteChildren: AppToolsMailsRouteRouteChildren = {
  AppToolsMailsCreateRouteRoute: AppToolsMailsCreateRouteRoute,
  AppToolsMailsDeleteMailIdRouteRoute: AppToolsMailsDeleteMailIdRouteRoute,
  AppToolsMailsShowMailIdRouteRoute: AppToolsMailsShowMailIdRouteRoute,
  AppToolsMailsUpdateMailIdRouteRoute: AppToolsMailsUpdateMailIdRouteRoute,
}

const AppToolsMailsRouteRouteWithChildren =
  AppToolsMailsRouteRoute._addFileChildren(AppToolsMailsRouteRouteChildren)

interface AppToolsMenuRouteRouteChildren {
  AppToolsMenuCreateEnterpriseRouteRoute: typeof AppToolsMenuCreateEnterpriseRouteRoute
  AppToolsMenuCreateProductRouteRoute: typeof AppToolsMenuCreateProductRouteRoute
}

const AppToolsMenuRouteRouteChildren: AppToolsMenuRouteRouteChildren = {
  AppToolsMenuCreateEnterpriseRouteRoute:
    AppToolsMenuCreateEnterpriseRouteRoute,
  AppToolsMenuCreateProductRouteRoute: AppToolsMenuCreateProductRouteRoute,
}

const AppToolsMenuRouteRouteWithChildren =
  AppToolsMenuRouteRoute._addFileChildren(AppToolsMenuRouteRouteChildren)

interface AppToolsNewsRouteRouteChildren {
  AppToolsNewsCreateRouteRoute: typeof AppToolsNewsCreateRouteRoute
  AppToolsNewsDeleteNewsIdRouteRoute: typeof AppToolsNewsDeleteNewsIdRouteRoute
  AppToolsNewsUpdateNewsIdRouteRoute: typeof AppToolsNewsUpdateNewsIdRouteRoute
}

const AppToolsNewsRouteRouteChildren: AppToolsNewsRouteRouteChildren = {
  AppToolsNewsCreateRouteRoute: AppToolsNewsCreateRouteRoute,
  AppToolsNewsDeleteNewsIdRouteRoute: AppToolsNewsDeleteNewsIdRouteRoute,
  AppToolsNewsUpdateNewsIdRouteRoute: AppToolsNewsUpdateNewsIdRouteRoute,
}

const AppToolsNewsRouteRouteWithChildren =
  AppToolsNewsRouteRoute._addFileChildren(AppToolsNewsRouteRouteChildren)

interface AppToolsPredefinedMessagesRouteRouteChildren {
  AppToolsPredefinedMessagesCreateRouteRoute: typeof AppToolsPredefinedMessagesCreateRouteRoute
  AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute: typeof AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute
  AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute: typeof AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute
}

const AppToolsPredefinedMessagesRouteRouteChildren: AppToolsPredefinedMessagesRouteRouteChildren =
  {
    AppToolsPredefinedMessagesCreateRouteRoute:
      AppToolsPredefinedMessagesCreateRouteRoute,
    AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute:
      AppToolsPredefinedMessagesDeletePredefinedMessageIdRouteRoute,
    AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute:
      AppToolsPredefinedMessagesUpdatePredefinedMessageIdRouteRoute,
  }

const AppToolsPredefinedMessagesRouteRouteWithChildren =
  AppToolsPredefinedMessagesRouteRoute._addFileChildren(
    AppToolsPredefinedMessagesRouteRouteChildren,
  )

interface AppToolsPredefinedTextsRouteRouteChildren {
  AppToolsPredefinedTextsCreateRouteRoute: typeof AppToolsPredefinedTextsCreateRouteRoute
  AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute: typeof AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute
  AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute: typeof AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute
}

const AppToolsPredefinedTextsRouteRouteChildren: AppToolsPredefinedTextsRouteRouteChildren =
  {
    AppToolsPredefinedTextsCreateRouteRoute:
      AppToolsPredefinedTextsCreateRouteRoute,
    AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute:
      AppToolsPredefinedTextsDeletePredefinedTextIdRouteRoute,
    AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute:
      AppToolsPredefinedTextsUpdatePredefinedTextIdRouteRoute,
  }

const AppToolsPredefinedTextsRouteRouteWithChildren =
  AppToolsPredefinedTextsRouteRoute._addFileChildren(
    AppToolsPredefinedTextsRouteRouteChildren,
  )

interface AppToolsProductFiltersRouteRouteChildren {
  AppToolsProductFiltersCreateRouteRoute: typeof AppToolsProductFiltersCreateRouteRoute
  AppToolsProductFiltersDeleteProductFilterIdRouteRoute: typeof AppToolsProductFiltersDeleteProductFilterIdRouteRoute
  AppToolsProductFiltersUpdateProductFilterIdRouteRoute: typeof AppToolsProductFiltersUpdateProductFilterIdRouteRoute
}

const AppToolsProductFiltersRouteRouteChildren: AppToolsProductFiltersRouteRouteChildren =
  {
    AppToolsProductFiltersCreateRouteRoute:
      AppToolsProductFiltersCreateRouteRoute,
    AppToolsProductFiltersDeleteProductFilterIdRouteRoute:
      AppToolsProductFiltersDeleteProductFilterIdRouteRoute,
    AppToolsProductFiltersUpdateProductFilterIdRouteRoute:
      AppToolsProductFiltersUpdateProductFilterIdRouteRoute,
  }

const AppToolsProductFiltersRouteRouteWithChildren =
  AppToolsProductFiltersRouteRoute._addFileChildren(
    AppToolsProductFiltersRouteRouteChildren,
  )

interface AppToolsProductInventoryRouteRouteChildren {
  AppToolsProductInventoryValidateQuantitiesRouteRoute: typeof AppToolsProductInventoryValidateQuantitiesRouteRoute
  AppToolsProductInventoryUpdateStockIdRouteRoute: typeof AppToolsProductInventoryUpdateStockIdRouteRoute
}

const AppToolsProductInventoryRouteRouteChildren: AppToolsProductInventoryRouteRouteChildren =
  {
    AppToolsProductInventoryValidateQuantitiesRouteRoute:
      AppToolsProductInventoryValidateQuantitiesRouteRoute,
    AppToolsProductInventoryUpdateStockIdRouteRoute:
      AppToolsProductInventoryUpdateStockIdRouteRoute,
  }

const AppToolsProductInventoryRouteRouteWithChildren =
  AppToolsProductInventoryRouteRoute._addFileChildren(
    AppToolsProductInventoryRouteRouteChildren,
  )

interface AppToolsProductShelvesRouteRouteChildren {
  AppToolsProductShelvesCreateRouteRoute: typeof AppToolsProductShelvesCreateRouteRoute
  AppToolsProductShelvesDeleteProductShelfIdRouteRoute: typeof AppToolsProductShelvesDeleteProductShelfIdRouteRoute
}

const AppToolsProductShelvesRouteRouteChildren: AppToolsProductShelvesRouteRouteChildren =
  {
    AppToolsProductShelvesCreateRouteRoute:
      AppToolsProductShelvesCreateRouteRoute,
    AppToolsProductShelvesDeleteProductShelfIdRouteRoute:
      AppToolsProductShelvesDeleteProductShelfIdRouteRoute,
  }

const AppToolsProductShelvesRouteRouteWithChildren =
  AppToolsProductShelvesRouteRoute._addFileChildren(
    AppToolsProductShelvesRouteRouteChildren,
  )

interface AppToolsSchedulerDetailsRdvIdRouteRouteChildren {
  AppToolsSchedulerDetailsRdvIdDeleteRouteRoute: typeof AppToolsSchedulerDetailsRdvIdDeleteRouteRoute
  AppToolsSchedulerDetailsRdvIdUpdateRouteRoute: typeof AppToolsSchedulerDetailsRdvIdUpdateRouteRoute
}

const AppToolsSchedulerDetailsRdvIdRouteRouteChildren: AppToolsSchedulerDetailsRdvIdRouteRouteChildren =
  {
    AppToolsSchedulerDetailsRdvIdDeleteRouteRoute:
      AppToolsSchedulerDetailsRdvIdDeleteRouteRoute,
    AppToolsSchedulerDetailsRdvIdUpdateRouteRoute:
      AppToolsSchedulerDetailsRdvIdUpdateRouteRoute,
  }

const AppToolsSchedulerDetailsRdvIdRouteRouteWithChildren =
  AppToolsSchedulerDetailsRdvIdRouteRoute._addFileChildren(
    AppToolsSchedulerDetailsRdvIdRouteRouteChildren,
  )

interface AppToolsSchedulerRouteRouteChildren {
  AppToolsSchedulerCreateRouteRoute: typeof AppToolsSchedulerCreateRouteRoute
  AppToolsSchedulerDetailsRdvIdRouteRoute: typeof AppToolsSchedulerDetailsRdvIdRouteRouteWithChildren
}

const AppToolsSchedulerRouteRouteChildren: AppToolsSchedulerRouteRouteChildren =
  {
    AppToolsSchedulerCreateRouteRoute: AppToolsSchedulerCreateRouteRoute,
    AppToolsSchedulerDetailsRdvIdRouteRoute:
      AppToolsSchedulerDetailsRdvIdRouteRouteWithChildren,
  }

const AppToolsSchedulerRouteRouteWithChildren =
  AppToolsSchedulerRouteRoute._addFileChildren(
    AppToolsSchedulerRouteRouteChildren,
  )

interface AppToolsVvaRouteRouteChildren {
  AppToolsVvaCreateRouteRoute: typeof AppToolsVvaCreateRouteRoute
  AppToolsVvaDeleteVvaIdRouteRoute: typeof AppToolsVvaDeleteVvaIdRouteRoute
}

const AppToolsVvaRouteRouteChildren: AppToolsVvaRouteRouteChildren = {
  AppToolsVvaCreateRouteRoute: AppToolsVvaCreateRouteRoute,
  AppToolsVvaDeleteVvaIdRouteRoute: AppToolsVvaDeleteVvaIdRouteRoute,
}

const AppToolsVvaRouteRouteWithChildren =
  AppToolsVvaRouteRoute._addFileChildren(AppToolsVvaRouteRouteChildren)

interface AppToolsRouteRouteChildren {
  AppToolsCreditRouteRoute: typeof AppToolsCreditRouteRouteWithChildren
  AppToolsDdnsRouteRoute: typeof AppToolsDdnsRouteRouteWithChildren
  AppToolsDepartmentsRouteRoute: typeof AppToolsDepartmentsRouteRouteWithChildren
  AppToolsEmailsRouteRoute: typeof AppToolsEmailsRouteRouteWithChildren
  AppToolsExternalLinksRouteRoute: typeof AppToolsExternalLinksRouteRouteWithChildren
  AppToolsFormationsRouteRoute: typeof AppToolsFormationsRouteRouteWithChildren
  AppToolsGlobalTurnoverRouteRoute: typeof AppToolsGlobalTurnoverRouteRoute
  AppToolsMailsRouteRoute: typeof AppToolsMailsRouteRouteWithChildren
  AppToolsMenuRouteRoute: typeof AppToolsMenuRouteRouteWithChildren
  AppToolsNewsRouteRoute: typeof AppToolsNewsRouteRouteWithChildren
  AppToolsPredefinedMessagesRouteRoute: typeof AppToolsPredefinedMessagesRouteRouteWithChildren
  AppToolsPredefinedTextsRouteRoute: typeof AppToolsPredefinedTextsRouteRouteWithChildren
  AppToolsProductFiltersRouteRoute: typeof AppToolsProductFiltersRouteRouteWithChildren
  AppToolsProductInventoryRouteRoute: typeof AppToolsProductInventoryRouteRouteWithChildren
  AppToolsProductShelvesRouteRoute: typeof AppToolsProductShelvesRouteRouteWithChildren
  AppToolsRepresentativesMapRouteRoute: typeof AppToolsRepresentativesMapRouteRoute
  AppToolsRepresentativesTurnoverRouteRoute: typeof AppToolsRepresentativesTurnoverRouteRoute
  AppToolsSchedulerRouteRoute: typeof AppToolsSchedulerRouteRouteWithChildren
  AppToolsVvaRouteRoute: typeof AppToolsVvaRouteRouteWithChildren
  AppToolsIndexRoute: typeof AppToolsIndexRoute
}

const AppToolsRouteRouteChildren: AppToolsRouteRouteChildren = {
  AppToolsCreditRouteRoute: AppToolsCreditRouteRouteWithChildren,
  AppToolsDdnsRouteRoute: AppToolsDdnsRouteRouteWithChildren,
  AppToolsDepartmentsRouteRoute: AppToolsDepartmentsRouteRouteWithChildren,
  AppToolsEmailsRouteRoute: AppToolsEmailsRouteRouteWithChildren,
  AppToolsExternalLinksRouteRoute: AppToolsExternalLinksRouteRouteWithChildren,
  AppToolsFormationsRouteRoute: AppToolsFormationsRouteRouteWithChildren,
  AppToolsGlobalTurnoverRouteRoute: AppToolsGlobalTurnoverRouteRoute,
  AppToolsMailsRouteRoute: AppToolsMailsRouteRouteWithChildren,
  AppToolsMenuRouteRoute: AppToolsMenuRouteRouteWithChildren,
  AppToolsNewsRouteRoute: AppToolsNewsRouteRouteWithChildren,
  AppToolsPredefinedMessagesRouteRoute:
    AppToolsPredefinedMessagesRouteRouteWithChildren,
  AppToolsPredefinedTextsRouteRoute:
    AppToolsPredefinedTextsRouteRouteWithChildren,
  AppToolsProductFiltersRouteRoute:
    AppToolsProductFiltersRouteRouteWithChildren,
  AppToolsProductInventoryRouteRoute:
    AppToolsProductInventoryRouteRouteWithChildren,
  AppToolsProductShelvesRouteRoute:
    AppToolsProductShelvesRouteRouteWithChildren,
  AppToolsRepresentativesMapRouteRoute: AppToolsRepresentativesMapRouteRoute,
  AppToolsRepresentativesTurnoverRouteRoute:
    AppToolsRepresentativesTurnoverRouteRoute,
  AppToolsSchedulerRouteRoute: AppToolsSchedulerRouteRouteWithChildren,
  AppToolsVvaRouteRoute: AppToolsVvaRouteRouteWithChildren,
  AppToolsIndexRoute: AppToolsIndexRoute,
}

const AppToolsRouteRouteWithChildren = AppToolsRouteRoute._addFileChildren(
  AppToolsRouteRouteChildren,
)

interface AppEnterprisesEnterpriseIdAddressBookRouteRouteChildren {
  AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute: typeof AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute
  AppEnterprisesEnterpriseIdAddressBookImportRouteRoute: typeof AppEnterprisesEnterpriseIdAddressBookImportRouteRoute
  AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute: typeof AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute
  AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute: typeof AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute
}

const AppEnterprisesEnterpriseIdAddressBookRouteRouteChildren: AppEnterprisesEnterpriseIdAddressBookRouteRouteChildren =
  {
    AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute:
      AppEnterprisesEnterpriseIdAddressBookCreateRouteRoute,
    AppEnterprisesEnterpriseIdAddressBookImportRouteRoute:
      AppEnterprisesEnterpriseIdAddressBookImportRouteRoute,
    AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute:
      AppEnterprisesEnterpriseIdAddressBookDeleteAddressIdRouteRoute,
    AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute:
      AppEnterprisesEnterpriseIdAddressBookUpdateAddressIdRouteRoute,
  }

const AppEnterprisesEnterpriseIdAddressBookRouteRouteWithChildren =
  AppEnterprisesEnterpriseIdAddressBookRouteRoute._addFileChildren(
    AppEnterprisesEnterpriseIdAddressBookRouteRouteChildren,
  )

interface AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteChildren {
  AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute
  AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute
}

const AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteChildren: AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteChildren =
  {
    AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute:
      AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdReplyRouteRoute,
    AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute:
      AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdResendRouteRoute,
  }

const AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteWithChildren =
  AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute._addFileChildren(
    AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteChildren,
  )

interface AppEnterprisesEnterpriseIdEmailHistoryRouteRouteChildren {
  AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteWithChildren
}

const AppEnterprisesEnterpriseIdEmailHistoryRouteRouteChildren: AppEnterprisesEnterpriseIdEmailHistoryRouteRouteChildren =
  {
    AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRoute:
      AppEnterprisesEnterpriseIdEmailHistoryEmailEmailIdRouteRouteWithChildren,
  }

const AppEnterprisesEnterpriseIdEmailHistoryRouteRouteWithChildren =
  AppEnterprisesEnterpriseIdEmailHistoryRouteRoute._addFileChildren(
    AppEnterprisesEnterpriseIdEmailHistoryRouteRouteChildren,
  )

interface AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteChildren {
  AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute
  AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute
}

const AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteChildren: AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteChildren =
  {
    AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute:
      AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdReplyRouteRoute,
    AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute:
      AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdResendRouteRoute,
  }

const AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteWithChildren =
  AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute._addFileChildren(
    AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteChildren,
  )

interface AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteChildren {
  AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute
  AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute
}

const AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteChildren: AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteChildren =
  {
    AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute:
      AppEnterprisesEnterpriseIdTaskEmailTaskIdReplyRouteRoute,
    AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute:
      AppEnterprisesEnterpriseIdTaskEmailTaskIdResendRouteRoute,
  }

const AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteWithChildren =
  AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute._addFileChildren(
    AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteChildren,
  )

interface AppEnterprisesEnterpriseIdRouteRouteChildren {
  AppEnterprisesEnterpriseIdAddressBookRouteRoute: typeof AppEnterprisesEnterpriseIdAddressBookRouteRouteWithChildren
  AppEnterprisesEnterpriseIdCreateContactRouteRoute: typeof AppEnterprisesEnterpriseIdCreateContactRouteRoute
  AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute: typeof AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute
  AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute: typeof AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute
  AppEnterprisesEnterpriseIdDeleteRouteRoute: typeof AppEnterprisesEnterpriseIdDeleteRouteRoute
  AppEnterprisesEnterpriseIdEmailHistoryRouteRoute: typeof AppEnterprisesEnterpriseIdEmailHistoryRouteRouteWithChildren
  AppEnterprisesEnterpriseIdImportContactsRouteRoute: typeof AppEnterprisesEnterpriseIdImportContactsRouteRoute
  AppEnterprisesEnterpriseIdImportGedFilesRouteRoute: typeof AppEnterprisesEnterpriseIdImportGedFilesRouteRoute
  AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute: typeof AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute
  AppEnterprisesEnterpriseIdUpdateRouteRoute: typeof AppEnterprisesEnterpriseIdUpdateRouteRoute
  AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute: typeof AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute
  AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute: typeof AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute
  AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute: typeof AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute
  AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute: typeof AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute
  AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute: typeof AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute
  AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute: typeof AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute
  AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute: typeof AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute: typeof AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute
  AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute: typeof AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute
  AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute: typeof AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteWithChildren
  AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute: typeof AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute
  AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute: typeof AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute
  AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute: typeof AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute
  AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute: typeof AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute
}

const AppEnterprisesEnterpriseIdRouteRouteChildren: AppEnterprisesEnterpriseIdRouteRouteChildren =
  {
    AppEnterprisesEnterpriseIdAddressBookRouteRoute:
      AppEnterprisesEnterpriseIdAddressBookRouteRouteWithChildren,
    AppEnterprisesEnterpriseIdCreateContactRouteRoute:
      AppEnterprisesEnterpriseIdCreateContactRouteRoute,
    AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute:
      AppEnterprisesEnterpriseIdCreateGedDirectoryRouteRoute,
    AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute:
      AppEnterprisesEnterpriseIdCreateLifesheetCommentRouteRoute,
    AppEnterprisesEnterpriseIdDeleteRouteRoute:
      AppEnterprisesEnterpriseIdDeleteRouteRoute,
    AppEnterprisesEnterpriseIdEmailHistoryRouteRoute:
      AppEnterprisesEnterpriseIdEmailHistoryRouteRouteWithChildren,
    AppEnterprisesEnterpriseIdImportContactsRouteRoute:
      AppEnterprisesEnterpriseIdImportContactsRouteRoute,
    AppEnterprisesEnterpriseIdImportGedFilesRouteRoute:
      AppEnterprisesEnterpriseIdImportGedFilesRouteRoute,
    AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute:
      AppEnterprisesEnterpriseIdRelateBusinessRmaRouteRoute,
    AppEnterprisesEnterpriseIdUpdateRouteRoute:
      AppEnterprisesEnterpriseIdUpdateRouteRoute,
    AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute:
      AppEnterprisesEnterpriseIdUpdateAccountabilityRouteRoute,
    AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute:
      AppEnterprisesEnterpriseIdUpdateCategoryRouteRoute,
    AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute:
      AppEnterprisesEnterpriseIdUpdateRepresentativeRouteRoute,
    AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute:
      AppEnterprisesEnterpriseIdCreateContactBusinessContactIdRouteRoute,
    AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute:
      AppEnterprisesEnterpriseIdDeleteContactContactIdRouteRoute,
    AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute:
      AppEnterprisesEnterpriseIdDeleteGedObjectObjectRelativePathRouteRoute,
    AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRoute:
      AppEnterprisesEnterpriseIdLifesheetEmailLifesheetIdRouteRouteWithChildren,
    AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute:
      AppEnterprisesEnterpriseIdRenameGedObjectObjectRelativePathRouteRoute,
    AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute:
      AppEnterprisesEnterpriseIdSendEmailToContactContactIdRouteRoute,
    AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRoute:
      AppEnterprisesEnterpriseIdTaskEmailTaskIdRouteRouteWithChildren,
    AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute:
      AppEnterprisesEnterpriseIdUnlinkTaskTaskIdRouteRoute,
    AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute:
      AppEnterprisesEnterpriseIdUnrelateBusinessRmaBusinessRmaIdRouteRoute,
    AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute:
      AppEnterprisesEnterpriseIdUpdateContactPasswordContactIdRouteRoute,
    AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute:
      AppEnterprisesEnterpriseIdUpdateContactContactIdRouteRoute,
  }

const AppEnterprisesEnterpriseIdRouteRouteWithChildren =
  AppEnterprisesEnterpriseIdRouteRoute._addFileChildren(
    AppEnterprisesEnterpriseIdRouteRouteChildren,
  )

interface AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteChildren {
  AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute
  AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute
}

const AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteChildren: AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteChildren =
  {
    AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute:
      AppProductsProductIdInformationsLifesheetEmailLifesheetIdReplyRouteRoute,
    AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute:
      AppProductsProductIdInformationsLifesheetEmailLifesheetIdResendRouteRoute,
  }

const AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteWithChildren =
  AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute._addFileChildren(
    AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteChildren,
  )

interface AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteChildren {
  AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute
  AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute
}

const AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteChildren: AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteChildren =
  {
    AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute:
      AppProductsProductIdInformationsTaskEmailTaskIdReplyRouteRoute,
    AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute:
      AppProductsProductIdInformationsTaskEmailTaskIdResendRouteRoute,
  }

const AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteWithChildren =
  AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute._addFileChildren(
    AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteChildren,
  )

interface AppProductsProductIdInformationsRouteRouteChildren {
  AppProductsProductIdInformationsCreateGedDirectoryRouteRoute: typeof AppProductsProductIdInformationsCreateGedDirectoryRouteRoute
  AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute: typeof AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute
  AppProductsProductIdInformationsDeleteGedObjectRouteRoute: typeof AppProductsProductIdInformationsDeleteGedObjectRouteRoute
  AppProductsProductIdInformationsImportGedFilesRouteRoute: typeof AppProductsProductIdInformationsImportGedFilesRouteRoute
  AppProductsProductIdInformationsRenameGedObjectRouteRoute: typeof AppProductsProductIdInformationsRenameGedObjectRouteRoute
  AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute: typeof AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteWithChildren
  AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute: typeof AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteWithChildren
  AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute: typeof AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute
}

const AppProductsProductIdInformationsRouteRouteChildren: AppProductsProductIdInformationsRouteRouteChildren =
  {
    AppProductsProductIdInformationsCreateGedDirectoryRouteRoute:
      AppProductsProductIdInformationsCreateGedDirectoryRouteRoute,
    AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute:
      AppProductsProductIdInformationsCreateLifesheetCommentRouteRoute,
    AppProductsProductIdInformationsDeleteGedObjectRouteRoute:
      AppProductsProductIdInformationsDeleteGedObjectRouteRoute,
    AppProductsProductIdInformationsImportGedFilesRouteRoute:
      AppProductsProductIdInformationsImportGedFilesRouteRoute,
    AppProductsProductIdInformationsRenameGedObjectRouteRoute:
      AppProductsProductIdInformationsRenameGedObjectRouteRoute,
    AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRoute:
      AppProductsProductIdInformationsLifesheetEmailLifesheetIdRouteRouteWithChildren,
    AppProductsProductIdInformationsTaskEmailTaskIdRouteRoute:
      AppProductsProductIdInformationsTaskEmailTaskIdRouteRouteWithChildren,
    AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute:
      AppProductsProductIdInformationsUnlinkTaskTaskIdRouteRoute,
  }

const AppProductsProductIdInformationsRouteRouteWithChildren =
  AppProductsProductIdInformationsRouteRoute._addFileChildren(
    AppProductsProductIdInformationsRouteRouteChildren,
  )

interface AppProductsProductIdManageAddSpecificationRouteRouteChildren {
  AppProductsProductIdManageAddSpecificationFilterIdRouteRoute: typeof AppProductsProductIdManageAddSpecificationFilterIdRouteRoute
}

const AppProductsProductIdManageAddSpecificationRouteRouteChildren: AppProductsProductIdManageAddSpecificationRouteRouteChildren =
  {
    AppProductsProductIdManageAddSpecificationFilterIdRouteRoute:
      AppProductsProductIdManageAddSpecificationFilterIdRouteRoute,
  }

const AppProductsProductIdManageAddSpecificationRouteRouteWithChildren =
  AppProductsProductIdManageAddSpecificationRouteRoute._addFileChildren(
    AppProductsProductIdManageAddSpecificationRouteRouteChildren,
  )

interface AppProductsProductIdManageRouteRouteChildren {
  AppProductsProductIdManageAddAssociatedProductRouteRoute: typeof AppProductsProductIdManageAddAssociatedProductRouteRoute
  AppProductsProductIdManageAddNomenclatureDetailRouteRoute: typeof AppProductsProductIdManageAddNomenclatureDetailRouteRoute
  AppProductsProductIdManageAddSpecificationRouteRoute: typeof AppProductsProductIdManageAddSpecificationRouteRouteWithChildren
  AppProductsProductIdManageCreateStockRouteRoute: typeof AppProductsProductIdManageCreateStockRouteRoute
  AppProductsProductIdManageCreateVersionRouteRoute: typeof AppProductsProductIdManageCreateVersionRouteRoute
  AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute: typeof AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute
  AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute: typeof AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute
  AppProductsProductIdManageDeleteStockStockIdRouteRoute: typeof AppProductsProductIdManageDeleteStockStockIdRouteRoute
  AppProductsProductIdManageDeleteVersionVersionIdRouteRoute: typeof AppProductsProductIdManageDeleteVersionVersionIdRouteRoute
  AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute: typeof AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute
  AppProductsProductIdManageStockHistoryStockIdRouteRoute: typeof AppProductsProductIdManageStockHistoryStockIdRouteRoute
  AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute: typeof AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute
  AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute: typeof AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute
  AppProductsProductIdManageUpdateStockStockIdRouteRoute: typeof AppProductsProductIdManageUpdateStockStockIdRouteRoute
  AppProductsProductIdManageUpdateVersionVersionIdRouteRoute: typeof AppProductsProductIdManageUpdateVersionVersionIdRouteRoute
}

const AppProductsProductIdManageRouteRouteChildren: AppProductsProductIdManageRouteRouteChildren =
  {
    AppProductsProductIdManageAddAssociatedProductRouteRoute:
      AppProductsProductIdManageAddAssociatedProductRouteRoute,
    AppProductsProductIdManageAddNomenclatureDetailRouteRoute:
      AppProductsProductIdManageAddNomenclatureDetailRouteRoute,
    AppProductsProductIdManageAddSpecificationRouteRoute:
      AppProductsProductIdManageAddSpecificationRouteRouteWithChildren,
    AppProductsProductIdManageCreateStockRouteRoute:
      AppProductsProductIdManageCreateStockRouteRoute,
    AppProductsProductIdManageCreateVersionRouteRoute:
      AppProductsProductIdManageCreateVersionRouteRoute,
    AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute:
      AppProductsProductIdManageDeleteNomenclatureDetailNomenclatureDetailIdRouteRoute,
    AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute:
      AppProductsProductIdManageDeleteSpecificationSpecificationIdRouteRoute,
    AppProductsProductIdManageDeleteStockStockIdRouteRoute:
      AppProductsProductIdManageDeleteStockStockIdRouteRoute,
    AppProductsProductIdManageDeleteVersionVersionIdRouteRoute:
      AppProductsProductIdManageDeleteVersionVersionIdRouteRoute,
    AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute:
      AppProductsProductIdManageRemoveAssociatedProductAssociatedProductIdRouteRoute,
    AppProductsProductIdManageStockHistoryStockIdRouteRoute:
      AppProductsProductIdManageStockHistoryStockIdRouteRoute,
    AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute:
      AppProductsProductIdManageUpdateNomenclatureDetailNomenclatureDetailIdRouteRoute,
    AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute:
      AppProductsProductIdManageUpdateSpecificationSpecificationIdRouteRoute,
    AppProductsProductIdManageUpdateStockStockIdRouteRoute:
      AppProductsProductIdManageUpdateStockStockIdRouteRoute,
    AppProductsProductIdManageUpdateVersionVersionIdRouteRoute:
      AppProductsProductIdManageUpdateVersionVersionIdRouteRoute,
  }

const AppProductsProductIdManageRouteRouteWithChildren =
  AppProductsProductIdManageRouteRoute._addFileChildren(
    AppProductsProductIdManageRouteRouteChildren,
  )

interface AppProductsProductIdRouteRouteChildren {
  AppProductsProductIdInformationsRouteRoute: typeof AppProductsProductIdInformationsRouteRouteWithChildren
  AppProductsProductIdManageRouteRoute: typeof AppProductsProductIdManageRouteRouteWithChildren
  AppProductsProductIdIndexRoute: typeof AppProductsProductIdIndexRoute
}

const AppProductsProductIdRouteRouteChildren: AppProductsProductIdRouteRouteChildren =
  {
    AppProductsProductIdInformationsRouteRoute:
      AppProductsProductIdInformationsRouteRouteWithChildren,
    AppProductsProductIdManageRouteRoute:
      AppProductsProductIdManageRouteRouteWithChildren,
    AppProductsProductIdIndexRoute: AppProductsProductIdIndexRoute,
  }

const AppProductsProductIdRouteRouteWithChildren =
  AppProductsProductIdRouteRoute._addFileChildren(
    AppProductsProductIdRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdArcPdfSendByEmailRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdArcPdfRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdArcRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdArcPdfRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute
  AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdArcRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdArcRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdArcPdfRouteRoute:
      AppBusinessesRmaBusinessBusinessIdArcPdfRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute:
      AppBusinessesRmaBusinessBusinessIdArcUpdateShippingPriceRouteRoute,
    AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdArcDeleteDetailDetailIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdArcUpdateDetailDetailIdRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdArcRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdArcRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdArcRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBillCreditsSendByEmailRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdBillRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdBillRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdBillRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBillCreditsRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBillSendByEmailRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdBillRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdBillRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdBillRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBlUpdateNewRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdBlRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute
  AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteWithChildren
}

const AppBusinessesRmaBusinessBusinessIdBlRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdBlRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBlSendByEmailRouteRoute,
    AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBlUpdateRouteRouteWithChildren,
  }

const AppBusinessesRmaBusinessBusinessIdBlRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdBlRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdBlRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdBpRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute
  AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdBpRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdBpRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpTravelVoucherRouteRoute,
    AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpAddSerialDetailIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpCreateDetailRmaDetailIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpCreateSerialRmaSerialIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpDeleteDetailDetailIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpDeleteSerialSerialIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpUpdateDetailDetailIdRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdBpRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdBpRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdBpRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardAddressBookCreateRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardAddressBookDeleteAddressIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardAddressBookUpdateAddressIdRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdReplyRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdResendRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteWithChildren
}

const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryEmailIdRouteRouteWithChildren,
  }

const AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdReplyRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdResendRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdReplyRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdResendRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute
  AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardAddressBookRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardCreateGedDirectoryRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardCreateLifesheetRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardCreateLinkRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardDeleteRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardEmailHistoryRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardImportGedFilesRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardSendEmailRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardUpdateBillingAddressRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardUpdateRepresentativeRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardUpdateResponsibleRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardConfirmQuotationImportOtherBusinessIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardDeleteGedObjectObjectRelativePathRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardDeleteLinkAssociatedIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardLifesheetEmailLifesheetIdRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardRenameGedObjectObjectRelativePathRouteRoute,
    AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardTaskEmailTaskIdRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardUnlinkTaskTaskIdRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailPredefinedMessagesRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteWithChildren
}

const AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeSendByEmailRouteRouteWithChildren,
  }

const AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationPdfSendByEmailRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute
  AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationCommercialNoticeRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationPdfRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationUpdateShippingPriceRouteRoute,
    AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationCreateAssociatedDetailDetailIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationCreateDetailSubquotationIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationDeleteDetailDetailIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationDeleteSubquotationSubquotationIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationUpdateDetailDetailIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationUpdateSubquotationSubquotationIdRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdArcRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdArcRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdBillRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBillRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdBlRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBlRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdBpRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdBpRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdIndexRoute: typeof AppBusinessesRmaBusinessBusinessIdIndexRoute
}

const AppBusinessesRmaBusinessBusinessIdRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdArcRouteRoute:
      AppBusinessesRmaBusinessBusinessIdArcRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdBillRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBillRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdBlRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBlRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdBpRouteRoute:
      AppBusinessesRmaBusinessBusinessIdBpRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdDashboardRouteRoute:
      AppBusinessesRmaBusinessBusinessIdDashboardRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdQuotationRouteRoute:
      AppBusinessesRmaBusinessBusinessIdQuotationRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdIndexRoute:
      AppBusinessesRmaBusinessBusinessIdIndexRoute,
  }

const AppBusinessesRmaBusinessBusinessIdRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute
}

const AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteChildren: AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute:
      AppBusinessesRmaRmaRmaIdDeliveryPdfSendByEmailRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdDeliveryRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute
  AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute
  AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute
  AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute
}

const AppBusinessesRmaRmaRmaIdDeliveryRouteRouteChildren: AppBusinessesRmaRmaRmaIdDeliveryRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute:
      AppBusinessesRmaRmaRmaIdDeliveryCreateDetailRouteRoute,
    AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRoute:
      AppBusinessesRmaRmaRmaIdDeliveryPdfRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute:
      AppBusinessesRmaRmaRmaIdDeliveryTravelVoucherRouteRoute,
    AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute:
      AppBusinessesRmaRmaRmaIdDeliveryDeleteDetailDetailIdRouteRoute,
    AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute:
      AppBusinessesRmaRmaRmaIdDeliveryUpdateDetailDetailIdRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdDeliveryRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdDeliveryRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdDeliveryRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute: typeof AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute
}

const AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteChildren: AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute:
      AppBusinessesRmaRmaRmaIdReceptionPdfSendByEmailRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdReceptionPdfRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdReceptionRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute: typeof AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute
  AppBusinessesRmaRmaRmaIdReceptionPdfRouteRoute: typeof AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute
  AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute
}

const AppBusinessesRmaRmaRmaIdReceptionRouteRouteChildren: AppBusinessesRmaRmaRmaIdReceptionRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute:
      AppBusinessesRmaRmaRmaIdReceptionCreateDetailRouteRoute,
    AppBusinessesRmaRmaRmaIdReceptionPdfRouteRoute:
      AppBusinessesRmaRmaRmaIdReceptionPdfRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute:
      AppBusinessesRmaRmaRmaIdReceptionDeleteDetailDetailIdRouteRoute,
    AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute:
      AppBusinessesRmaRmaRmaIdReceptionUpdateDetailDetailIdRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdReceptionRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdReceptionRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdReceptionRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute
}

const AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteChildren: AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportPdfSendByEmailRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdSupportPdfRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute
  AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute
}

const AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteChildren: AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdReplyRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdResendRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute
  AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute
}

const AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteChildren: AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdReplyRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdResendRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdSupportRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute
  AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute
  AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute
  AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute
  AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute
  AppBusinessesRmaRmaRmaIdSupportPdfRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute
  AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute
  AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute
  AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute
  AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute
  AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute
}

const AppBusinessesRmaRmaRmaIdSupportRouteRouteChildren: AppBusinessesRmaRmaRmaIdSupportRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportCreateDetailRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportCreateGedDirectoryRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportCreateLifesheetRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportCreateLinkRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportImportGedFilesRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportPdfRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportPdfRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportDeleteDetailDetailIdRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportDeleteGedObjectRelativePathRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportDeleteLinkAssociatedIdRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportLifesheetEmailLifesheetIdRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportRenameGedObjectObjectRelativePathRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportTaskEmailTaskIdRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportUnlinkTaskTaskIdRouteRoute,
    AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportUpdateDetailDetailIdRouteRoute,
  }

const AppBusinessesRmaRmaRmaIdSupportRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdSupportRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdSupportRouteRouteChildren,
  )

interface AppBusinessesRmaRmaRmaIdRouteRouteChildren {
  AppBusinessesRmaRmaRmaIdDeliveryRouteRoute: typeof AppBusinessesRmaRmaRmaIdDeliveryRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdReceptionRouteRoute: typeof AppBusinessesRmaRmaRmaIdReceptionRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdSupportRouteRoute: typeof AppBusinessesRmaRmaRmaIdSupportRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdIndexRoute: typeof AppBusinessesRmaRmaRmaIdIndexRoute
}

const AppBusinessesRmaRmaRmaIdRouteRouteChildren: AppBusinessesRmaRmaRmaIdRouteRouteChildren =
  {
    AppBusinessesRmaRmaRmaIdDeliveryRouteRoute:
      AppBusinessesRmaRmaRmaIdDeliveryRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdReceptionRouteRoute:
      AppBusinessesRmaRmaRmaIdReceptionRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdSupportRouteRoute:
      AppBusinessesRmaRmaRmaIdSupportRouteRouteWithChildren,
    AppBusinessesRmaRmaRmaIdIndexRoute: AppBusinessesRmaRmaRmaIdIndexRoute,
  }

const AppBusinessesRmaRmaRmaIdRouteRouteWithChildren =
  AppBusinessesRmaRmaRmaIdRouteRoute._addFileChildren(
    AppBusinessesRmaRmaRmaIdRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdStudyRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute
  AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute
  AppBusinessesRmaBusinessBusinessIdStudyIndexRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyIndexRoute
}

const AppBusinessesRmaBusinessBusinessIdStudyRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdStudyRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute:
      AppBusinessesRmaBusinessBusinessIdStudyAutomaticRouteRoute,
    AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute:
      AppBusinessesRmaBusinessBusinessIdStudyExpertRouteRoute,
    AppBusinessesRmaBusinessBusinessIdStudyIndexRoute:
      AppBusinessesRmaBusinessBusinessIdStudyIndexRoute,
  }

const AppBusinessesRmaBusinessBusinessIdStudyRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdStudyRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdStudyRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfSendByEmailRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdReplyRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdResendRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteChildren,
  )

interface AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteChildren {
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute
}

const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteChildren: AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteChildren =
  {
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateFaqRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateGedDirectoryRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLifesheetRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdCreateLinkRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditCumulatedTimeRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditNoBilledTimeRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdEditSubtitleRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdImportGedFilesRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdPdfRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteGedObjectObjectRelativePathRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdDeleteLinkAssociatedIdRouteRoute,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdLifesheetEmailLifesheetIdRouteRouteWithChildren,
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute:
      AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRenameGedObjectObjectRelativePathRouteRoute,
  }

const AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteWithChildren =
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute._addFileChildren(
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppBusinessesRmaRouteRoute: typeof AppBusinessesRmaRouteRouteWithChildren
  AppDashboardRouteRoute: typeof AppDashboardRouteRouteWithChildren
  AppEnterprisesRouteRoute: typeof AppEnterprisesRouteRouteWithChildren
  AppExternalLinksRouteRoute: typeof AppExternalLinksRouteRoute
  AppFaqRouteRoute: typeof AppFaqRouteRouteWithChildren
  AppProductsRouteRoute: typeof AppProductsRouteRouteWithChildren
  AppToolsRouteRoute: typeof AppToolsRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppEnterprisesEnterpriseIdRouteRoute: typeof AppEnterprisesEnterpriseIdRouteRouteWithChildren
  AppExternalLinksExternalLinkIdRouteRoute: typeof AppExternalLinksExternalLinkIdRouteRoute
  AppProductsProductIdRouteRoute: typeof AppProductsProductIdRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdRouteRouteWithChildren
  AppBusinessesRmaRmaRmaIdRouteRoute: typeof AppBusinessesRmaRmaRmaIdRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdStudyRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdStudyRouteRouteWithChildren
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute: typeof AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppBusinessesRmaRouteRoute: AppBusinessesRmaRouteRouteWithChildren,
  AppDashboardRouteRoute: AppDashboardRouteRouteWithChildren,
  AppEnterprisesRouteRoute: AppEnterprisesRouteRouteWithChildren,
  AppExternalLinksRouteRoute: AppExternalLinksRouteRoute,
  AppFaqRouteRoute: AppFaqRouteRouteWithChildren,
  AppProductsRouteRoute: AppProductsRouteRouteWithChildren,
  AppToolsRouteRoute: AppToolsRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppEnterprisesEnterpriseIdRouteRoute:
    AppEnterprisesEnterpriseIdRouteRouteWithChildren,
  AppExternalLinksExternalLinkIdRouteRoute:
    AppExternalLinksExternalLinkIdRouteRoute,
  AppProductsProductIdRouteRoute: AppProductsProductIdRouteRouteWithChildren,
  AppBusinessesRmaBusinessBusinessIdRouteRoute:
    AppBusinessesRmaBusinessBusinessIdRouteRouteWithChildren,
  AppBusinessesRmaRmaRmaIdRouteRoute:
    AppBusinessesRmaRmaRmaIdRouteRouteWithChildren,
  AppBusinessesRmaBusinessBusinessIdStudyRouteRoute:
    AppBusinessesRmaBusinessBusinessIdStudyRouteRouteWithChildren,
  AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRoute:
    AppBusinessesRmaBusinessBusinessIdAssistanceAssistanceIdRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthLoginRouteRoute: typeof AuthLoginRouteRoute
  AuthForgotPasswordRouteLazyRoute: typeof AuthForgotPasswordRouteLazyRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthResetPasswordTokenRouteLazyRoute: typeof AuthResetPasswordTokenRouteLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRouteRoute: AuthLoginRouteRoute,
  AuthForgotPasswordRouteLazyRoute: AuthForgotPasswordRouteLazyRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthResetPasswordTokenRouteLazyRoute: AuthResetPasswordTokenRouteLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
